// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3sHWr":[function(require,module,exports) {
require("2b6d5ead678b4549").register(require("4532326affbb838e").getBundleURL("c4cLN"), JSON.parse('["c4cLN","index.js","kMKFg","jose.cc54f90f.js","dVcvk","LoginWallOverlay.mh.426d1b93.js","7SBQa","LoginWallOverlay.nb.907aedaa.js","kNLVx","LoginWallOverlay.gva.f0c1a140.js","6nVKT","LoginWallOverlay.hbvl.eebbebe2.js","14QDh","LoginWallOverlay.ds.ae113db5.js","2zjTs","LoginWallOverlay.dl.9b887948.js","iOSSR","LoginWallOverlay.nhd.522bf830.js","jdd4K","LoginWallOverlay.ge.d3dcf050.js","e0Rep","LoginWallOverlay.yc.a384c4a6.js","QdmLN","LoginWallOverlay.hd.bcd0417d.js","jqHnS","LoginWallOverlay.ld.ba2c5308.js","95IVm","LoginWallOverlay.az.4fcebfb2.js","j5vQM","LoginWall.mh.74a69233.js","kuwyQ","LoginWall.nb.c8d55374.js","hpmJK","LoginWall.gva.79fb2dab.js","75rVb","LoginWall.hbvl.72a6953a.js","jvVie","LoginWall.ds.3ff9da3d.js","1Rec2","LoginWall.dl.401772ca.js","eP5WB","LoginWall.nhd.9aad8e83.js","cSUAJ","LoginWall.ge.a70638c8.js","ktfFT","LoginWall.yc.aac292fe.js","6vrJm","LoginWall.hd.6838addc.js","ahuud","LoginWall.ld.cb52e29f.js","ju3C7","LoginWall.az.0792f020.js","8TPB0","IdentityWallOverlay.mh.f0df3540.js","dKktD","IdentityWallOverlay.nb.4951d3fa.js","1nR1M","IdentityWallOverlay.gva.67574a3e.js","aJj8f","IdentityWallOverlay.hbvl.c7ad1980.js","k2nJc","IdentityWallOverlay.ds.0ce84b0a.js","5hQ26","IdentityWallOverlay.dl.1ffe5a88.js","20EWj","IdentityWallOverlay.nhd.5a438fcb.js","257xd","IdentityWallOverlay.ge.ce08b5ae.js","5YLOB","IdentityWallOverlay.yc.cde6835b.js","clg2W","IdentityWallOverlay.hd.5b2a3b27.js","cYyjx","IdentityWallOverlay.ld.bf51ec5d.js","hQARm","IdentityWallOverlay.az.52860d0d.js","4c16t","IdentityWall.mh.c62110cc.js","2W8Qq","IdentityWall.nb.2ef56700.js","gia0u","IdentityWall.gva.fc67bc6f.js","7v639","IdentityWall.hbvl.d3850f4b.js","OfjZN","IdentityWall.ds.99eeb46c.js","jNzC2","IdentityWall.dl.c2bbc2bc.js","3UHWR","IdentityWall.nhd.07723b7a.js","5JGOU","IdentityWall.ge.dd2b6e0c.js","cqhLa","IdentityWall.yc.f938690d.js","7cQwd","IdentityWall.hd.8d4eb9bb.js","lEVfn","IdentityWall.ld.b62e4226.js","dmlb4","IdentityWall.az.1ec2b4d9.js","ajzeL","EmailConfirmationWall.mh.1b12527a.js","3muPS","EmailConfirmationWall.nb.ff0748d1.js","cTJLt","EmailConfirmationWall.gva.2bfe0d3c.js","llb2B","EmailConfirmationWall.hbvl.06bbd80e.js","lKOLb","EmailConfirmationWall.ds.7b0a2deb.js","5RqXX","EmailConfirmationWall.dl.3a96210f.js","QEpwI","EmailConfirmationWall.nhd.248a5251.js","ef0Jm","EmailConfirmationWall.ge.85cdcbb2.js","de8wm","EmailConfirmationWall.yc.2745b35d.js","7s5QD","EmailConfirmationWall.hd.ef4a1e46.js","91Lro","EmailConfirmationWall.ld.9f18ed67.js","ho7rd","EmailConfirmationWall.az.f753284b.js","aZzFr","NotificationToast.mh.8bb40f12.js","4SbtD","NotificationToast.nb.4f3a77c8.js","f4SOf","NotificationToast.gva.04fee228.js","hBDBK","NotificationToast.hbvl.9ad95a59.js","2o74t","NotificationToast.ds.fc6d7a41.js","5ZRJS","NotificationToast.dl.722130e5.js","8C1BM","NotificationToast.nhd.e7f4603d.js","9otOP","NotificationToast.ge.1498befc.js","CUJ9S","NotificationToast.yc.45404df4.js","7SGkM","NotificationToast.hd.8bd94ebd.js","3Eoqt","NotificationToast.ld.ae79dc28.js","dzqic","NotificationToast.az.7a51ecb5.js"]'));

},{"2b6d5ead678b4549":"fyJL2","4532326affbb838e":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"8RSWf":[function(require,module,exports) {
var _auth0Sdk = require("./auth0-sdk");
var _featureFlags = require("./modules/feature-flags");
(()=>{
    const queue = window.CIAM || [];
    window.CIAM = {
        push: (fn)=>{
            fn();
        },
        getIdToken: (0, _auth0Sdk.getIdToken),
        getAccessToken: (0, _auth0Sdk.getAccessToken),
        getUserInfo: (0, _auth0Sdk.getUserInfo),
        getFullUserProfile: (0, _auth0Sdk.getFullUserProfile),
        getDecodedIdToken: (0, _auth0Sdk.getDecodedIdToken),
        getDecodedAccessToken: (0, _auth0Sdk.getDecodedAccessToken),
        refreshAccessToken: (0, _auth0Sdk.refreshAccessToken),
        isAuthenticated: (0, _auth0Sdk.isAuthenticated),
        isEmailVerified: (0, _auth0Sdk.isEmailVerified),
        showEmailConfirmation: (0, _auth0Sdk.showEmailConfirmation),
        showLoginWall: (0, _auth0Sdk.showLoginWall),
        showIdentityWall: (0, _auth0Sdk.showIdentityWall),
        showSilentLoginNotification: (0, _auth0Sdk.showSilentLoginNotification),
        sendEmailVerification: (0, _auth0Sdk.sendEmailVerification),
        getUserSubscriptions: (0, _auth0Sdk.getUserSubscriptions),
        getLoginUrl: (0, _auth0Sdk.getLoginUrl),
        getRegisterUrl: (0, _auth0Sdk.getRegisterUrl),
        getConfig: (0, _auth0Sdk.getConfig),
        hasIdentityLevel: (0, _auth0Sdk.hasIdentityLevel),
        initializeSessionManager: (0, _auth0Sdk.initializeSessionManager),
        on: (0, _auth0Sdk.on),
        off: (0, _auth0Sdk.off)
    };
    (0, _featureFlags.initFeatureFlags)().then((_)=>{}).catch((_)=>console.error("SDK feature flags failed to initialize")).finally(()=>{
        if (Array.isArray(queue)) queue.forEach((fn)=>fn());
    });
    if (window?.location?.search?.includes("_sl=")) {
        const searchParams = new URLSearchParams(window.location.search);
        if (!document.getElementById("auth0_silent-login-root")) {
            var doc = document.createElement("div");
            doc.id = "auth0_silent-login-root";
            document.body.appendChild(doc);
        }
        (0, _auth0Sdk.showSilentLoginNotification)({
            clientId: searchParams.get("_sl"),
            el: document.getElementById("auth0_silent-login-root"),
            language: searchParams.get("_sl_ui_locales") || "nl"
        });
    }
    if (window?.location?.search?.includes("force_sl=1")) {
        const parsedUrl = new URL(window.location.href);
        parsedUrl.searchParams.delete("force_sl");
        window.history.replaceState(history.state, undefined, parsedUrl.toString());
    }
})();

},{"./auth0-sdk":"3ELjX","./modules/feature-flags":"3g2JG"}],"3ELjX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get the client configuration from cookies.
 *
 * @param clientId Auth0 client id
 * @returns {Config}
 */ parcelHelpers.export(exports, "getConfig", ()=>getConfig);
/**
 * Get the access token of a logged in user. Useful when you need to send this token to a backend service from the client.
 *
 * @param clientId Auth0 client id
 * @returns Access token or null
 */ parcelHelpers.export(exports, "getAccessToken", ()=>getAccessToken);
/**
 * Returns all subscribed access claims.
 *
 * @param clientId Auth0 client id
 * @returns The list of claims
 */ parcelHelpers.export(exports, "getUserSubscriptions", ()=>getUserSubscriptions);
/**
 * Returns the access token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed access token or null
 */ parcelHelpers.export(exports, "getDecodedAccessToken", ()=>getDecodedAccessToken);
/**
 * Retrieve the raw id token of a logged in user. If you're looking to extract this infomration you can simply use the `getUserInfo` function instead.
 *
 * @param clientId Auth0 client id
 * @returns Raw JWT id token or null
 */ parcelHelpers.export(exports, "getIdToken", ()=>getIdToken);
/**
 * Returns the id token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed id token or null
 */ parcelHelpers.export(exports, "getDecodedIdToken", ()=>getDecodedIdToken);
/**
 * Returns the id token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed id token or null
 */ parcelHelpers.export(exports, "getUserInfo", ()=>getUserInfo);
/**
 * Returns the id token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed id token or null
 */ parcelHelpers.export(exports, "getFullUserProfile", ()=>getFullUserProfile);
/**
 * Refreshes the access token of a logged in user.
 *
 * @param clientId Auth0 client id
 * @returns True if the token was succesfully refreshed, false otherwise
 */ parcelHelpers.export(exports, "refreshAccessToken", ()=>refreshAccessToken);
/**
 * Attach a listener to an event.
 *
 * @param clientId Auth0 client id
 * @param event the name of the event to listen to
 * @param callback your callback function
 */ parcelHelpers.export(exports, "on", ()=>on);
/**
 * Detach a listener to an event.
 *
 * @param clientId Auth0 client id
 * @param event the name of the event to listen to
 * @param callback your callback function
 */ parcelHelpers.export(exports, "off", ()=>off);
/**
 * Is the user authenticated?
 *
 * @param clientId Auth0 client id
 * @returns True if the user is authenticated, false otherwise
 */ parcelHelpers.export(exports, "isAuthenticated", ()=>isAuthenticated);
/**
 * Is the email verified?
 *
 * @param clientId Auth0 client id
 * @returns True if the email is verified, false otherwise
 */ parcelHelpers.export(exports, "isEmailVerified", ()=>isEmailVerified);
parcelHelpers.export(exports, "hasIdentityLevel", ()=>hasIdentityLevel);
parcelHelpers.export(exports, "sendEmailVerification", ()=>sendEmailVerification);
/**
 * When not loggedin show login wall.
 * showLoginWall let you put our shared component based on the Mediahuis design system in your page.
 *
 * @param options The list of options to pass to the popup
 * @param options.type The type of email confirmation to show
 * @param options.loginIdentityLevel The identity level to login
 * @param options.registerIdentityLevel The identity level to register
 * @param options.el The DOM element to render the email confirmation in
 * @param options.slots.title Custom title for login wall
 * @param options.slots.content Custom content for login wall
 * @param options.slots.callToAction Custom call to action for login wall
 * @param options.onTrackEvent Function to track events
 * @returns
 */ parcelHelpers.export(exports, "showLoginWall", ()=>showLoginWall);
/**
 * Some brands require a specific identity level before reading any metered or plus articles.
 * showIdentityWall let you put our shared component based on the Mediahuis design system in your page.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.type The type of email confirmation to show
 * @param options.requiredIdentityLevel The identity level to progress
 * @param options.el The DOM element to render the email confirmation in
 * @param options.slots.title Custom title for login wall
 * @param options.slots.content Custom content for login wall
 * @param options.slots.callToAction Custom call to action for login wall
 * @param options.onTrackEvent Function to track events
 * @param options.options["ext-internal"] Internal tracking parameter
 * @returns
 */ parcelHelpers.export(exports, "showIdentityWall", ()=>showIdentityWall);
/**
 * Some brands require a specific identity to be show  before reading any metered or plus articles.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.type The type of email confirmation to show
 * @param options.el The DOM element to render the email confirmation in
 * @param options.onTrackEvent Function to track events
 * @returns
 */ parcelHelpers.export(exports, "showEmailConfirmation", ()=>showEmailConfirmation);
/**
 * If you want to control when to show the silent login popup.
 *
 * Note that we're using the Mediahuis design system to create these popups.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.el The DOM element to render the silent login notification in
 * @returns
 */ parcelHelpers.export(exports, "showSilentLoginNotification", ()=>showSilentLoginNotification);
parcelHelpers.export(exports, "Language", ()=>Language);
/**
 * Constructs the login URL with the specified parameters.
 *
 * @param clientId - The Auth0 client id.
 * @param identityLevel The identity level options required for login and registration.
 * @param identityLevel.loginIdentity The identity level required for login.
 * @param identityLevel.registerIdentity The identity level required for registration.
 * @param options - General options for constructing the URL.
 * @param options.skipEmailVerification - Whether to skip email verification. Defaults to false.
 * @param options.connection - The name of the social connection (e.g., 'mh-google-social' for Google).
 * @param options.returnTo - The URL to redirect to after login. Defaults to the current window location.
 * @param options.brand - The brand according to which CIAM should behave. !Only use if your client has to support multiple "brands", else configure this through the client config.
 * @param options.language - The language to be used by authentication screens. If not provided, default configured in cloudflare worker is used
 * @param tracking - Tracking options for analytics purposes.
 * @param tracking.articleId - Article ID for tracking.
 * @param tracking.prsid - PRS ID for tracking.
 * @param tracking.cid - CID for tracking.
 * @param tracking.internal - Internal tracking parameter.
 * @returns A promise that resolves to the constructed login URL as a string.
 */ parcelHelpers.export(exports, "getLoginUrl", ()=>getLoginUrl);
/**
 * Constructs the register URL with the specified parameters.
 *
 * @param clientId - The Auth0 client id.
 * @param identityLevel The identity level options required for login and registration.
 * @param identityLevel.loginIdentity The identity level required for login.
 * @param identityLevel.registerIdentity The identity level required for registration.
 * @param options - General options for constructing the URL.
 * @param options.skipEmailVerification - Whether to skip email verification. Defaults to false.
 * @param options.connection - The name of the social connection (e.g., 'mh-google-social' for Google).
 * @param options.returnTo - The URL to redirect to after registration. Defaults to the current window location.
 * @param options.brand The brand according to which CIAM should behave. !Only use if your client has to support multiple "brands", else configure this through the client config.
 * @param options.language The language to be used by authentication screens. If not provided, default configured in cloudflare worker is used
 * @param tracking - Tracking options for analytics purposes.
 * @param tracking.articleId - Article ID for tracking.
 * @param tracking.prsid - PRS ID for tracking.
 * @param tracking.cid - CID for tracking.
 * @param tracking.internal - Internal tracking parameter.
 * @returns A promise that resolves to the constructed register URL as a string.
 */ parcelHelpers.export(exports, "getRegisterUrl", ()=>getRegisterUrl);
/**
 * Initialize and connect to the global session manager.
 * @param clientId The clientID of the application
 * @param callbacks Optional callback functions for session events
 * @returns Promise<SessionManager>
 */ parcelHelpers.export(exports, "initializeSessionManager", ()=>initializeSessionManager);
var _cookie = require("./modules/cookie");
var _emitter = require("./utils/emitter");
var _pageVisibilityListener = require("./utils/pageVisibilityListener");
var _sessionManager = require("./modules/session-manager/SessionManager");
function getConfig(clientId) {
    const cookieValue = (0, _cookie.getCookie)(`${clientId}_config`);
    if (!cookieValue) throw new Error(`No config found for client id: ${clientId}`);
    const params = new URLSearchParams(cookieValue);
    return Array.from(params.entries()).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
function getAccessToken(clientId) {
    return (0, _cookie.getCookie)(`${clientId}_acc_token`);
}
async function getUserSubscriptions(clientId) {
    const decodedAccessToken = await getDecodedAccessToken(clientId);
    return decodedAccessToken?.["https://mediahuis.com/subscribed-accesses"] ?? [];
}
async function getDecodedAccessToken(clientId) {
    return (0, _cookie.extractToken)(`${clientId}_acc_token`);
}
function getIdToken(clientId) {
    return (0, _cookie.getCookie)(`${clientId}_id_token`);
}
async function getDecodedIdToken(clientId) {
    return (0, _cookie.extractToken)(`${clientId}_id_token`);
}
async function getUserInfo(clientId) {
    return getDecodedIdToken(clientId);
}
async function getFullUserProfile(clientId) {
    if (!isAuthenticated(clientId)) return null;
    const accessToken = await getDecodedAccessToken(clientId);
    const config = getConfig(clientId);
    let domain = `https://identity-management.mediahuis.com`;
    if (config.env === "test") domain = `https://identity-management-tst.mediahuis.com`;
    else if (config.env === "preview" || config.env === "staging") domain = `https://identity-management-uat.mediahuis.com`;
    else if (config.env === "dev") domain = `https://identity-management-dev.mediahuis.com`;
    const url = new URL(`/api/identities/${accessToken.sub}`, domain);
    const response = await fetch(url, {
        headers: {
            authorization: `Bearer ${getAccessToken(clientId)}`
        }
    });
    if (!response.ok) return null;
    return response.json();
}
async function refreshAccessToken(clientId) {
    const basePath = getBasePath(clientId);
    try {
        const response = await fetch(`${basePath}/auth/refresh`, {
            method: "POST"
        });
        if (!response.ok) return false;
        const { ok } = await response.json();
        return ok;
    } catch (_err) {
        return false;
    }
}
function on(clientId, event, callback) {
    // if someone is listening we can capture the clientId and start listening for expired tokens
    let isUserAuthenticated = isAuthenticated(clientId);
    let currentAccessToken = getAccessToken(clientId);
    (0, _pageVisibilityListener.registerPageVisibilityListener)(async (isVisible)=>{
        if (isVisible) {
            if (isUserAuthenticated) {
                // still authenticated but access token has changed
                if (isAuthenticated(clientId) && currentAccessToken !== getAccessToken(clientId)) {
                    (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_changed", clientId));
                    currentAccessToken = getAccessToken(clientId);
                    return;
                }
                const accessToken = await getDecodedAccessToken(clientId);
                // if expired
                if (!isAuthenticated(clientId) || accessToken?.exp * 1000 <= Date.now()) {
                    const isRefreshed = await refreshAccessToken(clientId);
                    isUserAuthenticated = isAuthenticated(clientId);
                    if (isRefreshed) {
                        currentAccessToken = getAccessToken(clientId);
                        (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_changed", clientId));
                    } else (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_expired", clientId));
                }
            } else if (isAuthenticated(clientId)) {
                (0, _emitter.getEmitter)().emit((0, _emitter.generateEventName)("auth:session_changed", clientId));
                currentAccessToken = getAccessToken(clientId);
                isUserAuthenticated = true;
            }
        }
    });
    (0, _emitter.getEmitter)().on((0, _emitter.generateEventName)(event, clientId), callback);
}
function off(clientId, event, callback) {
    (0, _emitter.getEmitter)().off((0, _emitter.generateEventName)(event, clientId), callback);
}
function isAuthenticated(clientId) {
    return !!getAccessToken(clientId) && !!getIdToken(clientId);
}
async function isEmailVerified(clientId) {
    const userInfo = await getUserInfo(clientId);
    if (!userInfo) return false;
    return userInfo.email_verified;
}
function getBasePath(clientId) {
    const config = getConfig(clientId);
    return config.prefix === "/" ? "" : config.prefix;
}
async function hasIdentityLevel(clientId, identityLevel) {
    const accessToken = await getDecodedAccessToken(clientId);
    return accessToken["https://mediahuis.com/identity-levels"]?.includes(identityLevel) ?? false;
}
async function sendEmailVerification(clientId) {
    const userInfo = await getDecodedIdToken(clientId);
    if (userInfo.email_verified) return false;
    const basePath = getBasePath(clientId);
    const verifyEmailUrl = new URL(`${basePath}/auth/verify-email`, window.location.origin);
    verifyEmailUrl.searchParams.append("accountId", userInfo.sub);
    try {
        const resp = await fetch(verifyEmailUrl, {
            headers: {
                authorization: "Bearer " + getAccessToken(clientId)
            }
        });
        return resp.ok;
    } catch (err) {
        return false;
    }
}
async function showLoginWall({ type, clientId, loginIdentityLevel, registerIdentityLevel, el, slots = {}, options, onTrackEvent }) {
    if (![
        "paywall",
        "inline",
        "overlay"
    ].includes(type)) throw new Error(`Unsupported type: ${type}, only paywall, inline or overlay is currently implemented.`);
    if (!el) throw new Error(`No element provided to render the identity wall in.`);
    if (isAuthenticated(clientId)) throw new Error(`User is authenticated.`);
    const config = getConfig(clientId);
    if (type === "overlay") {
        const { appendLoginWall } = await {
            mh: require("b06c8d5be285011"),
            nb: require("5ac405ed98c2874"),
            gva: require("86bd40b823258e10"),
            hbvl: require("608b9e7d2265d564"),
            ds: require("36ca43390b8f1de1"),
            dl: require("829253ae9520c44e"),
            nhd: require("a1ce44bb447c1e5c"),
            ge: require("954a1db98e5fa7e6"),
            yc: require("b8efff27cdb738b9"),
            hd: require("4e93fe45cae499c3"),
            ld: require("4fec8f51eee82732"),
            az: require("e5e29ee09258f6d2")
        }[config.brand];
        return appendLoginWall(el, {
            requiredLoginIdentityLevel: loginIdentityLevel,
            requiredRegisterIdentityLevel: registerIdentityLevel,
            brand: config.brand,
            slots,
            onTrackEvent,
            options
        });
    } else {
        const { appendLoginWall } = await {
            mh: require("4e8a5a660078958f"),
            nb: require("e4d298e589efe723"),
            gva: require("e2de46407845cc49"),
            hbvl: require("499927e8f43c1aad"),
            ds: require("35e616265ef4c7d0"),
            dl: require("3d6377345c774070"),
            nhd: require("2fc7e88eece64"),
            ge: require("eb4308b3d411355b"),
            yc: require("4d75e431d996a7bd"),
            hd: require("4b92afc2e15227b9"),
            ld: require("b9c4edeb7343e9e8"),
            az: require("e18a4dc2350432f0")
        }[config.brand];
        return appendLoginWall(el, {
            requiredLoginIdentityLevel: loginIdentityLevel,
            requiredRegisterIdentityLevel: registerIdentityLevel,
            brand: config.brand,
            clientId,
            slots,
            onTrackEvent,
            options
        });
    }
}
async function showIdentityWall({ type, clientId, identityLevel, el, slots = {}, onTrackEvent, options }) {
    // if (type !== 'paywall') {
    // 	throw new Error(`Unsupported type: ${type}, only paywall is currently implemented.`);
    // }
    if (!el) throw new Error(`No element provided to render the identity wall in.`);
    if (!isAuthenticated(clientId)) throw new Error(`User is not authenticated.`);
    const config = getConfig(clientId);
    if (type === "overlay") {
        const { appendIdentityWall } = await {
            mh: require("f211afece82b3372"),
            nb: require("ece490d262e1340f"),
            gva: require("73b901db05e69ad"),
            hbvl: require("4a3494a78a34542f"),
            ds: require("4213ded863b24215"),
            dl: require("77cd712826b3c5c1"),
            nhd: require("8369d2fe790f6f32"),
            ge: require("7b647a799ced2cd9"),
            yc: require("afa5dd078f90f551"),
            hd: require("e178446f0c3aeff9"),
            ld: require("d34beff9be5506c5"),
            az: require("b71d8201890fd61e")
        }[config.brand];
        return appendIdentityWall(el, {
            requiredIdentityLevel: identityLevel,
            brand: config.brand,
            clientId,
            slots,
            onTrackEvent,
            options
        });
    } else {
        const { appendIdentityWall } = await {
            mh: require("f01685cdd1dfb443"),
            nb: require("75abb72238cc4dee"),
            gva: require("4bca765fce46af51"),
            hbvl: require("e594674c719ab553"),
            ds: require("789801a03e5e140e"),
            dl: require("572244af4c80585b"),
            nhd: require("da9961e0ff4d5c35"),
            ge: require("3ca91b97cffb0761"),
            yc: require("4cdf562db955f7ba"),
            hd: require("74ba864ba7b089c9"),
            ld: require("b33b77412b0b3faa"),
            az: require("10a88c3c1fc31c46")
        }[config.brand];
        return appendIdentityWall(el, {
            requiredIdentityLevel: identityLevel,
            brand: config.brand,
            clientId,
            slots,
            onTrackEvent,
            options
        });
    }
}
async function showEmailConfirmation({ type, clientId, el, onTrackEvent }) {
    if (type !== "paywall" && type !== "inline") throw new Error(`Unsupported type: ${type}, only paywall or inline is currently implemented.`);
    if (!isAuthenticated(clientId)) throw new Error(`User is not authenticated.`);
    if (!el) throw new Error(`No element provided to render the email confirmation box in.`);
    const userInfo = await getDecodedIdToken(clientId);
    if (userInfo.email_verified) throw new Error(`User has already been verified.`);
    const config = getConfig(clientId);
    const { appendEmailVerificationWall } = await {
        mh: require("f302053403f46072"),
        nb: require("cf77df45f5c63fa8"),
        gva: require("e2d034d075638bd3"),
        hbvl: require("8b5901e6485a7c11"),
        ds: require("74334ec3b2e4a30"),
        dl: require("484b45870643fb"),
        nhd: require("dc544af4e7bfc5ba"),
        ge: require("28fbd7aa9405e905"),
        yc: require("680c4bc6217b9430"),
        hd: require("c79b001df3a1cd4e"),
        ld: require("d79ec99ca5a32e31"),
        az: require("e474b29626606e42")
    }[config.brand];
    return appendEmailVerificationWall(el, {
        email: userInfo.email,
        brand: config.brand,
        clientId,
        onTrackEvent
    });
}
async function showSilentLoginNotification({ clientId, el, language }) {
    const parsedUrl = new URL(window.location.href);
    parsedUrl.searchParams.delete("_sl");
    parsedUrl.searchParams.delete("_sl_ui_locales");
    window.history.replaceState(history.state, undefined, parsedUrl.toString());
    const userInfo = await getUserInfo(clientId);
    if (!userInfo.email) return;
    if (!el) throw new Error(`No element provided to render the silent login toast in.`);
    const { appendNotificationToast } = await {
        mh: require("481b112c9d50f416"),
        nb: require("aa52a3fca85317ac"),
        gva: require("9d13c54cd4c0ebd9"),
        hbvl: require("bd86f32227ae71d4"),
        ds: require("3338b7bea32464df"),
        dl: require("5f80b6be8de0b1f0"),
        nhd: require("7a92099a245c93b4"),
        ge: require("238231a235630333"),
        yc: require("eaa27e934c937fe3"),
        hd: require("438404de06674214"),
        ld: require("b0c5f264b41b18fa"),
        az: require("3d0186b691b7fdc0")
    }["mh"];
    Object.assign(el.style, {
        position: "fixed",
        zIndex: "9999",
        top: 0,
        right: 0
    });
    const config = getConfig(clientId);
    await appendNotificationToast(el, {
        email: userInfo.email,
        brand: config.brand,
        language
    });
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
var Language;
(function(Language) {
    Language["NL"] = "nl";
    Language["FR"] = "fr-FR";
    Language["DE"] = "de";
    Language["EN"] = "en";
    Language["PT"] = "pt-PT";
})(Language || (Language = {}));
async function getLoginUrl({ clientId, identityLevel, options, tracking }) {
    return await buildUrl({
        identityLevel: identityLevel,
        options: options,
        tracking: tracking,
        clientId: clientId,
        authType: "login"
    });
}
async function getRegisterUrl({ clientId, identityLevel, options, tracking }) {
    return await buildUrl({
        identityLevel: identityLevel,
        options: options,
        tracking: tracking,
        clientId: clientId,
        authType: "register"
    });
}
/**
 * Constructs a URL with the specified parameters for either login or registration.
 *
 * @param searchParams - The URL search parameters to be appended.
 * @param options - General options for constructing the URL.
 * @param options.skipEmailVerification - Whether to skip email verification. Defaults to false.
 * @param options.connection - The name of the social connection (e.g., 'mh-google-social' for Google).
 * @param options.returnTo - The URL to redirect to after the operation. Defaults to the current window location.
 * @param options.brand - The brand according to which CIAM should behave. !Only use if your client has to support multiple "brands", else configure this through the client config.
 * @param options.language - The language to be used by authentication screens. If not provided, default configured in ??? is used
 * @param tracking - Tracking options for analytics purposes.
 * @param tracking.articleId - Article ID for tracking.
 * @param tracking.prsid - PRS ID for tracking.
 * @param tracking.cid - CID for tracking.
 * @param tracking.internal - Internal tracking parameter.
 * @param clientId - The Auth0 client id.
 * @param authType - The type of authentication ('login' or 'register').
 * @returns A promise that resolves to the constructed URL as a string.
 */ async function buildUrl({ identityLevel, options: { skipEmailVerification = false, connection, returnTo = window.location.href, brand, language }, tracking, clientId, authType }) {
    const searchParams = new URLSearchParams();
    const config = getConfig(clientId);
    if (identityLevel.loginIdentity) searchParams.append("login_identity_level", identityLevel.loginIdentity);
    if (identityLevel.registerIdentity) searchParams.append("register_identity_level", identityLevel.registerIdentity);
    searchParams.append("skip_email_verification", skipEmailVerification ? "1" : "0");
    if (connection) searchParams.append("connection", connection);
    if (returnTo) searchParams.append("returnTo", returnTo);
    if (tracking.prsid) searchParams.append("ext-prsid", tracking.prsid);
    if (tracking.cid) searchParams.append("ext-cid", tracking.cid);
    if (tracking.internal) searchParams.append("ext-internal", tracking.internal);
    if (tracking.articleId) searchParams.append("ext-articleId", tracking.articleId);
    if (language) searchParams.append("ui_locales", language);
    if (brand) searchParams.append("ext-brand", brand);
    let prefix = config.prefix ? config.prefix : "/";
    if (!prefix.endsWith("/")) prefix += "/";
    const resultUrl = new URL(`${window.location.origin}${prefix}auth/${authType}`);
    resultUrl.search = searchParams.toString();
    return resultUrl.toString();
}
let globalSessionManager = null;
async function initializeSessionManager(clientId, callbacks) {
    const config = getConfig(clientId);
    let sessionManagerEndpoint = "session-management.mediahuis.com";
    if (config.env === "dev") sessionManagerEndpoint = "session-management-dev.mediahuis.com";
    else if (config.env === "test") sessionManagerEndpoint = "session-management-tst.mediahuis.com";
    else if (config.env === "preview" || config.env === "staging") sessionManagerEndpoint = "session-management-uat.mediahuis.com";
    if (!globalSessionManager) globalSessionManager = new (0, _sessionManager.SessionManager)({
        sessionManagerEndpoint,
        clientId
    });
    if (callbacks?.onSessionBlocked) (0, _emitter.getEmitter)().on("session:blocked", callbacks.onSessionBlocked);
    if (callbacks?.onSessionUnblocked) (0, _emitter.getEmitter)().on("session:unblocked", callbacks.onSessionUnblocked);
    (0, _emitter.getEmitter)().on((0, _emitter.generateEventName)("auth:session_changed", clientId), async ()=>{
        await globalSessionManager.shutdown();
        globalSessionManager = new (0, _sessionManager.SessionManager)({
            sessionManagerEndpoint,
            clientId
        });
        await globalSessionManager.connect();
    });
    (0, _emitter.getEmitter)().on((0, _emitter.generateEventName)("auth:session_expired", clientId), async ()=>{
        await globalSessionManager.shutdown();
    });
    await globalSessionManager.connect();
    return globalSessionManager;
}

},{"./modules/cookie":"lK6AJ","./utils/emitter":"icruC","./utils/pageVisibilityListener":"3T4Bn","./modules/session-manager/SessionManager":"39Y4V","b06c8d5be285011":"gKyNT","5ac405ed98c2874":"a1Sgr","86bd40b823258e10":"6WxCn","608b9e7d2265d564":"8SJmv","36ca43390b8f1de1":"2J4qA","829253ae9520c44e":"8dMQO","a1ce44bb447c1e5c":"bEKLz","954a1db98e5fa7e6":"48zHh","b8efff27cdb738b9":"2mi3I","4e93fe45cae499c3":"ldtR5","4fec8f51eee82732":"lPHNd","e5e29ee09258f6d2":"krUjc","4e8a5a660078958f":"gtb31","e4d298e589efe723":"jRTqj","e2de46407845cc49":"1tpGP","499927e8f43c1aad":"7hEG8","35e616265ef4c7d0":"21AMv","3d6377345c774070":"3GCVy","2fc7e88eece64":"8xBP8","eb4308b3d411355b":"2wlKu","4d75e431d996a7bd":"fYaZG","4b92afc2e15227b9":"3eTZQ","b9c4edeb7343e9e8":"bgxJ8","e18a4dc2350432f0":"7Spzc","f211afece82b3372":"aZ4P9","ece490d262e1340f":"9k7cc","73b901db05e69ad":"91Iyr","4a3494a78a34542f":"kRz8l","4213ded863b24215":"f89mb","77cd712826b3c5c1":"8cxG0","8369d2fe790f6f32":"fuLOH","7b647a799ced2cd9":"Z3dTd","afa5dd078f90f551":"besK2","e178446f0c3aeff9":"3WjRM","d34beff9be5506c5":"4dWYW","b71d8201890fd61e":"fahcO","f01685cdd1dfb443":"4fphA","75abb72238cc4dee":"dipmP","4bca765fce46af51":"9QXik","e594674c719ab553":"03fHo","789801a03e5e140e":"1mGBB","572244af4c80585b":"eiIRf","da9961e0ff4d5c35":"dD3X6","3ca91b97cffb0761":"5CY5G","4cdf562db955f7ba":"e8eUp","74ba864ba7b089c9":"f4kPj","b33b77412b0b3faa":"5hAXt","10a88c3c1fc31c46":"04Atm","f302053403f46072":"brsVh","cf77df45f5c63fa8":"l07GF","e2d034d075638bd3":"dc5hV","8b5901e6485a7c11":"bTq5d","74334ec3b2e4a30":"it3xb","484b45870643fb":"5NfyA","dc544af4e7bfc5ba":"4cJ95","28fbd7aa9405e905":"lAONF","680c4bc6217b9430":"1W6z0","c79b001df3a1cd4e":"6D5WW","d79ec99ca5a32e31":"b3N5W","e474b29626606e42":"k95D2","481b112c9d50f416":"afemA","aa52a3fca85317ac":"eX6l3","9d13c54cd4c0ebd9":"idtxH","bd86f32227ae71d4":"m1NRc","3338b7bea32464df":"dJYr2","5f80b6be8de0b1f0":"iDqEx","7a92099a245c93b4":"8kiyi","238231a235630333":"dLch8","eaa27e934c937fe3":"61bFV","438404de06674214":"dTU9H","b0c5f264b41b18fa":"bYeQK","3d0186b691b7fdc0":"6svRp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lK6AJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
parcelHelpers.export(exports, "extractToken", ()=>extractToken);
var _featureFlags = require("../feature-flags");
function getCookie(cookieName) {
    const prefix = (0, _featureFlags.useLegacyCiam)() ? "auth0_" : "ciam_";
    return getCookieByName(`${prefix}${cookieName}`);
}
function getCookieByName(fullCookieName) {
    const cookies = document.cookie.split(";");
    for (const c of cookies){
        const [name, ...value] = c.split("=");
        if (name.trim() === fullCookieName) return value.join("=");
    }
    return null;
}
async function extractToken(cookieName) {
    const cookie = getCookie(cookieName);
    if (!cookie) return null;
    const { decodeJwt } = await require("c6e23692f19aac04");
    return decodeJwt(cookie);
}

},{"../feature-flags":"3g2JG","c6e23692f19aac04":"e5KkV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3g2JG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initFeatureFlags", ()=>initFeatureFlags);
parcelHelpers.export(exports, "useLegacyCiam", ()=>useLegacyCiam);
parcelHelpers.export(exports, "featureFlags", ()=>featureFlags);
var _flagsmithClientProvider = require("@openfeature/flagsmith-client-provider");
var _webSdk = require("@openfeature/web-sdk");
// Safety net used when the FusionAuth worker hasn't set the config cookie
// (e.g. a page not behind the proxy). Production env id — fail safe rather
// than silent dev/test traffic.
const FALLBACK_FLAGSMITH_ENV_ID = "aAjYSbfHZH4KcNh6zv5hCt";
let initialized = false;
/**
 * Read `flagsmithEnvId` from any `ciam_*_config` cookie set by the FusionAuth
 * worker. Returns null if no such cookie exists or the value is empty.
 */ function readFlagsmithEnvIdFromCookie() {
    if (typeof document === "undefined") return null;
    const match = document.cookie.match(/(?:^|;\s*)ciam_[^=;]+_config=([^;]+)/);
    if (!match) return null;
    const params = new URLSearchParams(decodeURIComponent(match[1]));
    const value = params.get("flagsmithEnvId");
    return value && value.length > 0 ? value : null;
}
function resolveEnvironmentID() {
    const fromCookie = readFlagsmithEnvIdFromCookie();
    if (fromCookie) return fromCookie;
    console.warn("[CIAM SDK] No flagsmithEnvId found in config cookie \u2014 falling back to prd. This usually means the page is not served through the FusionAuth worker.");
    return FALLBACK_FLAGSMITH_ENV_ID;
}
async function initFeatureFlags() {
    if (initialized) return;
    const resolved = new (0, _flagsmithClientProvider.FlagsmithClientProvider)({
        environmentID: resolveEnvironmentID(),
        cacheFlags: true
    });
    await (0, _webSdk.OpenFeature).setProviderAndWait(resolved);
    initialized = true;
}
function useLegacyCiam() {
    return !featureFlags.getBooleanValue("use_fusionauth", false);
}
const featureFlags = (0, _webSdk.OpenFeature).getClient();

},{"@openfeature/flagsmith-client-provider":"cJbO9","@openfeature/web-sdk":"cF0AX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJbO9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlagsmithClientProvider", ()=>FlagsmithClientProvider);
var _webSdk = require("@openfeature/web-sdk");
var _flagsmith = require("flagsmith");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * Ret a value of the specified type based on the type parameter.
 *
 * @param value - The value to be converted or validated.
 * @param type - The target type for the conversion.
 * @returns The converted value if successful, or null if conversion fails or the type is unsupported.
 */ const typeFactory = (value, type)=>{
    if (value === null) return undefined;
    switch(type){
        case "string":
            return value !== null && typeof value !== "undefined" ? `${value}` : value;
        case "number":
            return typeof value === "number" ? value : parseFloat(value) || value;
        case "boolean":
            return typeof value === "boolean" ? value : false;
        case "object":
            if (typeof value === "string") try {
                return JSON.parse(value);
            } catch (error) {
                return value;
            }
            return value;
        default:
            return value;
    }
};
class FlagsmithClientProvider {
    constructor(_a){
        var { logger, flagsmithInstance } = _a, config = __rest(_a, [
            "logger",
            "flagsmithInstance"
        ]);
        this.metadata = {
            name: FlagsmithClientProvider.name
        };
        this.runsOn = "client";
        // The Open Feature event emitter
        this.events = new (0, _webSdk.OpenFeatureEventEmitter)();
        this._logger = logger;
        this._client = flagsmithInstance || (0, _flagsmith.createFlagsmithInstance)();
        this._config = config;
    }
    initialize(context) {
        return __awaiter(this, void 0, void 0, function*() {
            var _a;
            const identity = context === null || context === void 0 ? void 0 : context.targetingKey;
            const evaluationContext = this.mapContextToEvaluationContext(context, this._config.environmentID);
            if ((_a = this._client) === null || _a === void 0 ? void 0 : _a.initialised) {
                const isLogout = !!this._client.getContext().identity && !identity;
                this.events.emit((0, _webSdk.ProviderEvents).Stale, {
                    message: "context has changed"
                });
                return isLogout ? this._client.logout() : this._client.setContext(evaluationContext);
            }
            const serverState = this._config.state;
            if (serverState) {
                this._client.setState(serverState);
                this.events.emit((0, _webSdk.ProviderEvents).Ready, {
                    message: "flags provided by SSR state"
                });
            }
            if (!this._config.environmentID) this.events.emit((0, _webSdk.ProviderEvents).Stale, {
                message: "environmentID is required"
            });
            return this._client.init(Object.assign(Object.assign({}, this._config), {
                evaluationContext,
                onChange: (previousFlags, params, loadingState)=>{
                    var _a, _b;
                    const eventMeta = {
                        metadata: this.getMetadata(),
                        flagsChanged: params.flagsChanged
                    };
                    this.events.emit((0, _webSdk.ProviderEvents).Ready, Object.assign({
                        message: "Flags ready"
                    }, eventMeta));
                    if (params.flagsChanged) this.events.emit((0, _webSdk.ProviderEvents).ConfigurationChanged, Object.assign({
                        message: "Flags changed"
                    }, eventMeta));
                    (_b = (_a = this._config).onChange) === null || _b === void 0 || _b.call(_a, previousFlags, params, loadingState);
                }
            }));
        });
    }
    onContextChange(oldContext, newContext) {
        this.events.emit((0, _webSdk.ProviderEvents).Stale, {
            message: "Context Changed"
        });
        return this.initialize(newContext);
    }
    resolveBooleanEvaluation(flagKey) {
        return this.evaluate(flagKey, "boolean", false);
    }
    resolveStringEvaluation(flagKey, defaultValue) {
        return this.evaluate(flagKey, "string", defaultValue);
    }
    resolveNumberEvaluation(flagKey, defaultValue) {
        return this.evaluate(flagKey, "number", defaultValue);
    }
    resolveObjectEvaluation(flagKey, defaultValue) {
        return this.evaluate(flagKey, "object", defaultValue);
    }
    /**
     * Based on Flagsmith's state, return flag metadata
     * @private
     */ getMetadata() {
        var _a, _b;
        return Object.assign({
            targetingKey: ((_b = (_a = this._client.getContext()) === null || _a === void 0 ? void 0 : _a.identity) === null || _b === void 0 ? void 0 : _b.identifier) || ""
        }, this._client.getAllTraits() || {});
    }
    /**
     * Map the Open Feature context to the Flagsmith evaluation context
     * @private
     */ mapContextToEvaluationContext(context, environmentID) {
        if (!context) return {
            environment: {
                apiKey: environmentID
            }
        };
        const identity = context === null || context === void 0 ? void 0 : context.targetingKey;
        const traits = (context === null || context === void 0 ? void 0 : context["traits"]) || {};
        const hasTraits = Object.keys(traits).length > 0;
        const hasIdentifier = !!identity;
        const evaluationContext = {
            environment: {
                apiKey: this._config.environmentID
            },
            identity: hasIdentifier || hasTraits ? Object.assign(Object.assign({}, hasIdentifier && {
                identifier: identity
            }), hasTraits && {
                traits
            }) : undefined
        };
        return evaluationContext;
    }
    /**
     * Based on Flagsmith's loading state, determine the Open Feature resolution reason
     * @private
     */ evaluate(flagKey, type, defaultValue) {
        const value = typeFactory(type === "boolean" ? this._client.hasFeature(flagKey) : this._client.getValue(flagKey), type);
        if (typeof value !== "undefined" && typeof value !== type) throw new (0, _webSdk.TypeMismatchError)(`flag key ${flagKey} is not of type ${type}`);
        return {
            value: typeof value !== type ? defaultValue : value,
            reason: this.parseReason(value)
        };
    }
    /**
     * Based on Flagsmith's loading state and feature resolution, determine the Open Feature resolution reason
     * @private
     */ parseReason(value) {
        var _a;
        if (value === undefined) return "DEFAULT";
        switch((_a = this._client.loadingState) === null || _a === void 0 ? void 0 : _a.source){
            case "CACHE":
                return "CACHED";
            case "DEFAULT_FLAGS":
                return "DEFAULT";
            default:
                return "STATIC";
        }
    }
    get flagsmithClient() {
        return this._client;
    }
}

},{"@openfeature/web-sdk":"cF0AX","flagsmith":"6h7CH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cF0AX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComparisonStrategy", ()=>ComparisonStrategy);
parcelHelpers.export(exports, "FirstMatchStrategy", ()=>FirstMatchStrategy);
parcelHelpers.export(exports, "FirstSuccessfulStrategy", ()=>FirstSuccessfulStrategy);
parcelHelpers.export(exports, "InMemoryProvider", ()=>InMemoryProvider);
parcelHelpers.export(exports, "MultiProvider", ()=>MultiProvider);
parcelHelpers.export(exports, "NOOP_PROVIDER", ()=>NOOP_PROVIDER);
parcelHelpers.export(exports, "OpenFeature", ()=>OpenFeature);
parcelHelpers.export(exports, "OpenFeatureAPI", ()=>OpenFeatureAPI);
parcelHelpers.export(exports, "OpenFeatureEventEmitter", ()=>OpenFeatureEventEmitter);
parcelHelpers.export(exports, "ProviderEvents", ()=>(0, _core.ClientProviderEvents));
parcelHelpers.export(exports, "ProviderStatus", ()=>(0, _core.ClientProviderStatus));
parcelHelpers.export(exports, "TypedInMemoryProvider", ()=>TypedInMemoryProvider);
// src/provider/provider.ts
var _core = require("@openfeature/core");
// src/index.ts
parcelHelpers.exportAll(_core, exports);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var __superGet = (cls, obj, key)=>__reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// ../../node_modules/eventemitter3/index.js
var require_eventemitter3 = __commonJS({
    "../../node_modules/eventemitter3/index.js" (exports, module) {
        "use strict";
        var has = Object.prototype.hasOwnProperty;
        var prefix = "~";
        function Events() {}
        if (Object.create) {
            Events.prototype = /* @__PURE__ */ Object.create(null);
            if (!new Events().__proto__) prefix = false;
        }
        function EE(fn, context, once) {
            this.fn = fn;
            this.context = context;
            this.once = once || false;
        }
        function addListener(emitter, event, fn, context, once) {
            if (typeof fn !== "function") throw new TypeError("The listener must be a function");
            var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
            if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
            else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
            else emitter._events[evt] = [
                emitter._events[evt],
                listener
            ];
            return emitter;
        }
        function clearEvent(emitter, evt) {
            if (--emitter._eventsCount === 0) emitter._events = new Events();
            else delete emitter._events[evt];
        }
        function EventEmitter2() {
            this._events = new Events();
            this._eventsCount = 0;
        }
        EventEmitter2.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0) return names;
            for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
            if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
            return names;
        };
        EventEmitter2.prototype.listeners = function listeners(event) {
            var evt = prefix ? prefix + event : event, handlers = this._events[evt];
            if (!handlers) return [];
            if (handlers.fn) return [
                handlers.fn
            ];
            for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
            return ee;
        };
        EventEmitter2.prototype.listenerCount = function listenerCount(event) {
            var evt = prefix ? prefix + event : event, listeners = this._events[evt];
            if (!listeners) return 0;
            if (listeners.fn) return 1;
            return listeners.length;
        };
        EventEmitter2.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
                if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
                switch(len){
                    case 1:
                        return listeners.fn.call(listeners.context), true;
                    case 2:
                        return listeners.fn.call(listeners.context, a1), true;
                    case 3:
                        return listeners.fn.call(listeners.context, a1, a2), true;
                    case 4:
                        return listeners.fn.call(listeners.context, a1, a2, a3), true;
                    case 5:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                    case 6:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                }
                for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                listeners.fn.apply(listeners.context, args);
            } else {
                var length = listeners.length, j;
                for(i = 0; i < length; i++){
                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, void 0, true);
                    switch(len){
                        case 1:
                            listeners[i].fn.call(listeners[i].context);
                            break;
                        case 2:
                            listeners[i].fn.call(listeners[i].context, a1);
                            break;
                        case 3:
                            listeners[i].fn.call(listeners[i].context, a1, a2);
                            break;
                        case 4:
                            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                            break;
                        default:
                            if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                            listeners[i].fn.apply(listeners[i].context, args);
                    }
                }
            }
            return true;
        };
        EventEmitter2.prototype.on = function on(event, fn, context) {
            return addListener(this, event, fn, context, false);
        };
        EventEmitter2.prototype.once = function once(event, fn, context) {
            return addListener(this, event, fn, context, true);
        };
        EventEmitter2.prototype.removeListener = function removeListener(event, fn, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return this;
            if (!fn) {
                clearEvent(this, evt);
                return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
                if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
            } else {
                for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                else clearEvent(this, evt);
            }
            return this;
        };
        EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
                evt = prefix ? prefix + event : event;
                if (this._events[evt]) clearEvent(this, evt);
            } else {
                this._events = new Events();
                this._eventsCount = 0;
            }
            return this;
        };
        EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
        EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
        EventEmitter2.prefixed = prefix;
        EventEmitter2.EventEmitter = EventEmitter2;
        if ("undefined" !== typeof module) module.exports = EventEmitter2;
    }
});
// src/provider/no-op-provider.ts
var REASON_NO_OP = "No-op";
var NoopFeatureProvider = class {
    constructor(){
        this.metadata = {
            name: "No-op Provider"
        };
    }
    resolveBooleanEvaluation(_, defaultValue) {
        return this.noOp(defaultValue);
    }
    resolveStringEvaluation(_, defaultValue) {
        return this.noOp(defaultValue);
    }
    resolveNumberEvaluation(_, defaultValue) {
        return this.noOp(defaultValue);
    }
    resolveObjectEvaluation(_, defaultValue) {
        return this.noOp(defaultValue);
    }
    noOp(defaultValue) {
        return {
            value: defaultValue,
            reason: REASON_NO_OP
        };
    }
};
var NOOP_PROVIDER = new NoopFeatureProvider();
// ../../node_modules/eventemitter3/index.mjs
var import_index = __toESM(require_eventemitter3(), 1);
// src/events/open-feature-event-emitter.ts
var OpenFeatureEventEmitter = class extends (0, _core.GenericEventEmitter) {
    constructor(){
        super();
        this.eventEmitter = new import_index.default();
    }
};
var VariantNotFoundError = class _VariantNotFoundError extends (0, _core.OpenFeatureError) {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, _VariantNotFoundError.prototype);
        this.name = "VariantNotFoundError";
        this.code = (0, _core.ErrorCode).GENERAL;
    }
};
// src/provider/in-memory-provider/in-memory-provider.ts
var InMemoryProvider = class {
    constructor(flagConfiguration = {}){
        this.events = new OpenFeatureEventEmitter();
        this.runsOn = "client";
        this.metadata = {
            name: "in-memory"
        };
        this._flagConfiguration = __spreadValues({}, flagConfiguration);
    }
    /**
   * Overwrites the configured flags.
   * @param { FlagConfiguration } flagConfiguration new flag configuration
   */ putConfiguration(flagConfiguration) {
        return __async(this, null, function*() {
            try {
                const flagsChanged = Object.entries(__spreadValues(__spreadValues({}, flagConfiguration), this._flagConfiguration)).map(([key])=>key);
                this._flagConfiguration = __spreadValues({}, flagConfiguration);
                this.events.emit((0, _core.ClientProviderEvents).ConfigurationChanged, {
                    flagsChanged
                });
            } catch (err) {
                this.events.emit((0, _core.ClientProviderEvents).Error);
                throw err;
            }
        });
    }
    resolveBooleanEvaluation(flagKey, defaultValue, context, logger) {
        return this.resolveAndCheckFlag(flagKey, defaultValue, context || this._context, logger);
    }
    resolveNumberEvaluation(flagKey, defaultValue, context, logger) {
        return this.resolveAndCheckFlag(flagKey, defaultValue, context || this._context, logger);
    }
    resolveStringEvaluation(flagKey, defaultValue, context, logger) {
        return this.resolveAndCheckFlag(flagKey, defaultValue, context || this._context, logger);
    }
    resolveObjectEvaluation(flagKey, defaultValue, context, logger) {
        return this.resolveAndCheckFlag(flagKey, defaultValue, context || this._context, logger);
    }
    resolveAndCheckFlag(flagKey, defaultValue, context, logger) {
        if (!(flagKey in this._flagConfiguration)) {
            const message = `no flag found with key ${flagKey}`;
            logger == null || logger.debug(message);
            throw new (0, _core.FlagNotFoundError)(message);
        }
        if (this._flagConfiguration[flagKey].disabled) return {
            value: defaultValue,
            reason: (0, _core.StandardResolutionReasons).DISABLED
        };
        const resolvedFlag = this.resolveFlagWithReason(flagKey, context);
        if (resolvedFlag.value === void 0) {
            const message = `no value associated with variant provided for ${flagKey} found`;
            logger == null || logger.error(message);
            throw new VariantNotFoundError(message);
        }
        if (typeof resolvedFlag.value != typeof defaultValue) throw new (0, _core.TypeMismatchError)();
        return resolvedFlag;
    }
    resolveFlagWithReason(flagKey, ctx) {
        try {
            const resolutionResult = this.lookupFlagValue(flagKey, ctx);
            return resolutionResult;
        } catch (error) {
            if (!(error instanceof (0, _core.OpenFeatureError))) throw new (0, _core.GeneralError)((error == null ? void 0 : error.message) || "unknown error");
            throw error;
        }
    }
    lookupFlagValue(flagKey, ctx) {
        var _a;
        const flagSpec = this._flagConfiguration[flagKey];
        const isContextEval = ctx && (flagSpec == null ? void 0 : flagSpec.contextEvaluator);
        const variant = isContextEval ? (_a = flagSpec.contextEvaluator) == null ? void 0 : _a.call(flagSpec, ctx) : flagSpec.defaultVariant;
        const value = variant && (flagSpec == null ? void 0 : flagSpec.variants[variant]);
        const reason = isContextEval ? (0, _core.StandardResolutionReasons).TARGETING_MATCH : (0, _core.StandardResolutionReasons).STATIC;
        return __spreadProps(__spreadValues({
            value
        }, variant && {
            variant
        }), {
            reason
        });
    }
};
var TypedInMemoryProvider = class _TypedInMemoryProvider extends InMemoryProvider {
    constructor(flagConfiguration = {}){
        super(flagConfiguration);
    }
    /**
   * Overwrites the configured flags.
   * @param { FlagConfiguration } flagConfiguration new flag configuration
   * @example
   * ```
   * await provider.putConfiguration({
   *   'my-flag': {
   *     variants: { on: true, off: false },
   *     defaultVariant: 'on',
   *     contextEvaluator: (ctx) => ctx?.user?.id === '123' ? 'on' : 'off',
   *     disabled: false,
   *   },
   * });
   *
   * const flags = {
   *   'my-flag': {
   *     variants: { on: true, off: false },
   *     defaultVariant: 'on',
   *     contextEvaluator: (ctx) => ctx?.user?.id === '123' ? 'on' : 'off',
   *     disabled: false,
   *   },
   * } as const; // 'as const' needed to preserve the `defaultVariant` narrow literal type rather than `string`
   * await provider.putConfiguration(flags);
   * ```
   */ putConfiguration(flagConfiguration) {
        return __async(this, null, function*() {
            yield __superGet(_TypedInMemoryProvider.prototype, this, "putConfiguration").call(this, flagConfiguration);
        });
    }
};
var FirstMatchStrategy = class extends (0, _core.BaseFirstMatchStrategy) {
    constructor(){
        super((0, _core.ClientProviderStatus));
    }
};
var FirstSuccessfulStrategy = class extends (0, _core.BaseFirstSuccessfulStrategy) {
    constructor(){
        super((0, _core.ClientProviderStatus));
    }
};
var ComparisonStrategy = class extends (0, _core.BaseComparisonStrategy) {
    constructor(fallbackProvider, onMismatch){
        super((0, _core.ClientProviderStatus), fallbackProvider, onMismatch);
    }
};
// src/provider/multi-provider/hook-executor.ts
var HookExecutor = class {
    constructor(logger){
        this.logger = logger;
    }
    beforeHooks(hooks, hookContext, hints) {
        var _a;
        for (const hook of hooks != null ? hooks : [])(_a = hook == null ? void 0 : hook.before) == null || _a.call(hook, hookContext, Object.freeze(hints));
    }
    afterHooks(hooks, hookContext, evaluationDetails, hints) {
        var _a;
        for (const hook of hooks != null ? hooks : [])(_a = hook == null ? void 0 : hook.after) == null || _a.call(hook, hookContext, evaluationDetails, hints);
    }
    errorHooks(hooks, hookContext, err, hints) {
        var _a;
        for (const hook of hooks != null ? hooks : [])try {
            (_a = hook == null ? void 0 : hook.error) == null || _a.call(hook, hookContext, err, hints);
        } catch (err2) {
            this.logger.error(`Unhandled error during 'error' hook: ${err2}`);
            if (err2 instanceof Error) this.logger.error(err2.stack);
        }
    }
    finallyHooks(hooks, hookContext, evaluationDetails, hints) {
        var _a;
        for (const hook of hooks != null ? hooks : [])try {
            (_a = hook == null ? void 0 : hook.finally) == null || _a.call(hook, hookContext, evaluationDetails, hints);
        } catch (err) {
            this.logger.error(`Unhandled error during 'finally' hook: ${err}`);
            if (err instanceof Error) this.logger.error(err.stack);
        }
    }
};
// src/provider/multi-provider/multi-provider-web.ts
var MultiProvider = class _MultiProvider {
    constructor(constructorProviders, evaluationStrategy = new FirstMatchStrategy(), logger = new (0, _core.DefaultLogger)()){
        this.constructorProviders = constructorProviders;
        this.evaluationStrategy = evaluationStrategy;
        this.logger = logger;
        this.runsOn = "client";
        this.events = new OpenFeatureEventEmitter();
        this.hookContexts = /* @__PURE__ */ new WeakMap();
        this.hookHints = /* @__PURE__ */ new WeakMap();
        this.providerEntries = [];
        this.providerEntriesByName = {};
        this.statusTracker = new (0, _core.StatusTracker)(this.events, (0, _core.ClientProviderStatus), (0, _core.ClientProviderEvents));
        this.hookExecutor = new HookExecutor(this.logger);
        this.registerProviders(constructorProviders);
        const aggregateMetadata = Object.keys(this.providerEntriesByName).reduce((acc, name)=>{
            return __spreadProps(__spreadValues({}, acc), {
                [name]: this.providerEntriesByName[name].provider.metadata
            });
        }, {});
        this.metadata = __spreadProps(__spreadValues({}, aggregateMetadata), {
            name: _MultiProvider.name
        });
    }
    registerProviders(constructorProviders) {
        var _a, _b;
        const providersByName = {};
        for (const constructorProvider of constructorProviders){
            const providerName = constructorProvider.provider.metadata.name;
            const candidateName = (_a = constructorProvider.name) != null ? _a : providerName;
            if (constructorProvider.name && providersByName[constructorProvider.name]) throw new Error("Provider names must be unique");
            (_b = providersByName[candidateName]) != null ? _b : providersByName[candidateName] = [];
            providersByName[candidateName].push(constructorProvider.provider);
        }
        for (const name of Object.keys(providersByName)){
            const useIndexedNames = providersByName[name].length > 1;
            for(let i = 0; i < providersByName[name].length; i++){
                const indexedName = useIndexedNames ? `${name}-${i + 1}` : name;
                this.providerEntriesByName[indexedName] = {
                    provider: providersByName[name][i],
                    name: indexedName
                };
                this.providerEntries.push(this.providerEntriesByName[indexedName]);
                this.statusTracker.wrapEventHandler(this.providerEntriesByName[indexedName]);
            }
        }
        Object.freeze(this.providerEntries);
        Object.freeze(this.providerEntriesByName);
    }
    initialize(context) {
        return __async(this, null, function*() {
            const result = yield Promise.allSettled(this.providerEntries.map((provider)=>{
                var _a, _b;
                return (_b = (_a = provider.provider).initialize) == null ? void 0 : _b.call(_a, context);
            }));
            (0, _core.throwAggregateErrorFromPromiseResults)(result, this.providerEntries);
        });
    }
    onClose() {
        return __async(this, null, function*() {
            const result = yield Promise.allSettled(this.providerEntries.map((provider)=>{
                var _a, _b;
                return (_b = (_a = provider.provider).onClose) == null ? void 0 : _b.call(_a);
            }));
            (0, _core.throwAggregateErrorFromPromiseResults)(result, this.providerEntries);
        });
    }
    onContextChange(oldContext, newContext) {
        return __async(this, null, function*() {
            var _a, _b;
            for (const providerEntry of this.providerEntries)yield (_b = (_a = providerEntry.provider).onContextChange) == null ? void 0 : _b.call(_a, oldContext, newContext);
        });
    }
    resolveBooleanEvaluation(flagKey, defaultValue, context) {
        return this.flagResolutionProxy(flagKey, "boolean", defaultValue, context);
    }
    resolveStringEvaluation(flagKey, defaultValue, context) {
        return this.flagResolutionProxy(flagKey, "string", defaultValue, context);
    }
    resolveNumberEvaluation(flagKey, defaultValue, context) {
        return this.flagResolutionProxy(flagKey, "number", defaultValue, context);
    }
    resolveObjectEvaluation(flagKey, defaultValue, context) {
        return this.flagResolutionProxy(flagKey, "object", defaultValue, context);
    }
    track(trackingEventName, context, trackingEventDetails) {
        var _a, _b;
        for (const providerEntry of this.providerEntries){
            if (!providerEntry.provider.track) continue;
            const strategyContext = {
                provider: providerEntry.provider,
                providerName: providerEntry.name,
                providerStatus: this.statusTracker.providerStatus(providerEntry.name)
            };
            if (this.evaluationStrategy.shouldTrackWithThisProvider(strategyContext, context, trackingEventName, trackingEventDetails)) try {
                (_b = (_a = providerEntry.provider).track) == null || _b.call(_a, trackingEventName, context, trackingEventDetails);
            } catch (error) {
                this.logger.error(`Error tracking event "${trackingEventName}" with provider "${providerEntry.name}":`, error);
            }
        }
    }
    flagResolutionProxy(flagKey, flagType, defaultValue, context) {
        var _a;
        const hookContext = this.hookContexts.get(context);
        const hookHints = this.hookHints.get(context);
        if (!hookContext || !hookHints) throw new (0, _core.GeneralError)("Hook context not available for evaluation");
        const results = [];
        for (const providerEntry of this.providerEntries){
            const [shouldEvaluateNext, result] = this.evaluateProviderEntry(flagKey, flagType, defaultValue, providerEntry, hookContext, hookHints, context);
            results.push(result);
            if (!shouldEvaluateNext) break;
        }
        const resolutions = results.filter((r)=>Boolean(r));
        const finalResult = this.evaluationStrategy.determineFinalResult({
            flagKey,
            flagType
        }, context, resolutions);
        if ((_a = finalResult.errors) == null ? void 0 : _a.length) throw (0, _core.constructAggregateError)(finalResult.errors);
        if (!finalResult.details) throw new (0, _core.GeneralError)("No result was returned from any provider");
        return finalResult.details;
    }
    evaluateProviderEntry(flagKey, flagType, defaultValue, providerEntry, hookContext, hookHints, context) {
        let evaluationResult = void 0;
        const provider = providerEntry.provider;
        const strategyContext = {
            flagKey,
            flagType,
            provider,
            providerName: providerEntry.name,
            providerStatus: this.statusTracker.providerStatus(providerEntry.name)
        };
        if (!this.evaluationStrategy.shouldEvaluateThisProvider(strategyContext, context)) return [
            true,
            null
        ];
        let resolution;
        try {
            evaluationResult = this.evaluateProviderAndHooks(flagKey, defaultValue, provider, hookContext, hookHints);
            resolution = {
                details: evaluationResult,
                provider,
                providerName: providerEntry.name
            };
        } catch (error) {
            resolution = {
                thrownError: error,
                provider,
                providerName: providerEntry.name
            };
        }
        return [
            this.evaluationStrategy.shouldEvaluateNextProvider(strategyContext, context, resolution),
            resolution
        ];
    }
    evaluateProviderAndHooks(flagKey, defaultValue, provider, hookContext, hookHints) {
        var _a;
        let evaluationDetails;
        try {
            this.hookExecutor.beforeHooks(provider.hooks, hookContext, hookHints);
            const resolutionDetails = this.callProviderResolve(provider, flagKey, defaultValue, hookContext.context);
            evaluationDetails = __spreadProps(__spreadValues({}, resolutionDetails), {
                flagMetadata: Object.freeze((_a = resolutionDetails.flagMetadata) != null ? _a : {}),
                flagKey
            });
            this.hookExecutor.afterHooks(provider.hooks, hookContext, evaluationDetails, hookHints);
        } catch (error) {
            this.hookExecutor.errorHooks(provider.hooks, hookContext, error, hookHints);
            evaluationDetails = this.getErrorEvaluationDetails(flagKey, defaultValue, error);
        }
        this.hookExecutor.finallyHooks(provider.hooks, hookContext, evaluationDetails, hookHints);
        return evaluationDetails;
    }
    callProviderResolve(provider, flagKey, defaultValue, context) {
        switch(typeof defaultValue){
            case "string":
                return provider.resolveStringEvaluation(flagKey, defaultValue, context, this.logger);
            case "number":
                return provider.resolveNumberEvaluation(flagKey, defaultValue, context, this.logger);
            case "object":
                return provider.resolveObjectEvaluation(flagKey, defaultValue, context, this.logger);
            case "boolean":
                return provider.resolveBooleanEvaluation(flagKey, defaultValue, context, this.logger);
            default:
                throw new (0, _core.GeneralError)("Invalid flag evaluation type");
        }
    }
    get hooks() {
        return [
            {
                before: (hookContext, hints)=>{
                    this.hookContexts.set(hookContext.context, hookContext);
                    this.hookHints.set(hookContext.context, hints != null ? hints : {});
                    return hookContext.context;
                }
            }
        ];
    }
    getErrorEvaluationDetails(flagKey, defaultValue, err, flagMetadata = {}) {
        const errorMessage = err == null ? void 0 : err.message;
        const errorCode = (err == null ? void 0 : err.code) || (0, _core.ErrorCode).GENERAL;
        return {
            errorCode,
            errorMessage,
            value: defaultValue,
            reason: (0, _core.StandardResolutionReasons).ERROR,
            flagMetadata: Object.freeze(flagMetadata),
            flagKey
        };
    }
};
var OpenFeatureClient = class {
    constructor(providerAccessor, providerStatusAccessor, emitterAccessor, apiContextAccessor, apiHooksAccessor, globalLogger, options){
        this.providerAccessor = providerAccessor;
        this.providerStatusAccessor = providerStatusAccessor;
        this.emitterAccessor = emitterAccessor;
        this.apiContextAccessor = apiContextAccessor;
        this.apiHooksAccessor = apiHooksAccessor;
        this.globalLogger = globalLogger;
        this.options = options;
        this._hooks = [];
    }
    get metadata() {
        var _a, _b;
        return {
            // Use domain if name is not provided
            name: (_a = this.options.domain) != null ? _a : this.options.name,
            domain: (_b = this.options.domain) != null ? _b : this.options.name,
            version: this.options.version,
            providerMetadata: this.providerAccessor().metadata
        };
    }
    get providerStatus() {
        return this.providerStatusAccessor();
    }
    addHandler(eventType, handler, options) {
        var _a;
        this.emitterAccessor().addHandler(eventType, handler);
        const shouldRunNow = (0, _core.statusMatchesEvent)(eventType, this.providerStatus);
        if (shouldRunNow) try {
            handler({
                clientName: this.metadata.name,
                domain: this.metadata.domain,
                providerName: this._provider.metadata.name
            });
        } catch (err) {
            (_a = this._logger) == null || _a.error("Error running event handler:", err);
        }
        if ((options == null ? void 0 : options.signal) && typeof options.signal.addEventListener === "function") options.signal.addEventListener("abort", ()=>{
            this.removeHandler(eventType, handler);
        });
    }
    removeHandler(notificationType, handler) {
        this.emitterAccessor().removeHandler(notificationType, handler);
    }
    getHandlers(eventType) {
        return this.emitterAccessor().getHandlers(eventType);
    }
    setLogger(logger) {
        this._clientLogger = new (0, _core.SafeLogger)(logger);
        return this;
    }
    addHooks(...hooks) {
        this._hooks = [
            ...this._hooks,
            ...hooks
        ];
        return this;
    }
    getHooks() {
        return this._hooks;
    }
    clearHooks() {
        this._hooks = [];
        return this;
    }
    getBooleanValue(flagKey, defaultValue, options) {
        return this.getBooleanDetails(flagKey, defaultValue, options).value;
    }
    getBooleanDetails(flagKey, defaultValue, options) {
        return this.evaluate(flagKey, this._provider.resolveBooleanEvaluation, defaultValue, "boolean", options);
    }
    getStringValue(flagKey, defaultValue, options) {
        return this.getStringDetails(flagKey, defaultValue, options).value;
    }
    getStringDetails(flagKey, defaultValue, options) {
        return this.evaluate(flagKey, // this isolates providers from our restricted string generic argument.
        this._provider.resolveStringEvaluation, defaultValue, "string", options);
    }
    getNumberValue(flagKey, defaultValue, options) {
        return this.getNumberDetails(flagKey, defaultValue, options).value;
    }
    getNumberDetails(flagKey, defaultValue, options) {
        return this.evaluate(flagKey, // this isolates providers from our restricted number generic argument.
        this._provider.resolveNumberEvaluation, defaultValue, "number", options);
    }
    getObjectValue(flagKey, defaultValue, options) {
        return this.getObjectDetails(flagKey, defaultValue, options).value;
    }
    getObjectDetails(flagKey, defaultValue, options) {
        return this.evaluate(flagKey, this._provider.resolveObjectEvaluation, defaultValue, "object", options);
    }
    track(occurrenceKey, occurrenceDetails = {}) {
        var _a, _b, _c;
        try {
            this.shortCircuitIfNotReady();
            if (typeof this._provider.track === "function") {
                const frozenContext = Object.freeze(__spreadValues({}, this.apiContextAccessor((_a = this == null ? void 0 : this.options) == null ? void 0 : _a.domain)));
                return (_c = (_b = this._provider).track) == null ? void 0 : _c.call(_b, occurrenceKey, frozenContext, occurrenceDetails);
            } else this._logger.debug("Provider does not support the track function; will no-op.");
        } catch (err) {
            this._logger.debug("Error recording tracking event.", err);
        }
    }
    evaluate(flagKey, resolver, defaultValue, flagType, options = {}) {
        var _a, _b;
        const allHooks = [
            ...this.apiHooksAccessor(),
            ...this.getHooks(),
            ...options.hooks || [],
            ...this._provider.hooks || []
        ];
        const allHooksReversed = [
            ...allHooks
        ].reverse();
        const context = __spreadValues({}, this.apiContextAccessor((_a = this == null ? void 0 : this.options) == null ? void 0 : _a.domain));
        const hookContexts = allHooksReversed.map(()=>Object.freeze({
                flagKey,
                defaultValue,
                flagValueType: flagType,
                clientMetadata: this.metadata,
                providerMetadata: this._provider.metadata,
                context,
                logger: this._logger,
                hookData: new (0, _core.MapHookData)()
            }));
        let evaluationDetails;
        try {
            this.beforeHooks(allHooks, hookContexts, options);
            this.shortCircuitIfNotReady();
            const resolution = resolver.call(this._provider, flagKey, defaultValue, context, this._logger);
            const resolutionDetails = __spreadProps(__spreadValues({}, resolution), {
                flagMetadata: Object.freeze((_b = resolution.flagMetadata) != null ? _b : {}),
                flagKey
            });
            if (resolutionDetails.errorCode) {
                const err = (0, _core.instantiateErrorByErrorCode)(resolutionDetails.errorCode, resolutionDetails.errorMessage);
                this.errorHooks(allHooksReversed, hookContexts, err, options);
                evaluationDetails = this.getErrorEvaluationDetails(flagKey, defaultValue, err, resolutionDetails.flagMetadata);
            } else {
                this.afterHooks(allHooksReversed, hookContexts, resolutionDetails, options);
                evaluationDetails = resolutionDetails;
            }
        } catch (err) {
            this.errorHooks(allHooksReversed, hookContexts, err, options);
            evaluationDetails = this.getErrorEvaluationDetails(flagKey, defaultValue, err);
        }
        this.finallyHooks(allHooksReversed, hookContexts, evaluationDetails, options);
        return evaluationDetails;
    }
    beforeHooks(hooks, hookContexts, options) {
        var _a;
        for (const [index, hook] of hooks.entries()){
            const hookContextIndex = hooks.length - 1 - index;
            const hookContext = hookContexts[hookContextIndex];
            Object.freeze(hookContext);
            Object.freeze(hookContext.context);
            (_a = hook == null ? void 0 : hook.before) == null || _a.call(hook, hookContext, Object.freeze(options.hookHints));
        }
    }
    afterHooks(hooks, hookContexts, evaluationDetails, options) {
        var _a;
        for (const [index, hook] of hooks.entries()){
            const hookContext = hookContexts[index];
            (_a = hook == null ? void 0 : hook.after) == null || _a.call(hook, hookContext, evaluationDetails, options.hookHints);
        }
    }
    errorHooks(hooks, hookContexts, err, options) {
        var _a;
        for (const [index, hook] of hooks.entries())try {
            const hookContext = hookContexts[index];
            (_a = hook == null ? void 0 : hook.error) == null || _a.call(hook, hookContext, err, options.hookHints);
        } catch (err2) {
            this._logger.error(`Unhandled error during 'error' hook: ${err2}`);
            if (err2 instanceof Error) this._logger.error(err2.stack);
            this._logger.error(err2 == null ? void 0 : err2.stack);
        }
    }
    finallyHooks(hooks, hookContexts, evaluationDetails, options) {
        var _a;
        for (const [index, hook] of hooks.entries())try {
            const hookContext = hookContexts[index];
            (_a = hook == null ? void 0 : hook.finally) == null || _a.call(hook, hookContext, evaluationDetails, options.hookHints);
        } catch (err) {
            this._logger.error(`Unhandled error during 'finally' hook: ${err}`);
            if (err instanceof Error) this._logger.error(err.stack);
            this._logger.error(err == null ? void 0 : err.stack);
        }
    }
    get _provider() {
        return this.providerAccessor();
    }
    get _logger() {
        return this._clientLogger || this.globalLogger();
    }
    shortCircuitIfNotReady() {
        if (this.providerStatus === (0, _core.ClientProviderStatus).NOT_READY) throw new (0, _core.ProviderNotReadyError)("provider has not yet initialized");
        else if (this.providerStatus === (0, _core.ClientProviderStatus).FATAL) throw new (0, _core.ProviderFatalError)("provider is in an irrecoverable error state");
    }
    getErrorEvaluationDetails(flagKey, defaultValue, err, flagMetadata = {}) {
        const errorMessage = err == null ? void 0 : err.message;
        const errorCode = (err == null ? void 0 : err.code) || (0, _core.ErrorCode).GENERAL;
        return {
            errorCode,
            errorMessage,
            value: defaultValue,
            reason: (0, _core.StandardResolutionReasons).ERROR,
            flagMetadata: Object.freeze(flagMetadata),
            flagKey
        };
    }
};
// src/open-feature.ts
var GLOBAL_OPENFEATURE_API_KEY = Symbol.for("@openfeature/web-sdk/api");
var _globalThis = globalThis;
var OpenFeatureAPI = class _OpenFeatureAPI extends (0, _core.OpenFeatureCommonAPI) {
    constructor(){
        super("client");
        this._statusEnumType = (0, _core.ClientProviderStatus);
        this._apiEmitter = new OpenFeatureEventEmitter();
        this._defaultProvider = new (0, _core.ProviderWrapper)(NOOP_PROVIDER, (0, _core.ClientProviderStatus).NOT_READY, this._statusEnumType);
        this._domainScopedProviders = /* @__PURE__ */ new Map();
        this._createEventEmitter = ()=>new OpenFeatureEventEmitter();
    }
    /**
   * Gets a singleton instance of the OpenFeature API.
   * @ignore
   * @returns {OpenFeatureAPI} OpenFeature API
   */ static getInstance() {
        const globalApi = _globalThis[GLOBAL_OPENFEATURE_API_KEY];
        if (globalApi) return globalApi;
        const instance = new _OpenFeatureAPI();
        _globalThis[GLOBAL_OPENFEATURE_API_KEY] = instance;
        return instance;
    }
    getProviderStatus(domain) {
        var _a, _b;
        if (!domain) return this._defaultProvider.status;
        return (_b = (_a = this._domainScopedProviders.get(domain)) == null ? void 0 : _a.status) != null ? _b : this._defaultProvider.status;
    }
    setProviderAndWait(clientOrProvider, providerContextOrUndefined, contextOrUndefined) {
        return __async(this, null, function*() {
            const domain = (0, _core.stringOrUndefined)(clientOrProvider);
            const provider = domain ? (0, _core.objectOrUndefined)(providerContextOrUndefined) : (0, _core.objectOrUndefined)(clientOrProvider);
            const context = domain ? (0, _core.objectOrUndefined)(contextOrUndefined) : (0, _core.objectOrUndefined)(providerContextOrUndefined);
            if (context) {
                if (domain) this._domainScopedContext.set(domain, context);
                else this._context = context;
            }
            yield this.setAwaitableProvider(domain, provider);
        });
    }
    setProvider(domainOrProvider, providerContextOrUndefined, contextOrUndefined) {
        const domain = (0, _core.stringOrUndefined)(domainOrProvider);
        const provider = domain ? (0, _core.objectOrUndefined)(providerContextOrUndefined) : (0, _core.objectOrUndefined)(domainOrProvider);
        const context = domain ? (0, _core.objectOrUndefined)(contextOrUndefined) : (0, _core.objectOrUndefined)(providerContextOrUndefined);
        if (context) {
            if (domain) this._domainScopedContext.set(domain, context);
            else this._context = context;
        }
        const maybePromise = this.setAwaitableProvider(domain, provider);
        Promise.resolve(maybePromise).catch((err)=>{
            this._logger.error("Error during provider initialization:", err);
        });
        return this;
    }
    getProvider(domain) {
        return this.getProviderForClient(domain);
    }
    setContext(domainOrContext, contextOrUndefined) {
        return __async(this, null, function*() {
            var _a, _b;
            const domain = (0, _core.stringOrUndefined)(domainOrContext);
            const context = (_b = (_a = (0, _core.objectOrUndefined)(domainOrContext)) != null ? _a : (0, _core.objectOrUndefined)(contextOrUndefined)) != null ? _b : {};
            if (domain) {
                const wrapper = this._domainScopedProviders.get(domain);
                if (wrapper) {
                    const oldContext = this.getContext(domain);
                    this._domainScopedContext.set(domain, context);
                    yield this.runProviderContextChangeHandler(domain, wrapper, oldContext, context);
                } else this._domainScopedContext.set(domain, context);
            } else {
                const oldContext = this._context;
                this._context = context;
                const unboundProviders = Array.from(this._domainScopedProviders.entries()).filter(([domain2])=>!this._domainScopedContext.has(domain2)).reduce((acc, [domain2, wrapper])=>{
                    acc.push({
                        domain: domain2,
                        wrapper
                    });
                    return acc;
                }, []);
                const allDomainRecords = [
                    // add in the default (no domain)
                    {
                        domain: void 0,
                        wrapper: this._defaultProvider
                    },
                    ...unboundProviders
                ];
                yield Promise.all(allDomainRecords.map((dm)=>this.runProviderContextChangeHandler(dm.domain, dm.wrapper, oldContext, context)));
            }
        });
    }
    getContext(domainOrUndefined) {
        const domain = (0, _core.stringOrUndefined)(domainOrUndefined);
        if (domain) {
            const context = this._domainScopedContext.get(domain);
            if (context) return context;
            else this._logger.debug(`Unable to find context for '${domain}'.`);
        }
        return this._context;
    }
    clearContext(domainOrUndefined) {
        return __async(this, null, function*() {
            const domain = (0, _core.stringOrUndefined)(domainOrUndefined);
            if (domain) {
                const wrapper = this._domainScopedProviders.get(domain);
                if (wrapper) {
                    const oldContext = this.getContext(domain);
                    this._domainScopedContext.delete(domain);
                    const newContext = this.getContext();
                    yield this.runProviderContextChangeHandler(domain, wrapper, oldContext, newContext);
                } else this._domainScopedContext.delete(domain);
            } else return this.setContext({});
        });
    }
    /**
   * Resets the global evaluation context and removes the evaluation context for
   * all domains.
   */ clearContexts() {
        return __async(this, null, function*() {
            yield this.clearContext();
            yield Promise.allSettled(Array.from(this._domainScopedProviders.keys()).map((domain)=>this.clearContext(domain)));
        });
    }
    /**
   * A factory function for creating new domain-scoped OpenFeature clients. Clients
   * can contain their own state (e.g. logger, hook, context). Multiple domains
   * can be used to segment feature flag configuration.
   *
   * If there is already a provider bound to this name via {@link this.setProvider setProvider}, this provider will be used.
   * Otherwise, the default provider is used until a provider is assigned to that name.
   * @param {string} domain An identifier which logically binds clients with providers
   * @param {string} version The version of the client (only used for metadata)
   * @returns {Client} OpenFeature Client
   */ getClient(domain, version) {
        return new OpenFeatureClient(// functions are passed here to make sure that these values are always up to date,
        // and so we don't have to make these public properties on the API class.
        ()=>this.getProviderForClient(domain), ()=>this.getProviderStatus(domain), ()=>this.buildAndCacheEventEmitterForClient(domain), (domain2)=>this.getContext(domain2), ()=>this.getHooks(), ()=>this._logger, {
            domain,
            version
        });
    }
    /**
   * Clears all registered providers and resets the default provider.
   * @returns {Promise<void>}
   */ clearProviders() {
        return __async(this, null, function*() {
            yield __superGet(_OpenFeatureAPI.prototype, this, "clearProvidersAndSetDefault").call(this, NOOP_PROVIDER);
            this._domainScopedContext.clear();
        });
    }
    runProviderContextChangeHandler(domain, wrapper, oldContext, newContext) {
        return __async(this, null, function*() {
            var _a, _b, _c, _d, _e, _f;
            const providerName = ((_b = (_a = wrapper.provider) == null ? void 0 : _a.metadata) == null ? void 0 : _b.name) || "unnamed-provider";
            try {
                if (typeof wrapper.provider.onContextChange === "function") {
                    const maybePromise = wrapper.provider.onContextChange(oldContext, newContext);
                    if (maybePromise && typeof (maybePromise == null ? void 0 : maybePromise.then) === "function") {
                        wrapper.incrementPendingContextChanges();
                        wrapper.status = this._statusEnumType.RECONCILING;
                        this.getAssociatedEventEmitters(domain).forEach((emitter)=>{
                            emitter == null || emitter.emit((0, _core.ClientProviderEvents).Reconciling, {
                                domain,
                                providerName
                            });
                        });
                        (_c = this._apiEmitter) == null || _c.emit((0, _core.ClientProviderEvents).Reconciling, {
                            domain,
                            providerName
                        });
                        yield maybePromise;
                        wrapper.decrementPendingContextChanges();
                    }
                }
                wrapper.status = this._statusEnumType.READY;
                if (wrapper.allContextChangesSettled) {
                    this.getAssociatedEventEmitters(domain).forEach((emitter)=>{
                        emitter == null || emitter.emit((0, _core.ClientProviderEvents).ContextChanged, {
                            clientName: domain,
                            domain,
                            providerName
                        });
                    });
                    (_d = this._apiEmitter) == null || _d.emit((0, _core.ClientProviderEvents).ContextChanged, {
                        clientName: domain,
                        domain,
                        providerName
                    });
                }
            } catch (err) {
                wrapper.decrementPendingContextChanges();
                wrapper.status = this._statusEnumType.ERROR;
                if (wrapper.allContextChangesSettled) {
                    const error = err;
                    const message = `Error running ${providerName}'s context change handler: ${error == null ? void 0 : error.message}`;
                    (_e = this._logger) == null || _e.error(`${message}`, err);
                    this.getAssociatedEventEmitters(domain).forEach((emitter)=>{
                        emitter == null || emitter.emit((0, _core.ClientProviderEvents).Error, {
                            clientName: domain,
                            domain,
                            providerName,
                            message
                        });
                    });
                    (_f = this._apiEmitter) == null || _f.emit((0, _core.ClientProviderEvents).Error, {
                        clientName: domain,
                        domain,
                        providerName,
                        message
                    });
                }
            }
        });
    }
};
var OpenFeature = OpenFeatureAPI.getInstance();

},{"@openfeature/core":"cYEtY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cYEtY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AggregateError", ()=>AggregateError);
parcelHelpers.export(exports, "AllProviderEvents", ()=>ClientProviderEvents);
parcelHelpers.export(exports, "AllProviderStatus", ()=>ClientProviderStatus);
parcelHelpers.export(exports, "BaseComparisonStrategy", ()=>ComparisonStrategy);
parcelHelpers.export(exports, "BaseEvaluationStrategy", ()=>BaseEvaluationStrategy);
parcelHelpers.export(exports, "BaseFirstMatchStrategy", ()=>FirstMatchStrategy);
parcelHelpers.export(exports, "BaseFirstSuccessfulStrategy", ()=>FirstSuccessfulStrategy);
parcelHelpers.export(exports, "ClientProviderEvents", ()=>ClientProviderEvents);
parcelHelpers.export(exports, "ClientProviderStatus", ()=>ClientProviderStatus);
parcelHelpers.export(exports, "DefaultLogger", ()=>DefaultLogger);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "ErrorWithCode", ()=>ErrorWithCode);
parcelHelpers.export(exports, "FlagNotFoundError", ()=>FlagNotFoundError);
parcelHelpers.export(exports, "GeneralError", ()=>GeneralError);
parcelHelpers.export(exports, "GenericEventEmitter", ()=>GenericEventEmitter);
parcelHelpers.export(exports, "InvalidContextError", ()=>InvalidContextError);
parcelHelpers.export(exports, "LOG_LEVELS", ()=>LOG_LEVELS);
parcelHelpers.export(exports, "MapHookData", ()=>MapHookData);
parcelHelpers.export(exports, "OpenFeatureCommonAPI", ()=>OpenFeatureCommonAPI);
parcelHelpers.export(exports, "OpenFeatureError", ()=>OpenFeatureError);
parcelHelpers.export(exports, "ParseError", ()=>ParseError);
parcelHelpers.export(exports, "ProviderFatalError", ()=>ProviderFatalError);
parcelHelpers.export(exports, "ProviderNotReadyError", ()=>ProviderNotReadyError);
parcelHelpers.export(exports, "ProviderWrapper", ()=>ProviderWrapper);
parcelHelpers.export(exports, "SafeLogger", ()=>SafeLogger);
parcelHelpers.export(exports, "ServerProviderEvents", ()=>ServerProviderEvents);
parcelHelpers.export(exports, "ServerProviderStatus", ()=>ServerProviderStatus);
parcelHelpers.export(exports, "StandardResolutionReasons", ()=>StandardResolutionReasons);
parcelHelpers.export(exports, "StatusTracker", ()=>StatusTracker);
parcelHelpers.export(exports, "TargetingKeyMissingError", ()=>TargetingKeyMissingError);
parcelHelpers.export(exports, "TelemetryAttribute", ()=>TelemetryAttribute);
parcelHelpers.export(exports, "TelemetryFlagMetadata", ()=>TelemetryFlagMetadata);
parcelHelpers.export(exports, "TypeMismatchError", ()=>TypeMismatchError);
parcelHelpers.export(exports, "constructAggregateError", ()=>constructAggregateError);
parcelHelpers.export(exports, "createEvaluationEvent", ()=>createEvaluationEvent);
parcelHelpers.export(exports, "instantiateErrorByErrorCode", ()=>instantiateErrorByErrorCode);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "objectOrUndefined", ()=>objectOrUndefined);
parcelHelpers.export(exports, "statusMatchesEvent", ()=>statusMatchesEvent);
parcelHelpers.export(exports, "stringOrUndefined", ()=>stringOrUndefined);
parcelHelpers.export(exports, "throwAggregateErrorFromPromiseResults", ()=>throwAggregateErrorFromPromiseResults);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/hooks/hook-data.ts
var MapHookData = class {
    constructor(){
        this.data = /* @__PURE__ */ new Map();
    }
    set(key, value) {
        this.data.set(key, value);
    }
    get(key) {
        return this.data.get(key);
    }
    has(key) {
        return this.data.has(key);
    }
    delete(key) {
        return this.data.delete(key);
    }
    clear() {
        this.data.clear();
    }
};
// src/evaluation/evaluation.ts
var StandardResolutionReasons = {
    /**
   * The resolved value is static (no dynamic evaluation).
   */ STATIC: "STATIC",
    /**
   *  The resolved value was configured statically, or otherwise fell back to a pre-configured value.
   */ DEFAULT: "DEFAULT",
    /**
   * The resolved value was the result of a dynamic evaluation, such as a rule or specific user-targeting.
   */ TARGETING_MATCH: "TARGETING_MATCH",
    /**
   * The resolved value was the result of pseudorandom assignment.
   */ SPLIT: "SPLIT",
    /**
   * The resolved value was retrieved from cache.
   */ CACHED: "CACHED",
    /**
   * The resolved value was the result of the flag being disabled in the management system.
   */ DISABLED: "DISABLED",
    /**
   * The reason for the resolved value could not be determined.
   */ UNKNOWN: "UNKNOWN",
    /**
   * The resolved value is non-authoritative or possibly out of date.
   */ STALE: "STALE",
    /**
   * The resolved value was the result of an error.
   *
   * Note: The `errorCode` and `errorMessage` fields may contain additional details of this error.
   */ ERROR: "ERROR"
};
var ErrorCode = /* @__PURE__ */ ((ErrorCode2)=>{
    ErrorCode2["PROVIDER_NOT_READY"] = "PROVIDER_NOT_READY";
    ErrorCode2["PROVIDER_FATAL"] = "PROVIDER_FATAL";
    ErrorCode2["FLAG_NOT_FOUND"] = "FLAG_NOT_FOUND";
    ErrorCode2["PARSE_ERROR"] = "PARSE_ERROR";
    ErrorCode2["TYPE_MISMATCH"] = "TYPE_MISMATCH";
    ErrorCode2["TARGETING_KEY_MISSING"] = "TARGETING_KEY_MISSING";
    ErrorCode2["INVALID_CONTEXT"] = "INVALID_CONTEXT";
    ErrorCode2["GENERAL"] = "GENERAL";
    return ErrorCode2;
})(ErrorCode || {});
// src/errors/open-feature-error-abstract.ts
var OpenFeatureError = class _OpenFeatureError extends Error {
    constructor(message, options){
        super(message);
        Object.setPrototypeOf(this, _OpenFeatureError.prototype);
        this.name = "OpenFeatureError";
        this.cause = options == null ? void 0 : options.cause;
    }
};
// src/errors/flag-not-found-error.ts
var FlagNotFoundError = class _FlagNotFoundError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _FlagNotFoundError.prototype);
        this.name = "FlagNotFoundError";
        this.code = "FLAG_NOT_FOUND" /* FLAG_NOT_FOUND */ ;
    }
};
// src/errors/general-error.ts
var GeneralError = class _GeneralError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _GeneralError.prototype);
        this.name = "GeneralError";
        this.code = "GENERAL" /* GENERAL */ ;
    }
};
// src/errors/invalid-context-error.ts
var InvalidContextError = class _InvalidContextError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _InvalidContextError.prototype);
        this.name = "InvalidContextError";
        this.code = "INVALID_CONTEXT" /* INVALID_CONTEXT */ ;
    }
};
// src/errors/parse-error.ts
var ParseError = class _ParseError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _ParseError.prototype);
        this.name = "ParseError";
        this.code = "PARSE_ERROR" /* PARSE_ERROR */ ;
    }
};
// src/errors/provider-fatal-error.ts
var ProviderFatalError = class _ProviderFatalError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _ProviderFatalError.prototype);
        this.name = "ProviderFatalError";
        this.code = "PROVIDER_FATAL" /* PROVIDER_FATAL */ ;
    }
};
// src/errors/provider-not-ready-error.ts
var ProviderNotReadyError = class _ProviderNotReadyError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _ProviderNotReadyError.prototype);
        this.name = "ProviderNotReadyError";
        this.code = "PROVIDER_NOT_READY" /* PROVIDER_NOT_READY */ ;
    }
};
// src/errors/targeting-key-missing-error.ts
var TargetingKeyMissingError = class _TargetingKeyMissingError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _TargetingKeyMissingError.prototype);
        this.name = "TargetingKeyMissingError";
        this.code = "TARGETING_KEY_MISSING" /* TARGETING_KEY_MISSING */ ;
    }
};
// src/errors/type-mismatch-error.ts
var TypeMismatchError = class _TypeMismatchError extends OpenFeatureError {
    constructor(message, options){
        super(message, options);
        Object.setPrototypeOf(this, _TypeMismatchError.prototype);
        this.name = "TypeMismatchError";
        this.code = "TYPE_MISMATCH" /* TYPE_MISMATCH */ ;
    }
};
// src/errors/index.ts
var instantiateErrorByErrorCode = (errorCode, message)=>{
    switch(errorCode){
        case "FLAG_NOT_FOUND" /* FLAG_NOT_FOUND */ :
            return new FlagNotFoundError(message);
        case "PARSE_ERROR" /* PARSE_ERROR */ :
            return new ParseError(message);
        case "TYPE_MISMATCH" /* TYPE_MISMATCH */ :
            return new TypeMismatchError(message);
        case "TARGETING_KEY_MISSING" /* TARGETING_KEY_MISSING */ :
            return new TargetingKeyMissingError(message);
        case "INVALID_CONTEXT" /* INVALID_CONTEXT */ :
            return new InvalidContextError(message);
        case "PROVIDER_NOT_READY" /* PROVIDER_NOT_READY */ :
            return new ProviderNotReadyError(message);
        case "PROVIDER_FATAL" /* PROVIDER_FATAL */ :
            return new ProviderFatalError(message);
        default:
            return new GeneralError(message);
    }
};
// src/provider/provider.ts
var ServerProviderStatus = /* @__PURE__ */ ((ServerProviderStatus2)=>{
    ServerProviderStatus2["NOT_READY"] = "NOT_READY";
    ServerProviderStatus2["READY"] = "READY";
    ServerProviderStatus2["ERROR"] = "ERROR";
    ServerProviderStatus2["STALE"] = "STALE";
    ServerProviderStatus2["FATAL"] = "FATAL";
    return ServerProviderStatus2;
})(ServerProviderStatus || {});
var ClientProviderStatus = /* @__PURE__ */ ((ClientProviderStatus2)=>{
    ClientProviderStatus2["NOT_READY"] = "NOT_READY";
    ClientProviderStatus2["READY"] = "READY";
    ClientProviderStatus2["ERROR"] = "ERROR";
    ClientProviderStatus2["STALE"] = "STALE";
    ClientProviderStatus2["FATAL"] = "FATAL";
    ClientProviderStatus2["RECONCILING"] = "RECONCILING";
    return ClientProviderStatus2;
})(ClientProviderStatus || {});
// src/provider/multi-provider/errors.ts
var ErrorWithCode = class extends OpenFeatureError {
    constructor(code, message){
        super(message);
        this.code = code;
    }
};
var AggregateError = class _AggregateError extends GeneralError {
    constructor(message, originalErrors){
        super(message);
        this.originalErrors = originalErrors;
        Object.setPrototypeOf(this, _AggregateError.prototype);
        this.name = "AggregateError";
    }
};
var constructAggregateError = (providerErrors)=>{
    const errorsWithSource = providerErrors.map(({ providerName, error })=>{
        return {
            source: providerName,
            error
        };
    }).flat();
    const firstError = errorsWithSource[0];
    const message = firstError ? `Provider errors occurred: ${firstError.source}: ${firstError.error}` : "Provider errors occurred";
    return new AggregateError(message, errorsWithSource);
};
var throwAggregateErrorFromPromiseResults = (result, providerEntries)=>{
    const errors = result.map((r, i)=>{
        if (r.status === "rejected") return {
            error: r.reason,
            providerName: providerEntries[i].name
        };
        return null;
    }).filter((val)=>Boolean(val));
    if (errors.length) throw constructAggregateError(errors);
};
// src/provider/multi-provider/status-tracker.ts
var StatusTracker = class {
    constructor(events, statusEnum, eventEnum){
        this.events = events;
        this.statusEnum = statusEnum;
        this.eventEnum = eventEnum;
        this.providerStatuses = {};
    }
    wrapEventHandler(providerEntry) {
        var _a, _b, _c, _d, _e;
        const provider = providerEntry.provider;
        (_a = provider.events) == null || _a.addHandler(this.eventEnum.Error, (details)=>{
            this.changeProviderStatus(providerEntry.name, this.statusEnum.ERROR, details);
        });
        (_b = provider.events) == null || _b.addHandler(this.eventEnum.Stale, (details)=>{
            this.changeProviderStatus(providerEntry.name, this.statusEnum.STALE, details);
        });
        (_c = provider.events) == null || _c.addHandler(this.eventEnum.ConfigurationChanged, (details)=>{
            this.events.emit(this.eventEnum.ConfigurationChanged, details);
        });
        (_d = provider.events) == null || _d.addHandler(this.eventEnum.Ready, (details)=>{
            this.changeProviderStatus(providerEntry.name, this.statusEnum.READY, details);
        });
        const reconcilingEvent = this.eventEnum.Reconciling;
        const reconcilingStatus = this.statusEnum.RECONCILING;
        if (reconcilingEvent && reconcilingStatus) (_e = provider.events) == null || _e.addHandler(reconcilingEvent, (details)=>{
            this.changeProviderStatus(providerEntry.name, reconcilingStatus, details);
        });
    }
    providerStatus(name) {
        return this.providerStatuses[name];
    }
    getStatusFromProviderStatuses() {
        const statuses = Object.values(this.providerStatuses);
        if (statuses.includes(this.statusEnum.FATAL)) return this.statusEnum.FATAL;
        else if (statuses.includes(this.statusEnum.NOT_READY)) return this.statusEnum.NOT_READY;
        else if (statuses.includes(this.statusEnum.ERROR)) return this.statusEnum.ERROR;
        else if (statuses.includes(this.statusEnum.STALE)) return this.statusEnum.STALE;
        else if (this.statusEnum.RECONCILING && statuses.includes(this.statusEnum.RECONCILING)) return this.statusEnum.RECONCILING;
        return this.statusEnum.READY;
    }
    changeProviderStatus(name, status, details) {
        const currentStatus = this.getStatusFromProviderStatuses();
        this.providerStatuses[name] = status;
        const newStatus = this.getStatusFromProviderStatuses();
        if (currentStatus !== newStatus) {
            if (newStatus === this.statusEnum.FATAL || newStatus === this.statusEnum.ERROR) this.events.emit(this.eventEnum.Error, details);
            else if (newStatus === this.statusEnum.STALE) this.events.emit(this.eventEnum.Stale, details);
            else if (newStatus === this.statusEnum.READY) this.events.emit(this.eventEnum.Ready, details);
            else {
                const reconcilingEvent = this.eventEnum.Reconciling;
                if (reconcilingEvent && this.statusEnum.RECONCILING && newStatus === this.statusEnum.RECONCILING) this.events.emit(reconcilingEvent, details);
            }
        }
    }
};
// src/provider/multi-provider/strategies/base-evaluation-strategy.ts
var BaseEvaluationStrategy = class {
    constructor(statusEnum){
        this.statusEnum = statusEnum;
        this.runMode = "sequential";
    }
    shouldEvaluateThisProvider(strategyContext, _evalContext) {
        if (strategyContext.providerStatus === this.statusEnum.NOT_READY || strategyContext.providerStatus === this.statusEnum.FATAL) return false;
        return true;
    }
    shouldEvaluateNextProvider(_strategyContext, _context, _result) {
        return true;
    }
    shouldTrackWithThisProvider(strategyContext, _context, _trackingEventName, _trackingEventDetails) {
        if (strategyContext.providerStatus === this.statusEnum.NOT_READY || strategyContext.providerStatus === this.statusEnum.FATAL) return false;
        return true;
    }
    hasError(resolution) {
        return "thrownError" in resolution || !!resolution.details.errorCode;
    }
    hasErrorWithCode(resolution, code) {
        var _a;
        return "thrownError" in resolution ? ((_a = resolution.thrownError) == null ? void 0 : _a.code) === code : resolution.details.errorCode === code;
    }
    collectProviderErrors(resolutions) {
        var _a;
        const errors = [];
        for (const resolution of resolutions){
            if ("thrownError" in resolution) errors.push({
                providerName: resolution.providerName,
                error: resolution.thrownError
            });
            else if (resolution.details.errorCode) errors.push({
                providerName: resolution.providerName,
                error: new ErrorWithCode(resolution.details.errorCode, (_a = resolution.details.errorMessage) != null ? _a : "unknown error")
            });
        }
        return {
            errors
        };
    }
    resolutionToFinalResult(resolution) {
        return {
            details: resolution.details,
            provider: resolution.provider,
            providerName: resolution.providerName
        };
    }
};
// src/provider/multi-provider/strategies/first-match-strategy.ts
var FirstMatchStrategy = class extends BaseEvaluationStrategy {
    shouldEvaluateNextProvider(strategyContext, context, result) {
        if (this.hasErrorWithCode(result, "FLAG_NOT_FOUND" /* FLAG_NOT_FOUND */ )) return true;
        if (this.hasError(result)) return false;
        return false;
    }
    determineFinalResult(strategyContext, context, resolutions) {
        const finalResolution = resolutions[resolutions.length - 1];
        if (this.hasError(finalResolution)) return this.collectProviderErrors(resolutions);
        return this.resolutionToFinalResult(finalResolution);
    }
};
// src/provider/multi-provider/strategies/first-successful-strategy.ts
var FirstSuccessfulStrategy = class extends BaseEvaluationStrategy {
    shouldEvaluateNextProvider(strategyContext, context, result) {
        return this.hasError(result);
    }
    determineFinalResult(strategyContext, context, resolutions) {
        const finalResolution = resolutions[resolutions.length - 1];
        if (this.hasError(finalResolution)) return this.collectProviderErrors(resolutions);
        return this.resolutionToFinalResult(finalResolution);
    }
};
// src/provider/multi-provider/strategies/comparison-strategy.ts
var ComparisonStrategy = class extends BaseEvaluationStrategy {
    constructor(statusEnum, fallbackProvider, onMismatch){
        super(statusEnum);
        this.fallbackProvider = fallbackProvider;
        this.onMismatch = onMismatch;
        this.runMode = "parallel";
    }
    determineFinalResult(strategyContext, context, resolutions) {
        var _a;
        let value;
        let fallbackResolution;
        let finalResolution;
        let mismatch = false;
        for (const [i, resolution] of resolutions.entries()){
            if (this.hasError(resolution)) return this.collectProviderErrors(resolutions);
            if (resolution.provider === this.fallbackProvider) fallbackResolution = resolution;
            if (i === 0) finalResolution = resolution;
            if (typeof value !== "undefined" && value !== resolution.details.value) mismatch = true;
            else value = resolution.details.value;
        }
        if (!fallbackResolution) throw new GeneralError("Fallback provider not found in resolution results");
        if (!finalResolution) throw new GeneralError("Final resolution not found in resolution results");
        if (mismatch) {
            (_a = this.onMismatch) == null || _a.call(this, resolutions);
            return {
                details: fallbackResolution.details,
                provider: fallbackResolution.provider
            };
        }
        return this.resolutionToFinalResult(finalResolution);
    }
};
// src/events/events.ts
var ServerProviderEvents = /* @__PURE__ */ ((ServerProviderEvents2)=>{
    ServerProviderEvents2["Ready"] = "PROVIDER_READY";
    ServerProviderEvents2["Error"] = "PROVIDER_ERROR";
    ServerProviderEvents2["ConfigurationChanged"] = "PROVIDER_CONFIGURATION_CHANGED";
    ServerProviderEvents2["Stale"] = "PROVIDER_STALE";
    return ServerProviderEvents2;
})(ServerProviderEvents || {});
var ClientProviderEvents = /* @__PURE__ */ ((ClientProviderEvents2)=>{
    ClientProviderEvents2["Ready"] = "PROVIDER_READY";
    ClientProviderEvents2["Error"] = "PROVIDER_ERROR";
    ClientProviderEvents2["ConfigurationChanged"] = "PROVIDER_CONFIGURATION_CHANGED";
    ClientProviderEvents2["ContextChanged"] = "PROVIDER_CONTEXT_CHANGED";
    ClientProviderEvents2["Reconciling"] = "PROVIDER_RECONCILING";
    ClientProviderEvents2["Stale"] = "PROVIDER_STALE";
    return ClientProviderEvents2;
})(ClientProviderEvents || {});
// src/events/event-utils.ts
var eventStatusMap = {
    ["READY" /* READY */ ]: "PROVIDER_READY" /* Ready */ ,
    ["ERROR" /* ERROR */ ]: "PROVIDER_ERROR" /* Error */ ,
    ["FATAL" /* FATAL */ ]: "PROVIDER_ERROR" /* Error */ ,
    ["STALE" /* STALE */ ]: "PROVIDER_STALE" /* Stale */ ,
    ["RECONCILING" /* RECONCILING */ ]: "PROVIDER_RECONCILING" /* Reconciling */ ,
    ["NOT_READY" /* NOT_READY */ ]: void 0
};
var statusMatchesEvent = (event, status)=>{
    return !status && event === "PROVIDER_READY" /* Ready */  || eventStatusMap[status] === event;
};
// src/logger/default-logger.ts
var DefaultLogger = class {
    error(...args) {
        console.error(...args);
    }
    warn(...args) {
        console.warn(...args);
    }
    info() {}
    debug() {}
};
// src/logger/safe-logger.ts
var LOG_LEVELS = [
    "error",
    "warn",
    "info",
    "debug"
];
var SafeLogger = class {
    constructor(logger){
        this.fallbackLogger = new DefaultLogger();
        try {
            for (const level of LOG_LEVELS){
                if (!logger[level] || typeof logger[level] !== "function") throw new Error(`The provided logger is missing the ${level} method.`);
            }
            this.logger = logger;
        } catch (err) {
            console.error(err);
            console.error("Falling back to the default logger.");
            this.logger = this.fallbackLogger;
        }
    }
    error(...args) {
        this.log("error", ...args);
    }
    warn(...args) {
        this.log("warn", ...args);
    }
    info(...args) {
        this.log("info", ...args);
    }
    debug(...args) {
        this.log("debug", ...args);
    }
    log(level, ...args) {
        try {
            this.logger[level](...args);
        } catch (error) {
            this.fallbackLogger[level](...args);
        }
    }
};
// src/events/generic-event-emitter.ts
var GenericEventEmitter = class {
    constructor(globalLogger){
        this.globalLogger = globalLogger;
        this._handlers = {
            ["PROVIDER_CONFIGURATION_CHANGED" /* ConfigurationChanged */ ]: /* @__PURE__ */ new WeakMap(),
            ["PROVIDER_CONTEXT_CHANGED" /* ContextChanged */ ]: /* @__PURE__ */ new WeakMap(),
            ["PROVIDER_READY" /* Ready */ ]: /* @__PURE__ */ new WeakMap(),
            ["PROVIDER_ERROR" /* Error */ ]: /* @__PURE__ */ new WeakMap(),
            ["PROVIDER_STALE" /* Stale */ ]: /* @__PURE__ */ new WeakMap(),
            ["PROVIDER_RECONCILING" /* Reconciling */ ]: /* @__PURE__ */ new WeakMap()
        };
    }
    // here we use E, to restrict the events a provider can manually emit (PROVIDER_CONTEXT_CHANGED is emitted by the SDK)
    emit(eventType, context) {
        this.eventEmitter.emit(eventType, context);
    }
    addHandler(eventType, handler) {
        const asyncHandler = (details)=>__async(this, null, function*() {
                var _a;
                try {
                    yield handler(details);
                } catch (err) {
                    (_a = this._logger) == null || _a.error("Error running event handler:", err);
                }
            });
        const existingAsyncHandlers = this._handlers[eventType].get(handler);
        this._handlers[eventType].set(handler, [
            ...existingAsyncHandlers || [],
            asyncHandler
        ]);
        this.eventEmitter.on(eventType, asyncHandler);
    }
    removeHandler(eventType, handler) {
        const existingAsyncHandlers = this._handlers[eventType].get(handler);
        if (existingAsyncHandlers) {
            const removedAsyncHandler = existingAsyncHandlers.pop();
            if (removedAsyncHandler) this.eventEmitter.removeListener(eventType, removedAsyncHandler);
        }
    }
    removeAllHandlers(eventType) {
        if (eventType) this.eventEmitter.removeAllListeners(eventType);
        else this.eventEmitter.removeAllListeners();
    }
    getHandlers(eventType) {
        return this.eventEmitter.listeners(eventType);
    }
    setLogger(logger) {
        this._eventLogger = new SafeLogger(logger);
        return this;
    }
    get _logger() {
        var _a, _b;
        return (_b = this._eventLogger) != null ? _b : (_a = this.globalLogger) == null ? void 0 : _a.call(this);
    }
};
// src/telemetry/attributes.ts
var TelemetryAttribute = {
    /**
   * The lookup key of the feature flag.
   *
   * - type: `string`
   * - requirement level: `required`
   * - example: `logo-color`
   */ KEY: "feature_flag.key",
    /**
   * Describes a class of error the operation ended with.
   *
   * - type: `string`
   * - requirement level: `conditionally required`
   * - condition: `reason` is `error`
   * - example: `flag_not_found`
   */ ERROR_CODE: "error.type",
    /**
   * A message explaining the nature of an error occurring during flag evaluation.
   *
   * - type: `string`
   * - requirement level: `recommended`
   * - example: `Flag not found`
   */ ERROR_MESSAGE: "error.message",
    /**
   * A semantic identifier for an evaluated flag value.
   *
   * - type: `string`
   * - requirement level: `conditionally required`
   * - condition: variant is defined on the evaluation details
   * - example: `blue`; `on`; `true`
   */ VARIANT: "feature_flag.result.variant",
    /**
   * The evaluated value of the feature flag.
   *
   * - type: `undefined`
   * - requirement level: `conditionally required`
   * - example: `#ff0000`; `1`; `true`
   */ VALUE: "feature_flag.result.value",
    /**
   * The unique identifier for the flag evaluation context. For example, the targeting key.
   *
   * - type: `string`
   * - requirement level: `recommended`
   * - example: `5157782b-2203-4c80-a857-dbbd5e7761db`
   */ CONTEXT_ID: "feature_flag.context.id",
    /**
   * The reason code which shows how a feature flag value was determined.
   *
   * - type: `string`
   * - requirement level: `recommended`
   * - example: `targeting_match`
   */ REASON: "feature_flag.result.reason",
    /**
   * Describes a class of error the operation ended with.
   *
   * - type: `string`
   * - requirement level: `recommended`
   * - example: `flag_not_found`
   */ PROVIDER: "feature_flag.provider.name",
    /**
   * The identifier of the flag set to which the feature flag belongs.
   *
   * - type: `string`
   * - requirement level: `recommended`
   * - example: `proj-1`; `ab98sgs`; `service1/dev`
   */ FLAG_SET_ID: "feature_flag.set.id",
    /**
   * The version of the ruleset used during the evaluation. This may be any stable value which uniquely identifies the ruleset.
   *
   * - type: `string`
   * - requirement level: `recommended`
   * - example: `1.0.0`; `2021-01-01`
   */ VERSION: "feature_flag.version"
};
// src/telemetry/flag-metadata.ts
var TelemetryFlagMetadata = {
    /**
   * The context identifier returned in the flag metadata uniquely identifies
   * the subject of the flag evaluation. If not available, the targeting key
   * should be used.
   */ CONTEXT_ID: "contextId",
    /**
   * 	A logical identifier for the flag set.
   */ FLAG_SET_ID: "flagSetId",
    /**
   * 	A version string (format unspecified) for the flag or flag set.
   */ VERSION: "version"
};
// src/telemetry/evaluation-event.ts
var FLAG_EVALUATION_EVENT_NAME = "feature_flag.evaluation";
function createEvaluationEvent(hookContext, evaluationDetails) {
    var _a, _b, _c;
    const attributes = {
        [TelemetryAttribute.KEY]: hookContext.flagKey,
        [TelemetryAttribute.PROVIDER]: hookContext.providerMetadata.name,
        [TelemetryAttribute.REASON]: ((_a = evaluationDetails.reason) != null ? _a : StandardResolutionReasons.UNKNOWN).toLowerCase()
    };
    if (evaluationDetails.variant) attributes[TelemetryAttribute.VARIANT] = evaluationDetails.variant;
    if (evaluationDetails.value !== null) {
        if (typeof evaluationDetails.value !== "object") attributes[TelemetryAttribute.VALUE] = evaluationDetails.value;
        else try {
            attributes[TelemetryAttribute.VALUE] = JSON.stringify(evaluationDetails.value);
        } catch (e) {}
    }
    const contextId = (_b = evaluationDetails.flagMetadata[TelemetryFlagMetadata.CONTEXT_ID]) != null ? _b : hookContext.context.targetingKey;
    if (contextId) attributes[TelemetryAttribute.CONTEXT_ID] = contextId;
    const setId = evaluationDetails.flagMetadata[TelemetryFlagMetadata.FLAG_SET_ID];
    if (setId) attributes[TelemetryAttribute.FLAG_SET_ID] = setId;
    const version = evaluationDetails.flagMetadata[TelemetryFlagMetadata.VERSION];
    if (version) attributes[TelemetryAttribute.VERSION] = version;
    if (evaluationDetails.reason === StandardResolutionReasons.ERROR) {
        attributes[TelemetryAttribute.ERROR_CODE] = ((_c = evaluationDetails.errorCode) != null ? _c : "GENERAL" /* GENERAL */ ).toLowerCase();
        if (evaluationDetails.errorMessage) attributes[TelemetryAttribute.ERROR_MESSAGE] = evaluationDetails.errorMessage;
    }
    return {
        name: FLAG_EVALUATION_EVENT_NAME,
        attributes
    };
}
// src/type-guards.ts
function isString(value) {
    return typeof value === "string";
}
function stringOrUndefined(value) {
    return isString(value) ? value : void 0;
}
function isObject(value) {
    return typeof value === "object";
}
function objectOrUndefined(value) {
    return isObject(value) ? value : void 0;
}
// src/filter.ts
function isDefined(input) {
    return typeof input !== "undefined" && input !== null;
}
// src/open-feature.ts
var ProviderWrapper = class {
    constructor(_provider, _status, _statusEnumType){
        this._provider = _provider;
        this._status = _status;
        this._pendingContextChanges = 0;
        var _a, _b, _c;
        (_a = _provider.events) == null || _a.addHandler("PROVIDER_READY" /* Ready */ , ()=>{
            this._status = _statusEnumType.READY;
        });
        (_b = _provider.events) == null || _b.addHandler("PROVIDER_STALE" /* Stale */ , ()=>{
            this._status = _statusEnumType.STALE;
        });
        (_c = _provider.events) == null || _c.addHandler("PROVIDER_ERROR" /* Error */ , (details)=>{
            if ((details == null ? void 0 : details.errorCode) === "PROVIDER_FATAL" /* PROVIDER_FATAL */ ) this._status = _statusEnumType.FATAL;
            else this._status = _statusEnumType.ERROR;
        });
    }
    get provider() {
        return this._provider;
    }
    set provider(provider) {
        this._provider = provider;
    }
    get status() {
        return this._status;
    }
    set status(status) {
        this._status = status;
    }
    get allContextChangesSettled() {
        return this._pendingContextChanges === 0;
    }
    incrementPendingContextChanges() {
        this._pendingContextChanges++;
    }
    decrementPendingContextChanges() {
        this._pendingContextChanges--;
    }
};
var OpenFeatureCommonAPI = class {
    constructor(category){
        this._hooks = [];
        this._context = {};
        this._logger = new DefaultLogger();
        this._clientEventHandlers = /* @__PURE__ */ new Map();
        this._domainScopedContext = /* @__PURE__ */ new Map();
        this._clientEvents = /* @__PURE__ */ new Map();
        this._runsOn = category;
    }
    addHooks(...hooks) {
        this._hooks = [
            ...this._hooks,
            ...hooks
        ];
        return this;
    }
    getHooks() {
        return this._hooks;
    }
    clearHooks() {
        this._hooks = [];
        return this;
    }
    setLogger(logger) {
        this._logger = new SafeLogger(logger);
        return this;
    }
    /**
   * Get metadata about the default provider.
   * @returns {ProviderMetadata} Provider Metadata
   */ get providerMetadata() {
        return this.getProviderMetadata();
    }
    /**
   * Get metadata about a registered provider using the client name.
   * An unbound or empty client name will return metadata from the default provider.
   * @param {string} domain An identifier which logically binds clients with providers
   * @returns {ProviderMetadata} Provider Metadata
   */ getProviderMetadata(domain) {
        return this.getProviderForClient(domain).metadata;
    }
    /**
   * Adds a handler for the given provider event type.
   * The handlers are called in the order they have been added.
   * API (global) events run for all providers.
   * @param {AnyProviderEvent} eventType The provider event type to listen to
   * @param {EventHandler} handler The handler to run on occurrence of the event type
   * @param {EventOptions} options Optional options such as signal for aborting
   */ addHandler(eventType, handler, options) {
        [
            .../* @__PURE__ */ new Map([
                [
                    void 0,
                    this._defaultProvider
                ]
            ]),
            ...this._domainScopedProviders
        ].forEach((keyProviderTuple)=>{
            var _a;
            const domain = keyProviderTuple[0];
            const provider = keyProviderTuple[1].provider;
            const status = keyProviderTuple[1].status;
            const shouldRunNow = statusMatchesEvent(eventType, status);
            if (shouldRunNow) try {
                handler({
                    domain,
                    providerName: provider.metadata.name
                });
            } catch (err) {
                (_a = this._logger) == null || _a.error("Error running event handler:", err);
            }
        });
        this._apiEmitter.addHandler(eventType, handler);
        if ((options == null ? void 0 : options.signal) && typeof options.signal.addEventListener === "function") options.signal.addEventListener("abort", ()=>{
            this.removeHandler(eventType, handler);
        });
    }
    /**
   * Removes a handler for the given provider event type.
   * @param {AnyProviderEvent} eventType The provider event type to remove the listener for
   * @param {EventHandler} handler The handler to remove for the provider event type
   */ removeHandler(eventType, handler) {
        this._apiEmitter.removeHandler(eventType, handler);
    }
    /**
   * Removes all event handlers.
   */ clearHandlers() {
        this._apiEmitter.removeAllHandlers();
    }
    /**
   * Gets the current handlers for the given provider event type.
   * @param {AnyProviderEvent} eventType The provider event type to get the current handlers for
   * @returns {EventHandler[]} The handlers currently attached to the given provider event type
   */ getHandlers(eventType) {
        return this._apiEmitter.getHandlers(eventType);
    }
    setAwaitableProvider(domainOrProvider, providerOrUndefined) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const domain = stringOrUndefined(domainOrProvider);
        const provider = (_a = objectOrUndefined(domainOrProvider)) != null ? _a : objectOrUndefined(providerOrUndefined);
        if (!provider) {
            this._logger.debug("No provider defined, ignoring setProvider call");
            return;
        }
        const oldProvider = this.getProviderForClient(domain);
        const providerName = provider.metadata.name;
        if (oldProvider === provider) {
            this._logger.debug("Provider is already set, ignoring setProvider call");
            return;
        }
        if (!provider.runsOn) this._logger.debug(`Provider '${provider.metadata.name}' has not defined its intended use.`);
        else if (provider.runsOn !== this._runsOn) throw new GeneralError(`Provider '${provider.metadata.name}' is intended for use on the ${provider.runsOn}.`);
        const emitters = this.getAssociatedEventEmitters(domain);
        let initializationPromise = void 0;
        const wrappedProvider = new ProviderWrapper(provider, this._statusEnumType.NOT_READY, this._statusEnumType);
        if (typeof provider.initialize === "function" && !this.allProviders.includes(provider)) initializationPromise = (_e = (_d = (_c = provider.initialize) == null ? void 0 : _c.call(provider, domain ? (_b = this._domainScopedContext.get(domain)) != null ? _b : this._context : this._context)) == null ? void 0 : _d.then(()=>{
            var _a2;
            wrappedProvider.status = this._statusEnumType.READY;
            this.getAssociatedEventEmitters(domain).forEach((emitter)=>{
                emitter == null || emitter.emit("PROVIDER_READY" /* Ready */ , {
                    clientName: domain,
                    domain,
                    providerName
                });
            });
            (_a2 = this._apiEmitter) == null || _a2.emit("PROVIDER_READY" /* Ready */ , {
                clientName: domain,
                domain,
                providerName
            });
        })) == null ? void 0 : _e.catch((error)=>{
            var _a2;
            if ((error == null ? void 0 : error.code) === "PROVIDER_FATAL" /* PROVIDER_FATAL */ ) wrappedProvider.status = this._statusEnumType.FATAL;
            else wrappedProvider.status = this._statusEnumType.ERROR;
            this.getAssociatedEventEmitters(domain).forEach((emitter)=>{
                emitter == null || emitter.emit("PROVIDER_ERROR" /* Error */ , {
                    clientName: domain,
                    domain,
                    providerName,
                    message: error == null ? void 0 : error.message
                });
            });
            (_a2 = this._apiEmitter) == null || _a2.emit("PROVIDER_ERROR" /* Error */ , {
                clientName: domain,
                domain,
                providerName,
                message: error == null ? void 0 : error.message
            });
            throw error;
        });
        else {
            wrappedProvider.status = this._statusEnumType.READY;
            emitters.forEach((emitter)=>{
                emitter == null || emitter.emit("PROVIDER_READY" /* Ready */ , {
                    clientName: domain,
                    domain,
                    providerName
                });
            });
            (_f = this._apiEmitter) == null || _f.emit("PROVIDER_READY" /* Ready */ , {
                clientName: domain,
                domain,
                providerName
            });
        }
        if (domain) this._domainScopedProviders.set(domain, wrappedProvider);
        else this._defaultProvider = wrappedProvider;
        this.transferListeners(oldProvider, provider, domain, emitters);
        if (!this.allProviders.includes(oldProvider)) (_h = (_g = oldProvider == null ? void 0 : oldProvider.onClose) == null ? void 0 : _g.call(oldProvider)) == null || _h.catch((err)=>{
            this._logger.error(`error closing provider: ${err == null ? void 0 : err.message}, ${err == null ? void 0 : err.stack}`);
        });
        return initializationPromise;
    }
    getProviderForClient(domain) {
        var _a, _b;
        if (!domain) return this._defaultProvider.provider;
        return (_b = (_a = this._domainScopedProviders.get(domain)) == null ? void 0 : _a.provider) != null ? _b : this._defaultProvider.provider;
    }
    buildAndCacheEventEmitterForClient(domain) {
        const emitter = this._clientEvents.get(domain);
        if (emitter) return emitter;
        const newEmitter = this._createEventEmitter();
        this._clientEvents.set(domain, newEmitter);
        const clientProvider = this.getProviderForClient(domain);
        Object.values(ClientProviderEvents).forEach((eventType)=>{
            var _a;
            return (_a = clientProvider.events) == null ? void 0 : _a.addHandler(eventType, (details)=>__async(this, null, function*() {
                    newEmitter.emit(eventType, __spreadProps(__spreadValues({}, details), {
                        clientName: domain,
                        domain,
                        providerName: clientProvider.metadata.name
                    }));
                }));
        });
        return newEmitter;
    }
    getUnboundEmitters() {
        const domainScopedProviders = [
            ...this._domainScopedProviders.keys()
        ];
        const eventEmitterNames = [
            ...this._clientEvents.keys()
        ].filter(isDefined);
        const unboundEmitterNames = eventEmitterNames.filter((name)=>!domainScopedProviders.includes(name));
        return [
            // all unbound, named emitters
            ...unboundEmitterNames.map((name)=>this._clientEvents.get(name)),
            // the default emitter
            this._clientEvents.get(void 0)
        ].filter(isDefined);
    }
    getAssociatedEventEmitters(domain) {
        return domain ? [
            this.buildAndCacheEventEmitterForClient(domain)
        ] : this.getUnboundEmitters();
    }
    transferListeners(oldProvider, newProvider, domain, emitters) {
        var _a;
        (_a = this._clientEventHandlers.get(domain)) == null || _a.forEach((eventHandler)=>{
            var _a2;
            return (_a2 = oldProvider.events) == null ? void 0 : _a2.removeHandler(...eventHandler);
        });
        const newClientHandlers = Object.values(ClientProviderEvents).map((eventType)=>{
            const handler = (details)=>__async(this, null, function*() {
                    emitters.forEach((emitter)=>{
                        emitter == null || emitter.emit(eventType, __spreadProps(__spreadValues({}, details), {
                            clientName: domain,
                            domain,
                            providerName: newProvider.metadata.name
                        }));
                    });
                    this._apiEmitter.emit(eventType, __spreadProps(__spreadValues({}, details), {
                        clientName: domain,
                        domain,
                        providerName: newProvider.metadata.name
                    }));
                });
            return [
                eventType,
                handler
            ];
        });
        this._clientEventHandlers.set(domain, newClientHandlers);
        newClientHandlers.forEach((eventHandler)=>{
            var _a2;
            return (_a2 = newProvider.events) == null ? void 0 : _a2.addHandler(...eventHandler);
        });
    }
    close() {
        return __async(this, null, function*() {
            var _a, _b;
            try {
                yield (_b = (_a = this == null ? void 0 : this._defaultProvider.provider) == null ? void 0 : _a.onClose) == null ? void 0 : _b.call(_a);
            } catch (err) {
                this.handleShutdownError(this._defaultProvider.provider, err);
            }
            const wrappers = Array.from(this._domainScopedProviders);
            yield Promise.all(wrappers.map((_0)=>__async(this, [
                    _0
                ], function*([, wrapper]) {
                    var _a2, _b2;
                    try {
                        yield (_b2 = wrapper == null ? void 0 : (_a2 = wrapper.provider).onClose) == null ? void 0 : _b2.call(_a2);
                    } catch (err) {
                        this.handleShutdownError(wrapper == null ? void 0 : wrapper.provider, err);
                    }
                })));
        });
    }
    clearProvidersAndSetDefault(defaultProvider) {
        return __async(this, null, function*() {
            try {
                yield this.close();
            } catch (err) {
                this._logger.error("Unable to cleanly close providers. Resetting to the default configuration.");
            } finally{
                this._domainScopedProviders.clear();
                this._defaultProvider = new ProviderWrapper(defaultProvider, this._statusEnumType.NOT_READY, this._statusEnumType);
            }
        });
    }
    get allProviders() {
        return [
            ...[
                ...this._domainScopedProviders.values()
            ].map((wrappers)=>wrappers.provider),
            this._defaultProvider.provider
        ];
    }
    handleShutdownError(provider, err) {
        this._logger.error(`Error during shutdown of provider ${provider.metadata.name}: ${err}`);
        this._logger.error(err == null ? void 0 : err.stack);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"6h7CH":[function(require,module,exports) {
var parcelHelpers = require("9a12b8ebb588397d");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlagSource", ()=>s);
parcelHelpers.export(exports, "createFlagsmithInstance", ()=>I);
parcelHelpers.export(exports, "default", ()=>w);
var global = arguments[3];
var t = {
    getItemSync: function(t) {
        try {
            return localStorage.getItem(t) || null;
        } catch (t) {
            return null;
        }
    },
    getItem: function(t, e) {
        var n = this;
        return new Promise(function(i, a) {
            try {
                var o = n.getItemSync(t);
                null == e || e(null, o), i(o);
            } catch (t) {
                e && e(t, null), a(t);
            }
        });
    },
    setItem: function(t, e, n) {
        return new Promise(function(i, a) {
            try {
                localStorage.setItem(t, e), n && n(null, e), i(e);
            } catch (t) {
                n && n(t, null), a(t);
            }
        });
    }
}, e = function() {
    return e = Object.assign || function(t) {
        for(var e, n = 1, i = arguments.length; n < i; n++)for(var a in e = arguments[n])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        return t;
    }, e.apply(this, arguments);
};
function n(t, e, n, i) {
    return new (n || (n = Promise))(function(a, o) {
        function r(t) {
            try {
                l(i.next(t));
            } catch (t) {
                o(t);
            }
        }
        function s(t) {
            try {
                l(i.throw(t));
            } catch (t) {
                o(t);
            }
        }
        function l(t) {
            var e;
            t.done ? a(t.value) : (e = t.value, e instanceof n ? e : new n(function(t) {
                t(e);
            })).then(r, s);
        }
        l((i = i.apply(t, e || [])).next());
    });
}
function i(t, e) {
    var n, i, a, o, r = {
        label: 0,
        sent: function() {
            if (1 & a[0]) throw a[1];
            return a[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(o) {
        return function(s) {
            return function(o) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; r;)try {
                    if (n = 1, i && (a = 2 & o[0] ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
                    switch(i = 0, a && (o = [
                        2 & o[0],
                        a.value
                    ]), o[0]){
                        case 0:
                        case 1:
                            a = o;
                            break;
                        case 4:
                            return r.label++, {
                                value: o[1],
                                done: !1
                            };
                        case 5:
                            r.label++, i = o[1], o = [
                                0
                            ];
                            continue;
                        case 7:
                            o = r.ops.pop(), r.trys.pop();
                            continue;
                        default:
                            if (!(a = r.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                r = 0;
                                continue;
                            }
                            if (3 === o[0] && (!a || o[1] > a[0] && o[1] < a[3])) {
                                r.label = o[1];
                                break;
                            }
                            if (6 === o[0] && r.label < a[1]) {
                                r.label = a[1], a = o;
                                break;
                            }
                            if (a && r.label < a[2]) {
                                r.label = a[2], r.ops.push(o);
                                break;
                            }
                            a[2] && r.ops.pop(), r.trys.pop();
                            continue;
                    }
                    o = e.call(t, r);
                } catch (t) {
                    o = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    n = a = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                };
            }([
                o,
                s
            ]);
        };
    }
}
function a(t, e, n) {
    if (n || 2 === arguments.length) for(var i, a = 0, o = e.length; a < o; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}
var o = function t(e, n) {
    if (e === n) return !0;
    if (e && n && "object" == typeof e && "object" == typeof n) {
        if (e.constructor !== n.constructor) return !1;
        var i, a, o;
        if (Array.isArray(e)) {
            if ((i = e.length) != n.length) return !1;
            for(a = i; 0 != a--;)if (!t(e[a], n[a])) return !1;
            return !0;
        }
        if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
        if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
        if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
        if ((i = (o = Object.keys(e)).length) !== Object.keys(n).length) return !1;
        for(a = i; 0 != a--;)if (!Object.prototype.hasOwnProperty.call(n, o[a])) return !1;
        for(a = i; 0 != a--;){
            var r = o[a];
            if (!t(e[r], n[r])) return !1;
        }
        return !0;
    }
    return e != e && n != n;
};
function r(t, e) {
    var n = Object.keys(e || {}).filter(function(n) {
        var i = null == t ? void 0 : t[n], a = null == e ? void 0 : e[n];
        return !o(i, a);
    });
    return Object.keys(t || {}).filter(function(t) {
        Object.keys(e || {}).includes(t) || n.push(t);
    }), Object.keys(n).length ? n : null;
}
var s, l;
function u(t, e, n) {
    var i = "shortString", a = !0;
    "number" == typeof n && (i = "javaDouble", a = !1), t[i] = t[i] || {}, t[i][e] = a ? n + "" : n;
}
function c(t) {
    return !!t && "object" == typeof t && void 0 !== t.value;
}
function v(t) {
    return Object.fromEntries(Object.entries(t).map(function(t) {
        var e = t[0], n = t[1];
        return [
            e,
            c(n) ? n : {
                value: n
            }
        ];
    }));
}
function d(t) {
    return e(e({}, t), {
        identity: t.identity ? e(e({}, t.identity), {
            traits: v(t.identity.traits || {})
        }) : void 0
    });
}
!function(t) {
    t.NONE = "NONE", t.DEFAULT_FLAGS = "DEFAULT_FLAGS", t.CACHE = "CACHE", t.SERVER = "SERVER";
}(s || (s = {}));
var h, g = null, f = "FLAGSMITH_EVENT", p = "https://edge.api.flagsmith.com/api/v1/", y = function() {
    function t(t) {
        var n = this;
        this._trigger = null, this._triggerLoadingState = null, this.timestamp = null, this.isLoading = !1, this.eventSource = null, this.getFlags = function() {
            var t = n, i = t.api, a = t.evaluationContext;
            n.log("Get Flags"), n.isLoading = !0, n.loadingState.isFetching || n.setLoadingState(e(e({}, n.loadingState), {
                isFetching: !0
            }));
            var o = "".concat(n.getContext().identity), l = function(t) {
                var i, a, l, c;
                if (t && o === "".concat(n.getContext().identity)) {
                    var v = t.flags, d = t.traits, h = t.identifier;
                    n.isLoading = !1;
                    var g = {}, f = {};
                    d = d || [], (v = v || []).forEach(function(t) {
                        g[t.feature.name.toLowerCase().replace(/ /g, "_")] = {
                            id: t.feature.id,
                            enabled: t.enabled,
                            value: t.feature_state_value
                        };
                    }), d.forEach(function(t) {
                        f[t.trait_key.toLowerCase().replace(/ /g, "_")] = {
                            transient: t.transient,
                            value: t.trait_value
                        };
                    }), n.oldFlags = e({}, n.flags);
                    var p = r(n.oldFlags, g), y = r(null === (i = n.evaluationContext.identity) || void 0 === i ? void 0 : i.traits, f);
                    if ((h || Object.keys(f).length) && (n.evaluationContext.identity = e(e({}, n.evaluationContext.identity), {
                        traits: f
                    }), h && (n.evaluationContext.identity.identifier = h, n.identity = h)), n.flags = g, n.updateStorage(), n._onChange(n.oldFlags, {
                        isFromServer: !0,
                        flagsChanged: p,
                        traitsChanged: y
                    }, n._loadedState(null, s.SERVER)), n.datadogRum) try {
                        if (n.datadogRum.trackTraits) {
                            var m = {};
                            Object.keys((null === (a = n.evaluationContext.identity) || void 0 === a ? void 0 : a.traits) || {}).map(function(t) {
                                m["flagsmith_trait_" + t] = n.getTrait(t);
                            });
                            var S = e(e(e({}, n.datadogRum.client.getUser()), {
                                id: n.datadogRum.client.getUser().id || (null === (l = n.evaluationContext.identity) || void 0 === l ? void 0 : l.identifier)
                            }), m);
                            n.log("Setting Datadog user", S), n.datadogRum.client.setUser(S);
                        }
                    } catch (t) {
                        console.error(t);
                    }
                    if (n.dtrum) try {
                        var C = {
                            javaDouble: {},
                            date: {},
                            shortString: {},
                            javaLongOrObject: {}
                        };
                        Object.keys(n.flags).map(function(t) {
                            u(C, "flagsmith_value_" + t, n.getValue(t, {
                                skipAnalytics: !0
                            })), u(C, "flagsmith_enabled_" + t, n.hasFeature(t, {
                                skipAnalytics: !0
                            }));
                        }), Object.keys((null === (c = n.evaluationContext.identity) || void 0 === c ? void 0 : c.traits) || {}).map(function(t) {
                            u(C, "flagsmith_trait_" + t, n.getTrait(t));
                        }), n.log("Sending javaLongOrObject traits to dynatrace", C.javaLongOrObject), n.log("Sending date traits to dynatrace", C.date), n.log("Sending shortString traits to dynatrace", C.shortString), n.log("Sending javaDouble to dynatrace", C.javaDouble), n.dtrum.sendSessionProperties(C.javaLongOrObject, C.date, C.shortString, C.javaDouble);
                    } catch (t) {
                        console.error(t);
                    }
                }
            };
            return a.identity ? Promise.all([
                a.identity.traits && Object.keys(a.identity.traits).length || !a.identity.identifier ? n.getJSON(i + "identities/", "POST", JSON.stringify({
                    identifier: a.identity.identifier,
                    transient: a.identity.transient,
                    traits: Object.entries(a.identity.traits).map(function(t) {
                        var e = t[0], n = t[1];
                        return {
                            trait_key: e,
                            trait_value: null == n ? void 0 : n.value,
                            transient: null == n ? void 0 : n.transient
                        };
                    }).filter(function(t) {
                        return void 0 !== t.trait_value || (n.log("Warning - attempted to set an undefined trait value for key", t.trait_key), !1);
                    })
                })) : n.getJSON(i + "identities/?identifier=" + encodeURIComponent(a.identity.identifier) + (a.identity.transient ? "&transient=true" : ""))
            ]).then(function(t) {
                return n.evaluationContext.identity = e(e({}, n.evaluationContext.identity), {
                    traits: {}
                }), l(null == t ? void 0 : t[0]);
            }).catch(function(t) {
                var e = t.message, n = new Error(e);
                return Promise.reject(n);
            }) : n.getJSON(i + "flags/").then(function(t) {
                return l({
                    flags: t,
                    traits: void 0
                });
            });
        }, this.analyticsFlags = function() {
            var t = n.api;
            if (n.evaluationEvent && n.evaluationContext.environment && n.evaluationEvent[n.evaluationContext.environment.apiKey]) return n.evaluationEvent && 0 !== Object.getOwnPropertyNames(n.evaluationEvent).length && 0 !== Object.getOwnPropertyNames(n.evaluationEvent[n.evaluationContext.environment.apiKey]).length ? n.getJSON(t + "analytics/flags/", "POST", JSON.stringify(n.evaluationEvent[n.evaluationContext.environment.apiKey])).then(function(t) {
                if (n.evaluationContext.environment) {
                    var i = n.getState();
                    n.evaluationEvent || (n.evaluationEvent = {}), n.evaluationEvent[n.evaluationContext.environment.apiKey] = {}, n.setState(e(e({}, i), {
                        evaluationEvent: n.evaluationEvent
                    })), n.updateEventStorage();
                }
            }).catch(function(t) {
                n.log("Exception fetching evaluationEvent", t);
            }) : void 0;
        }, this.datadogRum = null, this.loadingState = {
            isLoading: !0,
            isFetching: !0,
            error: null,
            source: s.NONE
        }, this.canUseStorage = !1, this.analyticsInterval = null, this.api = null, this.cacheFlags = !1, this.enableAnalytics = !1, this.enableLogs = !1, this.evaluationContext = {}, this.evaluationEvent = null, this.flags = null, this.getFlagInterval = null, this.headers = null, this.identity = null, this.initialised = !1, this.oldFlags = null, this.onChange = null, this.onError = null, this.ticks = null, this.timer = null, this.dtrum = null, this.sentryClient = null, this.withTraits = null, this.cacheOptions = {
            ttl: 0,
            skipAPI: !1,
            loadStale: !1,
            storageKey: void 0
        }, this.getValue = function(t, e, i) {
            var a = n.flags && n.flags[t.toLowerCase().replace(/ /g, "_")], o = null;
            if (a && (o = a.value), (null == e ? void 0 : e.skipAnalytics) || i || n.evaluateFlag(t, "VALUE"), null === o && void 0 !== (null == e ? void 0 : e.fallback)) return e.fallback;
            if (null == e ? void 0 : e.json) try {
                return null === o ? (n.log("Tried to parse null flag as JSON: " + t), null) : JSON.parse(o);
            } catch (t) {
                return e.fallback;
            }
            return o;
        }, this.getTrait = function(t) {
            var e, i;
            return (null === (e = n.evaluationContext.identity) || void 0 === e ? void 0 : e.traits) && (null === (i = n.evaluationContext.identity.traits[t.toLowerCase().replace(/ /g, "_")]) || void 0 === i ? void 0 : i.value);
        }, this.getAllTraits = function() {
            var t;
            return Object.fromEntries(Object.entries((null === (t = n.evaluationContext.identity) || void 0 === t ? void 0 : t.traits) || {}).map(function(t) {
                var e = t[0], n = t[1];
                return [
                    e,
                    null == n ? void 0 : n.value
                ];
            }));
        }, this.setContext = function(t) {
            var i, a, o = d(t);
            return n.evaluationContext = e(e({}, o), {
                environment: o.environment || n.evaluationContext.environment
            }), n.identity = null === (a = null === (i = n.getContext()) || void 0 === i ? void 0 : i.identity) || void 0 === a ? void 0 : a.identifier, n.initialised ? n.getFlags() : Promise.resolve();
        }, this.getContext = function() {
            return n.evaluationContext;
        }, this.updateContext = function(t) {
            return n.setContext(e(e({}, n.getContext()), t));
        }, this.setTrait = function(t, i) {
            var a;
            if (n.api) return n.setContext(e(e({}, n.evaluationContext), {
                identity: e(e({}, n.evaluationContext.identity), {
                    traits: e(e({}, null === (a = n.evaluationContext.identity) || void 0 === a ? void 0 : a.traits), v(Object.fromEntries([
                        [
                            t,
                            i
                        ]
                    ])))
                })
            }));
        }, this.setTraits = function(t) {
            var i;
            if (n.api) return n.setContext(e(e({}, n.evaluationContext), {
                identity: e(e({}, n.evaluationContext.identity), {
                    traits: e(e({}, null === (i = n.evaluationContext.identity) || void 0 === i ? void 0 : i.traits), Object.fromEntries(Object.entries(t).map(function(t) {
                        var e = t[0], n = t[1];
                        return [
                            e,
                            c(n) ? n : {
                                value: n
                            }
                        ];
                    })))
                })
            }));
            console.error("Attempted to setTraits a user before calling flagsmith.init. Call flagsmith.init first, if you wish to prevent it sending a request for flags, call init with preventFetch:true.");
        }, this.hasFeature = function(t, e) {
            var i, a, o = "object" == typeof e, r = n.flags && n.flags[t.toLowerCase().replace(/ /g, "_")], s = !1;
            if (!r && o && void 0 !== e.fallback ? s = null == e ? void 0 : e.fallback : r && r.enabled && (s = !0), (o && !e.skipAnalytics || !e) && n.evaluateFlag(t, "ENABLED"), n.sentryClient) try {
                null === (a = null === (i = n.sentryClient.getIntegrationByName("FeatureFlags")) || void 0 === i ? void 0 : i.addFeatureFlag) || void 0 === a || a.call(i, t, s);
            } catch (t) {
                console.error(t);
            }
            return s;
        }, this.getStorageKey = function() {
            var t, e;
            return (null === (t = n.cacheOptions) || void 0 === t ? void 0 : t.storageKey) || "FLAGSMITH_DB_" + (null === (e = n.evaluationContext.environment) || void 0 === e ? void 0 : e.apiKey);
        }, this.getJSON = function(t, e, i) {
            var a, o, r, s = n.headers, u = {
                method: e || "GET",
                body: i,
                cache: "no-cache",
                headers: {}
            };
            n.evaluationContext.environment && (u.headers["X-Environment-Key"] = n.evaluationContext.environment.apiKey), e && "GET" !== e && (u.headers["Content-Type"] = "application/json; charset=utf-8"), (null === (a = n.applicationMetadata) || void 0 === a ? void 0 : a.name) && (u.headers["Flagsmith-Application-Name"] = n.applicationMetadata.name), (null === (o = n.applicationMetadata) || void 0 === o ? void 0 : o.version) && (u.headers["Flagsmith-Application-Version"] = n.applicationMetadata.version), s && Object.assign(u.headers, s), l || console.error("Flagsmith: fetch is undefined, please specify a fetch implementation into flagsmith.init to support SSR.");
            var c = "".concat(null === (r = n.evaluationContext.identity) || void 0 === r ? void 0 : r.identifier);
            return l(t, u).then(function(i) {
                var a, o, r = "".concat(null === (a = n.evaluationContext.identity) || void 0 === a ? void 0 : a.identifier);
                if (c === r) {
                    var s = null === (o = i.headers) || void 0 === o ? void 0 : o.get("x-flagsmith-document-updated-at");
                    if (s) try {
                        var l = parseFloat(s);
                        if (isNaN(l)) return Promise.reject("Failed to parse x-flagsmith-document-updated-at");
                        n.timestamp = l;
                    } catch (t) {
                        n.log(t, "Failed to parse x-flagsmith-document-updated-at", s);
                    }
                    return n.log("Fetch response: " + i.status + " " + (e || "GET") + 0 + t), i.text().then(function(t) {
                        var e = t;
                        try {
                            e = JSON.parse(t);
                        } catch (t) {}
                        return !e && i.status && (e = "API Response: ".concat(i.status)), i.status && i.status >= 200 && i.status < 300 ? e : Promise.reject(new Error(e));
                    });
                }
                n.log("Received response with identity mismatch, ignoring response. Requested: ".concat(c, ", Current: ").concat(r));
            });
        }, this.evaluateFlag = function(t, e) {
            if (n.datadogRum && (n.datadogRum.client.addFeatureFlagEvaluation ? "VALUE" === e ? n.datadogRum.client.addFeatureFlagEvaluation("flagsmith_value_" + t, n.getValue(t, {}, !0)) : n.datadogRum.client.addFeatureFlagEvaluation("flagsmith_enabled_" + t, n.hasFeature(t, !0)) : console.error("Flagsmith: Your datadog RUM client does not support the function addFeatureFlagEvaluation, please update it.")), n.enableAnalytics) {
                if (!n.evaluationEvent || !n.evaluationContext.environment) return;
                n.evaluationEvent[n.evaluationContext.environment.apiKey] || (n.evaluationEvent[n.evaluationContext.environment.apiKey] = {}), void 0 === n.evaluationEvent[n.evaluationContext.environment.apiKey][t] && (n.evaluationEvent[n.evaluationContext.environment.apiKey][t] = 0), n.evaluationEvent[n.evaluationContext.environment.apiKey][t] += 1;
            }
            n.updateEventStorage();
        }, this._onChange = function(t, e, i) {
            var a, o;
            n.setLoadingState(i), null === (a = n.onChange) || void 0 === a || a.call(n, t, e, n.loadingState), null === (o = n._trigger) || void 0 === o || o.call(n);
        }, l = t.fetch ? t.fetch : "undefined" != typeof fetch ? fetch : null === global || void 0 === global ? void 0 : global.fetch, this.canUseStorage = "undefined" != typeof window || !!t.browserlessStorage, this.applicationMetadata = t.applicationMetadata, this.log("Constructing flagsmith instance " + t), t.eventSource && (h = t.eventSource), t.AsyncStorage && (g = t.AsyncStorage);
    }
    return t.prototype.init = function(t) {
        var a, o, u;
        return n(this, void 0, void 0, function() {
            var c, v, h, y, m, S, C, _, b, E, x, O, F, w, I, L, A, j, k, T, N, P, R, K, D, U, G, J, M, H, V, q, B, W, X = this;
            return i(this, function(Y) {
                switch(Y.label){
                    case 0:
                        c = d(t.evaluationContext || this.evaluationContext), Y.label = 1;
                    case 1:
                        if (Y.trys.push([
                            1,
                            13,
                            ,
                            14
                        ]), v = t.AsyncStorage, h = t._trigger, y = t._triggerLoadingState, m = t.angularHttpClient, S = t.api, C = void 0 === S ? p : S, _ = t.applicationMetadata, b = t.cacheFlags, E = t.cacheOptions, x = t.datadogRum, O = t.defaultFlags, F = t.enableAnalytics, w = t.enableDynatrace, I = t.enableLogs, L = t.environmentID, A = t.eventSourceUrl, j = void 0 === A ? "https://realtime.flagsmith.com/" : A, k = t.fetch, T = t.headers, N = t.identity, P = t.onChange, R = t.onError, K = t.preventFetch, D = t.realtime, U = t.sentryClient, G = t.state, J = t.traits, c.environment = L ? {
                            apiKey: L
                        } : c.environment, !c.environment || !c.environment.apiKey) throw new Error("Please provide `evaluationContext.environment` with non-empty `apiKey`");
                        if (c.identity = N || J ? {
                            identifier: N,
                            traits: J ? Object.fromEntries(Object.entries(J).map(function(t) {
                                return [
                                    t[0],
                                    {
                                        value: t[1]
                                    }
                                ];
                            })) : {}
                        } : c.identity, this.evaluationContext = c, this.api = ($ = C).endsWith("/") ? $ : $ + "/", this.headers = T, this.getFlagInterval = null, this.analyticsInterval = null, this.onChange = P, M = "Wrong Flagsmith Configuration: preventFetch is true and no defaulFlags provided", this._trigger = h || this._trigger, this._triggerLoadingState = y || this._triggerLoadingState, this.onError = function(t) {
                            X.setLoadingState(e(e({}, X.loadingState), {
                                isFetching: !1,
                                isLoading: !1,
                                error: t
                            })), null == R || R(t);
                        }, this.enableLogs = I || !1, this.cacheOptions = E ? {
                            skipAPI: !!E.skipAPI,
                            ttl: E.ttl || 0,
                            storageKey: E.storageKey,
                            loadStale: !!E.loadStale
                        } : this.cacheOptions, !this.cacheOptions.ttl && this.cacheOptions.skipAPI && console.warn("Flagsmith: you have set a cache ttl of 0 and are skipping API calls, this means the API will not be hit unless you clear local storage."), k && (l = k), this.enableAnalytics = F || !1, this.flags = Object.assign({}, O) || {}, this.datadogRum = x || null, this.initialised = !0, this.ticks = 1e4, this.timer = this.enableLogs ? (new Date).valueOf() : null, this.cacheFlags = void 0 !== g && !!b, this.applicationMetadata = _, f = "FLAGSMITH_EVENT_" + c.environment.apiKey, v && (g = v), D && "undefined" != typeof window && this.setupRealtime(j, c.environment.apiKey), Object.keys(this.flags).length && (this.loadingState = e(e({}, this.loadingState), {
                            isLoading: !1,
                            source: s.DEFAULT_FLAGS
                        })), this.setState(G), this.log("Initialising with properties", t, this), w && ("undefined" == typeof dtrum ? console.error("You have attempted to enable dynatrace but dtrum is undefined, please check you have the Dynatrace RUM JavaScript API installed.") : this.dtrum = dtrum), U && (this.sentryClient = U), m && (l = function(t) {
                            return function(e, n) {
                                var i = n.headers, a = n.method, o = n.body, r = {
                                    headers: i,
                                    observe: "response",
                                    responseType: "text"
                                }, s = function(t, e) {
                                    var n = t.status, i = t.headers, a = t.body, o = t.error, r = t.message;
                                    return {
                                        status: null != n ? n : e ? 200 : 500,
                                        ok: e,
                                        headers: {
                                            get: function(t) {
                                                var e, n;
                                                return null !== (n = null === (e = null == i ? void 0 : i.get) || void 0 === e ? void 0 : e.call(i, t)) && void 0 !== n ? n : null;
                                            }
                                        },
                                        text: function() {
                                            var t, e, n = null !== (e = null !== (t = null != a ? a : o) && void 0 !== t ? t : r) && void 0 !== e ? e : "";
                                            return Promise.resolve("string" != typeof n ? JSON.stringify(n) : n);
                                        }
                                    };
                                };
                                return new Promise(function(n) {
                                    var i = function(t) {
                                        return n(s(t, !t.status || t.status >= 200 && t.status < 300));
                                    }, l = function(t) {
                                        return n(s(t, !1));
                                    };
                                    switch(a){
                                        case "GET":
                                            return t.get(e, r).subscribe(i, l);
                                        case "POST":
                                        case "PUT":
                                            return t.post(e, null != o ? o : "", r).subscribe(i, l);
                                        default:
                                            return l({
                                                status: 405,
                                                message: "Unsupported method: ".concat(a)
                                            });
                                    }
                                });
                            };
                        }(m)), g && this.canUseStorage && g.getItem(f).then(function(t) {
                            try {
                                X.evaluationEvent = JSON.parse(t) || {};
                            } catch (t) {
                                X.evaluationEvent = {};
                            }
                            X.analyticsInterval = setInterval(X.analyticsFlags, X.ticks);
                        }), this.enableAnalytics && (this.analyticsInterval && clearInterval(this.analyticsInterval), g && this.canUseStorage && g.getItem(f, function(t, n) {
                            if (n && X.evaluationContext.environment) {
                                var i = JSON.parse(n);
                                if (i[X.evaluationContext.environment.apiKey]) {
                                    var a = X.getState();
                                    X.log("Retrieved events from cache", n), X.setState(e(e({}, a), {
                                        evaluationEvent: i[X.evaluationContext.environment.apiKey]
                                    }));
                                }
                            }
                        })), !b) return [
                            3,
                            9
                        ];
                        if (!g || !this.canUseStorage) return [
                            3,
                            8
                        ];
                        H = function(t, a) {
                            return n(X, void 0, void 0, function() {
                                var t, n, o, l, u, c, v, h, g, f, p, y, m, S, C, _, b, E, x, F = this;
                                return i(this, function(i) {
                                    switch(i.label){
                                        case 0:
                                            if (!a) return [
                                                3,
                                                7
                                            ];
                                            t = null, n = null, i.label = 1;
                                        case 1:
                                            return i.trys.push([
                                                1,
                                                5,
                                                ,
                                                6
                                            ]), o = JSON.parse(a), l = !1, u = !1, o && o.api === this.api && (null === (f = null === (g = o.evaluationContext) || void 0 === g ? void 0 : g.environment) || void 0 === f ? void 0 : f.apiKey) === (null === (p = this.evaluationContext.environment) || void 0 === p ? void 0 : p.apiKey) && (c = !0, this.evaluationContext.identity && (null === (m = null === (y = o.evaluationContext) || void 0 === y ? void 0 : y.identity) || void 0 === m ? void 0 : m.identifier) !== this.evaluationContext.identity.identifier && (this.log("Ignoring cache, identity has changed from " + (null === (C = null === (S = o.evaluationContext) || void 0 === S ? void 0 : S.identity) || void 0 === C ? void 0 : C.identifier) + " to " + this.evaluationContext.identity.identifier), c = !1), this.cacheOptions.ttl && (!o.ts || (new Date).valueOf() - o.ts > this.cacheOptions.ttl) && (o.ts && !this.cacheOptions.loadStale ? (this.log("Ignoring cache, timestamp is too old ts:" + o.ts + " ttl: " + this.cacheOptions.ttl + " time elapsed since cache: " + ((new Date).valueOf() - o.ts) + "ms"), c = !1) : o.ts && this.cacheOptions.loadStale && (this.log("Loading stale cache, timestamp ts:" + o.ts + " ttl: " + this.cacheOptions.ttl + " time elapsed since cache: " + ((new Date).valueOf() - o.ts) + "ms"), u = !0, c = !0)), c && (l = !0, t = r(this.flags, o.flags), this.setState(e(e({}, o), {
                                                evaluationContext: d(e(e({}, o.evaluationContext), {
                                                    identity: (null === (_ = o.evaluationContext) || void 0 === _ ? void 0 : _.identity) ? e(e({}, null === (b = o.evaluationContext) || void 0 === b ? void 0 : b.identity), {
                                                        traits: e({}, J || {})
                                                    }) : void 0
                                                }))
                                            })), this.log("Retrieved flags from cache", o))), l ? (v = !K && (!this.cacheOptions.skipAPI || u), this._onChange(null, {
                                                isFromServer: !1,
                                                flagsChanged: t,
                                                traitsChanged: n
                                            }, this._loadedState(null, s.CACHE, v)), this.oldFlags = this.flags, this.cacheOptions.skipAPI && l && !u && this.log("Skipping API, using cache"), v && this.getFlags().catch(function(t) {
                                                var e;
                                                null === (e = F.onError) || void 0 === e || e.call(F, t);
                                            }), [
                                                3,
                                                4
                                            ]) : [
                                                3,
                                                2
                                            ];
                                        case 2:
                                            return K ? [
                                                3,
                                                4
                                            ] : [
                                                4,
                                                this.getFlags()
                                            ];
                                        case 3:
                                            i.sent(), i.label = 4;
                                        case 4:
                                            return [
                                                3,
                                                6
                                            ];
                                        case 5:
                                            return h = i.sent(), this.log("Exception fetching cached logs", h), [
                                                3,
                                                6
                                            ];
                                        case 6:
                                            return [
                                                3,
                                                10
                                            ];
                                        case 7:
                                            return K ? [
                                                3,
                                                9
                                            ] : [
                                                4,
                                                this.getFlags()
                                            ];
                                        case 8:
                                            return i.sent(), [
                                                3,
                                                10
                                            ];
                                        case 9:
                                            if (O) this._onChange(null, {
                                                isFromServer: !1,
                                                flagsChanged: r({}, this.flags),
                                                traitsChanged: r({}, null === (E = this.evaluationContext.identity) || void 0 === E ? void 0 : E.traits)
                                            }, this._loadedState(null, s.DEFAULT_FLAGS));
                                            else {
                                                if (!this.flags) throw new Error(M);
                                                this._onChange(null, {
                                                    isFromServer: !1,
                                                    flagsChanged: r({}, this.flags),
                                                    traitsChanged: r({}, null === (x = this.evaluationContext.identity) || void 0 === x ? void 0 : x.traits)
                                                }, this._loadedState(null, s.DEFAULT_FLAGS));
                                            }
                                            i.label = 10;
                                        case 10:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, Y.label = 2;
                    case 2:
                        return Y.trys.push([
                            2,
                            7,
                            ,
                            8
                        ]), g.getItemSync ? (V = g.getItemSync(this.getStorageKey()), [
                            3,
                            5
                        ]) : [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            4,
                            g.getItem(this.getStorageKey())
                        ];
                    case 4:
                        V = Y.sent(), Y.label = 5;
                    case 5:
                        return [
                            4,
                            H(null, V)
                        ];
                    case 6:
                    case 7:
                        return Y.sent(), [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            3,
                            12
                        ];
                    case 9:
                        return K ? [
                            3,
                            11
                        ] : [
                            4,
                            this.getFlags()
                        ];
                    case 10:
                        return Y.sent(), [
                            3,
                            12
                        ];
                    case 11:
                        if (O) this._onChange(null, {
                            isFromServer: !1,
                            flagsChanged: r({}, O),
                            traitsChanged: r({}, null === (a = c.identity) || void 0 === a ? void 0 : a.traits)
                        }, this._loadedState(null, s.DEFAULT_FLAGS));
                        else if (this.flags && (q = null, 0 === Object.keys(this.flags).length && (q = M), this._onChange(null, {
                            isFromServer: !1,
                            flagsChanged: r({}, this.flags),
                            traitsChanged: r({}, null === (o = c.identity) || void 0 === o ? void 0 : o.traits)
                        }, this._loadedState(q, s.DEFAULT_FLAGS)), q)) throw new Error(q);
                        Y.label = 12;
                    case 12:
                        return [
                            3,
                            14
                        ];
                    case 13:
                        throw B = Y.sent(), this.log("Error during initialisation ", B), W = B instanceof Error ? B : new Error("".concat(B)), null === (u = this.onError) || void 0 === u || u.call(this, W), B;
                    case 14:
                        return [
                            2
                        ];
                }
                var $;
            });
        });
    }, t.prototype.getAllFlags = function() {
        return this.flags;
    }, t.prototype.identify = function(t, e, n) {
        return this.identity = t, this.evaluationContext.identity = {
            identifier: t,
            transient: n,
            traits: this.evaluationContext.identity && this.evaluationContext.identity.identifier == t ? this.evaluationContext.identity.traits : {}
        }, this.evaluationContext.identity.identifier = t, this.log("Identify: " + this.evaluationContext.identity.identifier), e && (this.evaluationContext.identity.traits = Object.fromEntries(Object.entries(e).map(function(t) {
            var e = t[0], n = t[1];
            return [
                e,
                c(n) ? n : {
                    value: n
                }
            ];
        }))), this.initialised ? this.getFlags() : Promise.resolve();
    }, t.prototype.getState = function() {
        return {
            api: this.api,
            flags: this.flags,
            ts: this.ts,
            evaluationContext: this.evaluationContext,
            identity: this.identity,
            evaluationEvent: this.evaluationEvent
        };
    }, t.prototype.setState = function(t) {
        var e, n;
        t && (this.initialised = !0, this.api = t.api || this.api || p, this.flags = t.flags || this.flags, this.evaluationContext = t.evaluationContext || this.evaluationContext, this.evaluationEvent = t.evaluationEvent || this.evaluationEvent, this.identity = null === (n = null === (e = this.getContext()) || void 0 === e ? void 0 : e.identity) || void 0 === n ? void 0 : n.identifier, this.log("setState called", this));
    }, t.prototype.logout = function() {
        return this.identity = null, this.evaluationContext.identity = null, this.initialised ? this.getFlags() : Promise.resolve();
    }, t.prototype.startListening = function(t) {
        void 0 === t && (t = 1e3), this.getFlagInterval && clearInterval(this.getFlagInterval), this.getFlagInterval = setInterval(this.getFlags, t);
    }, t.prototype.stopListening = function() {
        this.getFlagInterval && (clearInterval(this.getFlagInterval), this.getFlagInterval = null);
    }, t.prototype._loadedState = function(t, e, n) {
        return void 0 === t && (t = null), void 0 === n && (n = !1), {
            error: t,
            isFetching: n,
            isLoading: !1,
            source: e
        };
    }, t.prototype.log = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        this.enableLogs && console.log.apply(this, a([
            "FLAGSMITH:",
            (new Date).valueOf() - (this.timer || 0),
            "ms"
        ], t, !0));
    }, t.prototype.updateStorage = function() {
        if (this.cacheFlags) {
            this.ts = (new Date).valueOf();
            var t = JSON.stringify(this.getState());
            this.log("Setting storage", t), g.setItem(this.getStorageKey(), t);
        }
    }, t.prototype.updateEventStorage = function() {
        if (this.enableAnalytics) {
            var t = JSON.stringify(this.getState().evaluationEvent);
            g.setItem(f, t).catch(function(t) {
                return console.error("Flagsmith: Error setting item in async storage", t);
            });
        }
    }, t.prototype.setLoadingState = function(t) {
        var n;
        o(t, this.loadingState) || (this.loadingState = e({}, t), this.log("Loading state changed", t), null === (n = this._triggerLoadingState) || void 0 === n || n.call(this));
    }, t.prototype.setupRealtime = function(t, e) {
        var n = this, i = t + "sse/environments/" + e + "/stream";
        h ? this.eventSource || (this.log("Creating event source with url " + i), this.eventSource = new h(i), this.eventSource.addEventListener("environment_updated", function(t) {
            var e;
            try {
                e = JSON.parse(t.data).updated_at;
            } catch (t) {
                n.log("Could not parse sse event", t);
            }
            e ? !n.timestamp || e > n.timestamp ? n.isLoading ? n.log("updated_at is new, but flags are loading", t.data, n.timestamp) : (n.log("updated_at is new, fetching flags", t.data, n.timestamp), n.getFlags()) : n.log("updated_at is outdated, skipping get flags", t.data, n.timestamp) : n.log("No updated_at received, fetching flags", t);
        })) : this.log("Error, EventSource is undefined");
    }, t;
}();
function m(t) {
    var e = t.fetch, n = t.AsyncStorage, i = t.eventSource;
    return new y({
        fetch: e,
        AsyncStorage: n,
        eventSource: i
    });
}
var S, C = (S = function(t, e) {
    return S = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }, S(t, e);
}, function(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    S(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}), _ = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, n = e && t[e], i = 0;
    if (n) return n.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && i >= t.length && (t = void 0), {
                value: t && t[i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, b = function(t, e) {
    var n = "function" == typeof Symbol && t[Symbol.iterator];
    if (!n) return t;
    var i, a, o = n.call(t), r = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(i = o.next()).done;)r.push(i.value);
    } catch (t) {
        a = {
            error: t
        };
    } finally{
        try {
            i && !i.done && (n = o.return) && n.call(o);
        } finally{
            if (a) throw a.error;
        }
    }
    return r;
}, E = function(t, e, n) {
    if (n || 2 === arguments.length) for(var i, a = 0, o = e.length; a < o; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}, x = function(t) {
    function e() {
        return t.call(this, "EventSource not available.\nConsider loading an EventSource polyfill and making it available globally as EventSource, or passing one in as eventSourceClass to the ReconnectingEventSource constructor.") || this;
    }
    return C(e, t), e;
}(Error), O = function() {
    function t(t, e) {
        var n = this;
        if (this.CONNECTING = 0, this.OPEN = 1, this.CLOSED = 2, this._configuration = null != e ? Object.assign({}, e) : void 0, this.withCredentials = !1, this._eventSource = null, this._lastEventId = null, this._timer = null, this._listeners = {
            open: [],
            error: [],
            message: []
        }, this.url = t.toString(), this.readyState = this.CONNECTING, this.max_retry_time = 3e3, this.eventSourceClass = globalThis.FlagsmithEventSource, null != this._configuration && (this._configuration.lastEventId && (this._lastEventId = this._configuration.lastEventId, delete this._configuration.lastEventId), this._configuration.max_retry_time && (this.max_retry_time = this._configuration.max_retry_time, delete this._configuration.max_retry_time), this._configuration.eventSourceClass && (this.eventSourceClass = this._configuration.eventSourceClass, delete this._configuration.eventSourceClass)), null == this.eventSourceClass || "function" != typeof this.eventSourceClass) throw new x;
        this._onevent_wrapped = function(t) {
            n._onevent(t);
        }, this._start();
    }
    return t.prototype.dispatchEvent = function(t) {
        throw new Error("Method not implemented.");
    }, t.prototype._start = function() {
        var t, e, n = this, i = this.url;
        this._lastEventId && (-1 === i.indexOf("?") ? i += "?" : i += "&", i += "lastEventId=" + encodeURIComponent(this._lastEventId)), this._eventSource = new this.eventSourceClass(i, this._configuration), this._eventSource.onopen = function(t) {
            n._onopen(t);
        }, this._eventSource.onerror = function(t) {
            n._onerror(t);
        }, this._eventSource.onmessage = function(t) {
            n.onmessage(t);
        };
        try {
            for(var a = _(Object.keys(this._listeners)), o = a.next(); !o.done; o = a.next()){
                var r = o.value;
                this._eventSource.addEventListener(r, this._onevent_wrapped);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                o && !o.done && (e = a.return) && e.call(a);
            } finally{
                if (t) throw t.error;
            }
        }
    }, t.prototype._onopen = function(t) {
        0 === this.readyState && (this.readyState = 1, this.onopen(t));
    }, t.prototype._onerror = function(t) {
        var e = this;
        if (1 === this.readyState && (this.readyState = 0, this.onerror(t)), this._eventSource) {
            this._eventSource.close(), this._eventSource = null;
            var n = Math.round(this.max_retry_time * Math.random());
            this._timer = setTimeout(function() {
                return e._start();
            }, n);
        }
    }, t.prototype._onevent = function(t) {
        var e, n;
        t && t.lastEventId && (this._lastEventId = t.lastEventId);
        var i = this._listeners[t.type];
        if (null != i) try {
            for(var a = _(E([], b(i), !1)), o = a.next(); !o.done; o = a.next())o.value.call(this, t);
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (n = a.return) && n.call(a);
            } finally{
                if (e) throw e.error;
            }
        }
        "message" === t.type && this.onmessage(t);
    }, t.prototype.onopen = function(t) {}, t.prototype.onerror = function(t) {}, t.prototype.onmessage = function(t) {}, t.prototype.close = function() {
        this._timer && (clearTimeout(this._timer), this._timer = null), this._eventSource && (this._eventSource.close(), this._eventSource = null), this.readyState = 2;
    }, t.prototype.addEventListener = function(t, e, n) {
        null == this._listeners[t] && (this._listeners[t] = [], null != this._eventSource && this._eventSource.addEventListener(t, this._onevent_wrapped));
        var i = this._listeners[t];
        i.includes(e) || (this._listeners[t] = E(E([], b(i), !1), [
            e
        ], !1));
    }, t.prototype.removeEventListener = function(t, e, n) {
        var i = this._listeners[t];
        this._listeners[t] = i.filter(function(t) {
            return t !== e;
        });
    }, t;
}();
globalThis.FlagsmithEventSource = "undefined" != typeof EventSource ? EventSource : null;
var F = function(t, e) {
    return e = e || {}, new Promise(function(n, i) {
        var a = new XMLHttpRequest, o = [], r = [], s = {}, l = function() {
            return {
                ok: 2 == (a.status / 100 | 0),
                statusText: a.statusText,
                status: a.status,
                url: a.responseURL,
                text: function() {
                    return Promise.resolve(a.responseText);
                },
                json: function() {
                    return Promise.resolve(a.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        a.response
                    ]));
                },
                clone: l,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return r;
                    },
                    get: function(t) {
                        return s[t.toLowerCase()];
                    },
                    has: function(t) {
                        return t.toLowerCase() in s;
                    }
                }
            };
        };
        for(var u in a.open(e.method || "get", t, !0), a.onload = function() {
            a.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(t, e, n) {
                o.push(e = e.toLowerCase()), r.push([
                    e,
                    n
                ]), s[e] = s[e] ? s[e] + "," + n : n;
            }), n(l());
        }, a.onerror = i, a.withCredentials = "include" == e.credentials, e.headers)a.setRequestHeader(u, e.headers[u]);
        a.send(e.body || null);
    });
}, w = m({
    AsyncStorage: t,
    fetch: F,
    eventSource: O
});
"undefined" != typeof window && (window.flagsmith = w);
var I = function() {
    return m({
        AsyncStorage: t,
        fetch: F,
        eventSource: O
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151","9a12b8ebb588397d":"7baQq"}],"7baQq":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"e5KkV":[function(require,module,exports) {
module.exports = require("605c7eba80b7e640")(require("1def5c81c628ea83").resolve("kMKFg")).then(()=>module.bundle.root("7mp50"));

},{"605c7eba80b7e640":"hpx0h","1def5c81c628ea83":"fyJL2"}],"hpx0h":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"icruC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateEventName", ()=>generateEventName);
parcelHelpers.export(exports, "getEmitter", ()=>getEmitter);
var _mitt = require("mitt");
var _mittDefault = parcelHelpers.interopDefault(_mitt);
let emitterInstance = null;
function generateEventName(eventName, clientId) {
    return `${eventName}:${clientId}`;
}
function getEmitter() {
    if (!emitterInstance) emitterInstance = (0, _mittDefault.default)();
    return emitterInstance;
}

},{"mitt":"9VktN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VktN":[function(require,module,exports) {
var parcelHelpers = require("cfa4c44207791989");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(n) {
        return {
            all: n = n || new Map,
            on: function(t, e) {
                var i = n.get(t);
                i ? i.push(e) : n.set(t, [
                    e
                ]);
            },
            off: function(t, e) {
                var i = n.get(t);
                i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
            },
            emit: function(t, e) {
                var i = n.get(t);
                i && i.slice().map(function(n) {
                    n(e);
                }), (i = n.get("*")) && i.slice().map(function(n) {
                    n(t, e);
                });
            }
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151","cfa4c44207791989":"7baQq"}],"3T4Bn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerPageVisibilityListener", ()=>registerPageVisibilityListener);
let listeners = [];
let isListenerAttached = false;
function registerPageVisibilityListener(cb) {
    listeners.push(cb);
    if (!isListenerAttached) {
        isListenerAttached = true;
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "visible") listeners.forEach((listener)=>listener(true));
            else listeners.forEach((listener)=>listener(false));
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39Y4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionManager", ()=>SessionManager);
var _emitter = require("../../utils/emitter");
var _auth0Sdk = require("../../auth0-sdk");
var _rews = require("@nktkas/rews");
class SessionManager {
    constructor(options){
        this.ws = null;
        this._isInitialized = false;
        this.sessionState = null;
        this.pingIntervalId = null;
        this.onWebsocketSessionMessage = async (event)=>{
            if (event.data === "pong") return;
            const message = JSON.parse(event.data);
            this.sessionState = this.reduceSessionStateMessage(this.sessionState, message);
            this.applyState(this.sessionState);
        };
        this.onWebsocketClose = async (event)=>{
            console.log("Primary WebSocket closed:", event.code, event.reason);
            this.stopPing();
        };
        this.sessionManagerEndpoint = options.sessionManagerEndpoint;
        this.clientId = options.clientId;
        this.pingInterval = options.pingInterval ?? 30000;
    }
    async connect() {
        if (this._isInitialized) return;
        await this.establishWebSocketConnection();
        this._isInitialized = true;
    }
    startMediaConsumption() {
        this.ws.send(JSON.stringify({
            type: "startMediaConsumption"
        }));
    }
    endMediaConsumption() {
        this.ws.send(JSON.stringify({
            type: "endMediaConsumption"
        }));
    }
    applyState(state) {
        if (state) {
            if (state.isInConcurrencyLimitedContext && !state.isActive) (0, _emitter.getEmitter)().emit("session:blocked");
            else (0, _emitter.getEmitter)().emit("session:unblocked");
        }
        this.sessionState = state;
    }
    async establishWebSocketConnection() {
        if (this.ws?.readyState === WebSocket.OPEN) return;
        if (!(0, _auth0Sdk.isAuthenticated)(this.clientId)) throw new Error("User must be authenticated before initiating a session manager connection");
        const urlProvider = ()=>{
            const url = new URL(`wss://${this.sessionManagerEndpoint}`);
            url.pathname = "/join";
            url.searchParams.set("token", (0, _auth0Sdk.getIdToken)(this.clientId));
            return url.toString();
        };
        this.ws = new (0, _rews.ReconnectingWebSocket)(urlProvider, [
            "v1.mediahuis.session-manager+json"
        ], {
            maxRetries: null,
            reconnectionDelay: 5000
        });
        this.ws.onopen = ()=>{
            this.sessionState = null;
            this.startPing();
        };
        this.ws.onmessage = this.onWebsocketSessionMessage;
        this.ws.onclose = this.onWebsocketClose;
        this.ws.onerror = (error)=>{
            console.error("Primary WebSocket error:", error);
        };
    }
    reduceSessionStateMessage(prev, message) {
        if (message.type !== "sessionState") return prev;
        if (!prev || message.data.version > prev.version) return message.data;
        return prev;
    }
    startPing() {
        this.stopPing();
        this.pingIntervalId = setInterval(()=>{
            if (this.ws?.readyState === WebSocket.OPEN) this.ws.send("ping");
        }, this.pingInterval);
    }
    stopPing() {
        if (this.pingIntervalId !== null) {
            clearInterval(this.pingIntervalId);
            this.pingIntervalId = null;
        }
    }
    async shutdown() {
        this.stopPing();
        if (this.ws) {
            if (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING) this.ws.close(1000);
            this.ws = null;
        }
        this.sessionState = null;
        this._isInitialized = false;
    }
}

},{"../../utils/emitter":"icruC","../../auth0-sdk":"3ELjX","@nktkas/rews":"9sg0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9sg0q":[function(require,module,exports) {
// deno-lint-ignore-file no-explicit-any
/** Error thrown when reconnection fails in {@link ReconnectingWebSocket}. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReconnectingWebSocketError", ()=>ReconnectingWebSocketError);
/**
 * A WebSocket with auto-reconnection logic. Fully compatible with standard WebSocket API.
 *
 * Features:
 * - Automatic reconnection with configurable max retries and delay.
 * - Buffers messages sent while disconnected and sends them upon reconnection.
 * - Re-applies event listeners after reconnection.
 * - Supports dynamic URL and protocols via functions.
 *
 * Additional properties and events:
 * - `isTerminated`: Indicates whether the instance has been permanently terminated.
 * - `terminationReason`: If terminated, provides the reason for termination.
 * - `terminationSignal`: AbortSignal that is aborted when the instance is permanently terminated.
 * - `terminate` event: Fired when the instance is permanently terminated.
 */ parcelHelpers.export(exports, "ReconnectingWebSocket", ()=>ReconnectingWebSocket);
class ReconnectingWebSocketError extends Error {
    /**
     * Error code indicating the type of reconnection error:
     * - `RECONNECTION_LIMIT`: Maximum reconnection attempts reached
     * - `TERMINATED_BY_USER`: Closed via `close()` method
     * - `UNKNOWN_ERROR`: Unexpected failure during reconnection
     */ code;
    constructor(code, cause){
        super(`Error when reconnecting WebSocket: ${code}`);
        this.name = "ReconnectingWebSocketError";
        this.cause = cause;
        this.code = code;
    }
}
class ReconnectingWebSocket {
    _socket;
    _urlProvider;
    _protocolsProvider;
    _listeners = [];
    _attempt = 0;
    _messageBuffer = [];
    _abortController = new AbortController();
    /** Indicates whether the instance has been permanently terminated. */ get isTerminated() {
        return this._abortController.signal.aborted;
    }
    /** If terminated, provides the reason for termination. */ get terminationReason() {
        return this._abortController.signal.reason;
    }
    /** AbortSignal that is aborted when the instance is permanently terminated. */ get terminationSignal() {
        return this._abortController.signal;
    }
    /** Reconnection configuration options. */ reconnectOptions;
    constructor(url, protocolsOrOptions, maybeOptions){
        const protocols = typeof protocolsOrOptions === "string" || typeof protocolsOrOptions === "function" || Array.isArray(protocolsOrOptions) ? protocolsOrOptions : undefined;
        const options = typeof protocolsOrOptions === "object" && !Array.isArray(protocolsOrOptions) ? protocolsOrOptions : maybeOptions;
        if (!globalThis.WebSocket && !options?.WebSocket) throw new Error("No WebSocket implementation found. Please provide a custom WebSocket constructor in the options.");
        this._urlProvider = url;
        this._protocolsProvider = protocols;
        this.reconnectOptions = {
            WebSocket: options?.WebSocket ?? WebSocket,
            maxRetries: options?.maxRetries ?? 3,
            connectionTimeout: options?.connectionTimeout === undefined ? 10000 : options.connectionTimeout,
            reconnectionDelay: options?.reconnectionDelay ?? ((n)=>Math.min(~~(1 << n) * 150, 10000))
        };
        this._createSocket();
        this._initInternalListeners();
    }
    _createSocket() {
        const url = typeof this._urlProvider === "function" ? this._urlProvider() : this._urlProvider;
        const protocols = typeof this._protocolsProvider === "function" ? this._protocolsProvider() : this._protocolsProvider;
        this._socket = createSocketWithTimeout(()=>new this.reconnectOptions.WebSocket(url, protocols), this.reconnectOptions.connectionTimeout);
    }
    _initInternalListeners() {
        const handleClose = ()=>{
            this._socket.removeEventListener("error", handleError);
            this._close();
        };
        const handleError = ()=>{
            this._socket.removeEventListener("close", handleClose);
            this._close();
        };
        this._socket.addEventListener("open", this._open, {
            once: true
        });
        this._socket.addEventListener("close", handleClose, {
            once: true
        });
        this._socket.addEventListener("error", handleError, {
            once: true
        });
    }
    _open = ()=>{
        // Reset the attempt counter
        this._attempt = 0;
        // Send all buffered messages
        this._messageBuffer.forEach((item)=>{
            this._socket.send(item);
        });
        this._messageBuffer = [];
    };
    _close = async ()=>{
        try {
            // If the instance is terminated, do not attempt to reconnect
            if (this._abortController.signal.aborted) return;
            // Check if reconnection should be attempted
            if (++this._attempt > this.reconnectOptions.maxRetries) {
                this._cleanup("RECONNECTION_LIMIT");
                return;
            }
            // Delay before reconnecting
            const delay = typeof this.reconnectOptions.reconnectionDelay === "number" ? this.reconnectOptions.reconnectionDelay : this.reconnectOptions.reconnectionDelay(this._attempt);
            await sleep(delay, this._abortController.signal);
            // Create a new WebSocket instance and re-apply event listeners (and some properties)
            const { onclose, onerror, onmessage, onopen, binaryType } = this._socket; // preserve event handlers
            this._createSocket();
            this._initInternalListeners();
            this._listeners.forEach(({ type, listenerProxy, options })=>{
                this._socket.addEventListener(type, listenerProxy, options);
            });
            this._socket.onclose = onclose;
            this._socket.onerror = onerror;
            this._socket.onmessage = onmessage;
            this._socket.onopen = onopen;
            this._socket.binaryType = binaryType;
        } catch (error) {
            this._cleanup("UNKNOWN_ERROR", error);
        }
    };
    _cleanup(code, cause) {
        const error = new ReconnectingWebSocketError(code, cause);
        this._abortController.abort(error);
        this._socket.close();
        this.dispatchEvent(new CustomEvent("terminate", {
            detail: error
        }));
    }
    // WebSocket property implementations
    get url() {
        return this._socket.url;
    }
    get readyState() {
        return this._socket.readyState;
    }
    get bufferedAmount() {
        return this._socket.bufferedAmount;
    }
    get extensions() {
        return this._socket.extensions;
    }
    get protocol() {
        return this._socket.protocol;
    }
    get binaryType() {
        return this._socket.binaryType;
    }
    set binaryType(value) {
        this._socket.binaryType = value;
    }
    CONNECTING = 0;
    OPEN = 1;
    CLOSING = 2;
    CLOSED = 3;
    static CONNECTING = 0;
    static OPEN = 1;
    static CLOSING = 2;
    static CLOSED = 3;
    get onclose() {
        return this._socket.onclose;
    }
    set onclose(value) {
        this._socket.onclose = value;
    }
    get onerror() {
        return this._socket.onerror;
    }
    set onerror(value) {
        this._socket.onerror = value;
    }
    get onmessage() {
        return this._socket.onmessage;
    }
    set onmessage(value) {
        this._socket.onmessage = value;
    }
    get onopen() {
        return this._socket.onopen;
    }
    set onopen(value) {
        this._socket.onopen = value;
    }
    /**
     * @param permanently - If `true`, the connection will be permanently closed. Default is `true`.
     */ close(code, reason, permanently = true) {
        this._socket.close(code, reason);
        if (permanently) this._cleanup("TERMINATED_BY_USER");
    }
    /**
     * @note If the connection is not open, the data will be buffered and sent when the connection is established.
     */ send(data) {
        if (this._socket.readyState !== ReconnectingWebSocket.OPEN && !this._abortController.signal.aborted) this._messageBuffer.push(data);
        else this._socket.send(data);
    }
    addEventListener(type, listener, options) {
        // Wrap the listener to handle reconnection
        let listenerProxy;
        if (this._abortController.signal.aborted) // If the instance is terminated, use the original listener
        listenerProxy = listener;
        else {
            // Check if the listener is already registered
            const index = this._listeners.findIndex((e)=>listenersMatch(e, {
                    type,
                    listener,
                    options
                }));
            if (index !== -1) // Use the existing listener proxy
            listenerProxy = this._listeners[index].listenerProxy;
            else {
                // Wrap the original listener to follow the once option when reconnecting
                listenerProxy = (event)=>{
                    try {
                        if (typeof listener === "function") listener.call(this, event);
                        else listener.handleEvent(event);
                    } finally{
                        // If the listener is marked as once, remove it after the first invocation
                        if (typeof options === "object" && options.once === true) {
                            const index = this._listeners.findIndex((e)=>listenersMatch(e, {
                                    type,
                                    listener,
                                    options
                                }));
                            if (index !== -1) this._listeners.splice(index, 1);
                        }
                    }
                };
                this._listeners.push({
                    type,
                    listener,
                    options,
                    listenerProxy
                });
            }
        }
        // Add the wrapped (or original) listener
        this._socket.addEventListener(type, listenerProxy, options);
    }
    removeEventListener(type, listener, options) {
        // Remove a wrapped listener, not an original listener
        const index = this._listeners.findIndex((e)=>listenersMatch(e, {
                type,
                listener,
                options
            }));
        if (index !== -1) {
            const { listenerProxy } = this._listeners[index];
            this._socket.removeEventListener(type, listenerProxy, options);
            this._listeners.splice(index, 1);
        } else // If the wrapped listener is not found, remove the original listener
        this._socket.removeEventListener(type, listener, options);
    }
    dispatchEvent(event) {
        return this._socket.dispatchEvent(event);
    }
}
/** @see https://developer.mozilla.org/en-US/docs/Web/API/DOMException */ const DOMException_ = /* @__PURE__ */ (()=>{
    return globalThis.DOMException || class DOMExceptionPolyfill extends Error {
        constructor(message = "", name = "Error"){
            super(message);
            this.name = name;
        }
    };
})();
const AbortSignal_ = /* @__PURE__ */ (()=>{
    return {
        /** @see https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/timeout_static */ timeout: AbortSignal?.timeout ? (ms)=>AbortSignal.timeout(ms) : (ms)=>{
            const controller = new AbortController();
            setTimeout(()=>controller.abort(new DOMException_("Signal timed out.", "TimeoutError")), ms);
            return controller.signal;
        }
    };
})();
function createSocketWithTimeout(socketFactory, timeout) {
    const socket = socketFactory();
    if (timeout === null) return socket;
    const handleOpen = ()=>{
        socket.removeEventListener("close", handleClose);
        socket.removeEventListener("error", handleError);
        signal.removeEventListener("abort", handleAbort);
    };
    const handleClose = ()=>{
        socket.removeEventListener("open", handleOpen);
        socket.removeEventListener("error", handleError);
        signal.removeEventListener("abort", handleAbort);
    };
    const handleError = ()=>{
        socket.removeEventListener("open", handleOpen);
        socket.removeEventListener("close", handleClose);
        signal.removeEventListener("abort", handleAbort);
    };
    const handleAbort = ()=>{
        socket.close(3008, "Timeout"); // https://www.iana.org/assignments/websocket/websocket.xml#close-code-number
    };
    const signal = AbortSignal_.timeout(timeout);
    socket.addEventListener("open", handleOpen, {
        once: true,
        signal
    });
    socket.addEventListener("close", handleClose, {
        once: true,
        signal
    });
    socket.addEventListener("error", handleError, {
        once: true,
        signal
    });
    signal.addEventListener("abort", handleAbort, {
        once: true
    });
    return socket;
}
function listenersMatch(a, b) {
    const aCapture = typeof a.options === "object" ? a.options.capture : a.options;
    const bCapture = typeof b.options === "object" ? b.options.capture : b.options;
    return a.type === b.type && a.listener === b.listener && !!aCapture === !!bCapture;
}
function sleep(ms, signal) {
    if (signal?.aborted) return Promise.reject(signal.reason);
    return new Promise((resolve, reject)=>{
        const onAbort = ()=>{
            clearTimeout(timer);
            reject(signal?.reason);
        };
        const onTimeout = ()=>{
            signal?.removeEventListener("abort", onAbort);
            resolve();
        };
        const timer = setTimeout(onTimeout, ms);
        signal?.addEventListener("abort", onAbort, {
            once: true
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKyNT":[function(require,module,exports) {
module.exports = require("bfb19f1f70bf147")(require("7c299a68cb785182").resolve("dVcvk")).then(()=>module.bundle.root("7wVf9"));

},{"bfb19f1f70bf147":"hpx0h","7c299a68cb785182":"fyJL2"}],"a1Sgr":[function(require,module,exports) {
module.exports = require("8c7a744112c20846")(require("bc215b369e5acd08").resolve("7SBQa")).then(()=>module.bundle.root("N7M1B"));

},{"8c7a744112c20846":"hpx0h","bc215b369e5acd08":"fyJL2"}],"6WxCn":[function(require,module,exports) {
module.exports = require("cc868cec43cccc06")(require("9f2c9f5f31adae37").resolve("kNLVx")).then(()=>module.bundle.root("cI8hw"));

},{"cc868cec43cccc06":"hpx0h","9f2c9f5f31adae37":"fyJL2"}],"8SJmv":[function(require,module,exports) {
module.exports = require("e73e8ac07c91f146")(require("2428a9ea6592d30f").resolve("6nVKT")).then(()=>module.bundle.root("1UyDU"));

},{"e73e8ac07c91f146":"hpx0h","2428a9ea6592d30f":"fyJL2"}],"2J4qA":[function(require,module,exports) {
module.exports = require("4b935d83c2fece24")(require("b8d2e3eaf9a92fe9").resolve("14QDh")).then(()=>module.bundle.root("8A1Yz"));

},{"4b935d83c2fece24":"hpx0h","b8d2e3eaf9a92fe9":"fyJL2"}],"8dMQO":[function(require,module,exports) {
module.exports = require("a5de393b7796c079")(require("f2555b67d2296b6b").resolve("2zjTs")).then(()=>module.bundle.root("mo8zj"));

},{"a5de393b7796c079":"hpx0h","f2555b67d2296b6b":"fyJL2"}],"bEKLz":[function(require,module,exports) {
module.exports = require("83c8b8b45a9d705c")(require("adfcaec848abbd52").resolve("iOSSR")).then(()=>module.bundle.root("f1QHr"));

},{"83c8b8b45a9d705c":"hpx0h","adfcaec848abbd52":"fyJL2"}],"48zHh":[function(require,module,exports) {
module.exports = require("bb97173ddc78c574")(require("a073e290a5381076").resolve("jdd4K")).then(()=>module.bundle.root("gSHee"));

},{"bb97173ddc78c574":"hpx0h","a073e290a5381076":"fyJL2"}],"2mi3I":[function(require,module,exports) {
module.exports = require("f9b43fbaa647662b")(require("a949dd31ad95017d").resolve("e0Rep")).then(()=>module.bundle.root("boN4L"));

},{"f9b43fbaa647662b":"hpx0h","a949dd31ad95017d":"fyJL2"}],"ldtR5":[function(require,module,exports) {
module.exports = require("7a5d35f229713df5")(require("e9d96b5f8b3a8866").resolve("QdmLN")).then(()=>module.bundle.root("6OJ4a"));

},{"7a5d35f229713df5":"hpx0h","e9d96b5f8b3a8866":"fyJL2"}],"lPHNd":[function(require,module,exports) {
module.exports = require("79ede8252e769920")(require("d5f90ff86e599950").resolve("jqHnS")).then(()=>module.bundle.root("8ieI2"));

},{"79ede8252e769920":"hpx0h","d5f90ff86e599950":"fyJL2"}],"krUjc":[function(require,module,exports) {
module.exports = require("578c0244a82c461e")(require("3e9b9c64a20d5c39").resolve("95IVm")).then(()=>module.bundle.root("4OF6e"));

},{"578c0244a82c461e":"hpx0h","3e9b9c64a20d5c39":"fyJL2"}],"gtb31":[function(require,module,exports) {
module.exports = require("f94ee04f2c3cd027")(require("ea899a02d4db8b9b").resolve("j5vQM")).then(()=>module.bundle.root("cDCAE"));

},{"f94ee04f2c3cd027":"hpx0h","ea899a02d4db8b9b":"fyJL2"}],"jRTqj":[function(require,module,exports) {
module.exports = require("493d672ed4d12c77")(require("b5072bd13d6267b").resolve("kuwyQ")).then(()=>module.bundle.root("1DfC8"));

},{"493d672ed4d12c77":"hpx0h","b5072bd13d6267b":"fyJL2"}],"1tpGP":[function(require,module,exports) {
module.exports = require("f35792fc7dbacb6f")(require("2ab200d1632a7adc").resolve("hpmJK")).then(()=>module.bundle.root("juDwX"));

},{"f35792fc7dbacb6f":"hpx0h","2ab200d1632a7adc":"fyJL2"}],"7hEG8":[function(require,module,exports) {
module.exports = require("10c6a731738e92b4")(require("7085bee8b03d1d16").resolve("75rVb")).then(()=>module.bundle.root("exkcQ"));

},{"10c6a731738e92b4":"hpx0h","7085bee8b03d1d16":"fyJL2"}],"21AMv":[function(require,module,exports) {
module.exports = require("2340097d46a6f35f")(require("16a1b40ee145802c").resolve("jvVie")).then(()=>module.bundle.root("4Kk1B"));

},{"2340097d46a6f35f":"hpx0h","16a1b40ee145802c":"fyJL2"}],"3GCVy":[function(require,module,exports) {
module.exports = require("408359ce386ceec9")(require("b1dbb6d471b8fed4").resolve("1Rec2")).then(()=>module.bundle.root("8hqyP"));

},{"408359ce386ceec9":"hpx0h","b1dbb6d471b8fed4":"fyJL2"}],"8xBP8":[function(require,module,exports) {
module.exports = require("827c34931e60c4e9")(require("f470cc79baf4763e").resolve("eP5WB")).then(()=>module.bundle.root("5YXTA"));

},{"827c34931e60c4e9":"hpx0h","f470cc79baf4763e":"fyJL2"}],"2wlKu":[function(require,module,exports) {
module.exports = require("aba3fe9b413f02bb")(require("2382f090e5dc35f3").resolve("cSUAJ")).then(()=>module.bundle.root("9FRzR"));

},{"aba3fe9b413f02bb":"hpx0h","2382f090e5dc35f3":"fyJL2"}],"fYaZG":[function(require,module,exports) {
module.exports = require("76115b3d094ec00e")(require("3d35c95733215df").resolve("ktfFT")).then(()=>module.bundle.root("fqkhk"));

},{"76115b3d094ec00e":"hpx0h","3d35c95733215df":"fyJL2"}],"3eTZQ":[function(require,module,exports) {
module.exports = require("475b794e949b6d80")(require("f5841a260ba9118b").resolve("6vrJm")).then(()=>module.bundle.root("aCSiA"));

},{"475b794e949b6d80":"hpx0h","f5841a260ba9118b":"fyJL2"}],"bgxJ8":[function(require,module,exports) {
module.exports = require("39d214d3a521213a")(require("87d514c9ad222e0d").resolve("ahuud")).then(()=>module.bundle.root("a0kxV"));

},{"39d214d3a521213a":"hpx0h","87d514c9ad222e0d":"fyJL2"}],"7Spzc":[function(require,module,exports) {
module.exports = require("3b001b7f7654ae12")(require("bce33a515dad22bb").resolve("ju3C7")).then(()=>module.bundle.root("9ktb7"));

},{"3b001b7f7654ae12":"hpx0h","bce33a515dad22bb":"fyJL2"}],"aZ4P9":[function(require,module,exports) {
module.exports = require("d98c6006bba35999")(require("f2aee2694c1f3542").resolve("8TPB0")).then(()=>module.bundle.root("l27MP"));

},{"d98c6006bba35999":"hpx0h","f2aee2694c1f3542":"fyJL2"}],"9k7cc":[function(require,module,exports) {
module.exports = require("6a8a346cdc0b164b")(require("2605420dc2ff6dc8").resolve("dKktD")).then(()=>module.bundle.root("5l2YZ"));

},{"6a8a346cdc0b164b":"hpx0h","2605420dc2ff6dc8":"fyJL2"}],"91Iyr":[function(require,module,exports) {
module.exports = require("4cc3e0367993afc1")(require("97eecf66b27ad639").resolve("1nR1M")).then(()=>module.bundle.root("eqGXI"));

},{"4cc3e0367993afc1":"hpx0h","97eecf66b27ad639":"fyJL2"}],"kRz8l":[function(require,module,exports) {
module.exports = require("481997bab56db8d8")(require("3daeeef0d5b454d0").resolve("aJj8f")).then(()=>module.bundle.root("3CxmS"));

},{"481997bab56db8d8":"hpx0h","3daeeef0d5b454d0":"fyJL2"}],"f89mb":[function(require,module,exports) {
module.exports = require("23efd76a28bfece0")(require("8d61dd70a56cb6f1").resolve("k2nJc")).then(()=>module.bundle.root("cMuma"));

},{"23efd76a28bfece0":"hpx0h","8d61dd70a56cb6f1":"fyJL2"}],"8cxG0":[function(require,module,exports) {
module.exports = require("44a56bf3a1341e0b")(require("c0394dd428d95c06").resolve("5hQ26")).then(()=>module.bundle.root("3MkQT"));

},{"44a56bf3a1341e0b":"hpx0h","c0394dd428d95c06":"fyJL2"}],"fuLOH":[function(require,module,exports) {
module.exports = require("79d1a9aa27b5a0f0")(require("9effb843be8462ff").resolve("20EWj")).then(()=>module.bundle.root("dag7C"));

},{"79d1a9aa27b5a0f0":"hpx0h","9effb843be8462ff":"fyJL2"}],"Z3dTd":[function(require,module,exports) {
module.exports = require("9c3c2d9228c4e037")(require("ed1f069c874ed00d").resolve("257xd")).then(()=>module.bundle.root("kpQGh"));

},{"9c3c2d9228c4e037":"hpx0h","ed1f069c874ed00d":"fyJL2"}],"besK2":[function(require,module,exports) {
module.exports = require("5dcfefa19bc64855")(require("59efb3595eb290cd").resolve("5YLOB")).then(()=>module.bundle.root("hMF7j"));

},{"5dcfefa19bc64855":"hpx0h","59efb3595eb290cd":"fyJL2"}],"3WjRM":[function(require,module,exports) {
module.exports = require("9f9830a23a458e4c")(require("d79187d509bd8443").resolve("clg2W")).then(()=>module.bundle.root("2VbJB"));

},{"9f9830a23a458e4c":"hpx0h","d79187d509bd8443":"fyJL2"}],"4dWYW":[function(require,module,exports) {
module.exports = require("ca7eebf8be1314ad")(require("21ecb85065719286").resolve("cYyjx")).then(()=>module.bundle.root("fNnk0"));

},{"ca7eebf8be1314ad":"hpx0h","21ecb85065719286":"fyJL2"}],"fahcO":[function(require,module,exports) {
module.exports = require("f47e9fd91fb339f2")(require("593e6213f9cb0719").resolve("hQARm")).then(()=>module.bundle.root("5DZPH"));

},{"f47e9fd91fb339f2":"hpx0h","593e6213f9cb0719":"fyJL2"}],"4fphA":[function(require,module,exports) {
module.exports = require("a22073a420ae26be")(require("6180dece980a49bd").resolve("4c16t")).then(()=>module.bundle.root("kxT6z"));

},{"a22073a420ae26be":"hpx0h","6180dece980a49bd":"fyJL2"}],"dipmP":[function(require,module,exports) {
module.exports = require("17a9f9d7bc7ea8b9")(require("92158b0a720491b4").resolve("2W8Qq")).then(()=>module.bundle.root("dF7ZY"));

},{"17a9f9d7bc7ea8b9":"hpx0h","92158b0a720491b4":"fyJL2"}],"9QXik":[function(require,module,exports) {
module.exports = require("6e468987ede8580")(require("3a6841d1b05e1cfc").resolve("gia0u")).then(()=>module.bundle.root("75GTL"));

},{"6e468987ede8580":"hpx0h","3a6841d1b05e1cfc":"fyJL2"}],"03fHo":[function(require,module,exports) {
module.exports = require("f15dbcb5cd1ee7d9")(require("d9fff254ae07007f").resolve("7v639")).then(()=>module.bundle.root("5EgzO"));

},{"f15dbcb5cd1ee7d9":"hpx0h","d9fff254ae07007f":"fyJL2"}],"1mGBB":[function(require,module,exports) {
module.exports = require("539b33738b6d8311")(require("46b7da085be7b8f6").resolve("OfjZN")).then(()=>module.bundle.root("BJ8kO"));

},{"539b33738b6d8311":"hpx0h","46b7da085be7b8f6":"fyJL2"}],"eiIRf":[function(require,module,exports) {
module.exports = require("2e1bd49a9e2d9387")(require("e0725d370ded4003").resolve("jNzC2")).then(()=>module.bundle.root("3UfyQ"));

},{"2e1bd49a9e2d9387":"hpx0h","e0725d370ded4003":"fyJL2"}],"dD3X6":[function(require,module,exports) {
module.exports = require("2a9d707d93c275fb")(require("b67cf5aa9f134c49").resolve("3UHWR")).then(()=>module.bundle.root("eq61v"));

},{"2a9d707d93c275fb":"hpx0h","b67cf5aa9f134c49":"fyJL2"}],"5CY5G":[function(require,module,exports) {
module.exports = require("d2c53b980fd1ea12")(require("ad994e9691d6bdf1").resolve("5JGOU")).then(()=>module.bundle.root("5Ae6d"));

},{"d2c53b980fd1ea12":"hpx0h","ad994e9691d6bdf1":"fyJL2"}],"e8eUp":[function(require,module,exports) {
module.exports = require("98604b90ca5a8247")(require("5f139f2af37a3fab").resolve("cqhLa")).then(()=>module.bundle.root("bfxrh"));

},{"98604b90ca5a8247":"hpx0h","5f139f2af37a3fab":"fyJL2"}],"f4kPj":[function(require,module,exports) {
module.exports = require("f4931021ec5e9edc")(require("c080589c71eadb8d").resolve("7cQwd")).then(()=>module.bundle.root("8MMWT"));

},{"f4931021ec5e9edc":"hpx0h","c080589c71eadb8d":"fyJL2"}],"5hAXt":[function(require,module,exports) {
module.exports = require("94d42fc7e4273a56")(require("9a39749322e67181").resolve("lEVfn")).then(()=>module.bundle.root("3Fu63"));

},{"94d42fc7e4273a56":"hpx0h","9a39749322e67181":"fyJL2"}],"04Atm":[function(require,module,exports) {
module.exports = require("d8dc7866bc44d651")(require("7f1c2ec077dc776c").resolve("dmlb4")).then(()=>module.bundle.root("iQt0J"));

},{"d8dc7866bc44d651":"hpx0h","7f1c2ec077dc776c":"fyJL2"}],"brsVh":[function(require,module,exports) {
module.exports = require("dab94c5f480b9ba9")(require("7662ecde9a33c23c").resolve("ajzeL")).then(()=>module.bundle.root("ke0vM"));

},{"dab94c5f480b9ba9":"hpx0h","7662ecde9a33c23c":"fyJL2"}],"l07GF":[function(require,module,exports) {
module.exports = require("aa48007f44e1f9cf")(require("c7c8b219c315c64c").resolve("3muPS")).then(()=>module.bundle.root("dyhU7"));

},{"aa48007f44e1f9cf":"hpx0h","c7c8b219c315c64c":"fyJL2"}],"dc5hV":[function(require,module,exports) {
module.exports = require("f03a45176795e21d")(require("4bbe76253daeda09").resolve("cTJLt")).then(()=>module.bundle.root("ihtxD"));

},{"f03a45176795e21d":"hpx0h","4bbe76253daeda09":"fyJL2"}],"bTq5d":[function(require,module,exports) {
module.exports = require("d654740881f02f1c")(require("8222000f4506661e").resolve("llb2B")).then(()=>module.bundle.root("3rcOX"));

},{"d654740881f02f1c":"hpx0h","8222000f4506661e":"fyJL2"}],"it3xb":[function(require,module,exports) {
module.exports = require("de40d8b31a44e006")(require("c62877e7848fa1c9").resolve("lKOLb")).then(()=>module.bundle.root("cZNhs"));

},{"de40d8b31a44e006":"hpx0h","c62877e7848fa1c9":"fyJL2"}],"5NfyA":[function(require,module,exports) {
module.exports = require("350106dbfbac4863")(require("72a9c53dd65ea7fb").resolve("5RqXX")).then(()=>module.bundle.root("hHh7x"));

},{"350106dbfbac4863":"hpx0h","72a9c53dd65ea7fb":"fyJL2"}],"4cJ95":[function(require,module,exports) {
module.exports = require("659724e38025d745")(require("beaff201f28c51df").resolve("QEpwI")).then(()=>module.bundle.root("91bnv"));

},{"659724e38025d745":"hpx0h","beaff201f28c51df":"fyJL2"}],"lAONF":[function(require,module,exports) {
module.exports = require("fe9d6565dfddbbb8")(require("f163939f61e181a1").resolve("ef0Jm")).then(()=>module.bundle.root("2MNVj"));

},{"fe9d6565dfddbbb8":"hpx0h","f163939f61e181a1":"fyJL2"}],"1W6z0":[function(require,module,exports) {
module.exports = require("f9d322798de72f11")(require("1f37df753036d3ae").resolve("de8wm")).then(()=>module.bundle.root("lOeMY"));

},{"f9d322798de72f11":"hpx0h","1f37df753036d3ae":"fyJL2"}],"6D5WW":[function(require,module,exports) {
module.exports = require("22d2f3cc04e055fa")(require("69da044074b78d86").resolve("7s5QD")).then(()=>module.bundle.root("8QgrV"));

},{"22d2f3cc04e055fa":"hpx0h","69da044074b78d86":"fyJL2"}],"b3N5W":[function(require,module,exports) {
module.exports = require("569bafc7c5a5823b")(require("339e796cc453ac56").resolve("91Lro")).then(()=>module.bundle.root("6cLxi"));

},{"569bafc7c5a5823b":"hpx0h","339e796cc453ac56":"fyJL2"}],"k95D2":[function(require,module,exports) {
module.exports = require("cf887bc12d2d02e0")(require("a7f538c621d91f80").resolve("ho7rd")).then(()=>module.bundle.root("fReZb"));

},{"cf887bc12d2d02e0":"hpx0h","a7f538c621d91f80":"fyJL2"}],"afemA":[function(require,module,exports) {
module.exports = require("128c529fea87dc36")(require("eb9eac47c533415").resolve("aZzFr")).then(()=>module.bundle.root("7gloV"));

},{"128c529fea87dc36":"hpx0h","eb9eac47c533415":"fyJL2"}],"eX6l3":[function(require,module,exports) {
module.exports = require("9d8c307cdaf8f7dc")(require("dcc977a96fac0a25").resolve("4SbtD")).then(()=>module.bundle.root("jyJwv"));

},{"9d8c307cdaf8f7dc":"hpx0h","dcc977a96fac0a25":"fyJL2"}],"idtxH":[function(require,module,exports) {
module.exports = require("f1c5140ebb3ced1e")(require("3a262dd2e94c6a87").resolve("f4SOf")).then(()=>module.bundle.root("6Pc33"));

},{"f1c5140ebb3ced1e":"hpx0h","3a262dd2e94c6a87":"fyJL2"}],"m1NRc":[function(require,module,exports) {
module.exports = require("b147c874bcbfcdb1")(require("e70a3d4a401d5952").resolve("hBDBK")).then(()=>module.bundle.root("ldVfF"));

},{"b147c874bcbfcdb1":"hpx0h","e70a3d4a401d5952":"fyJL2"}],"dJYr2":[function(require,module,exports) {
module.exports = require("2dd7a5720d76f5cd")(require("f418f4268a0e6aae").resolve("2o74t")).then(()=>module.bundle.root("aCipR"));

},{"2dd7a5720d76f5cd":"hpx0h","f418f4268a0e6aae":"fyJL2"}],"iDqEx":[function(require,module,exports) {
module.exports = require("f0069b02b755e16d")(require("f17ac925c5a90d2f").resolve("5ZRJS")).then(()=>module.bundle.root("6aGE0"));

},{"f0069b02b755e16d":"hpx0h","f17ac925c5a90d2f":"fyJL2"}],"8kiyi":[function(require,module,exports) {
module.exports = require("f73a01aa56c80c39")(require("d0878370ba68f678").resolve("8C1BM")).then(()=>module.bundle.root("5dYha"));

},{"f73a01aa56c80c39":"hpx0h","d0878370ba68f678":"fyJL2"}],"dLch8":[function(require,module,exports) {
module.exports = require("28f576ee498e1458")(require("8863317693ca8a96").resolve("9otOP")).then(()=>module.bundle.root("cx5ri"));

},{"28f576ee498e1458":"hpx0h","8863317693ca8a96":"fyJL2"}],"61bFV":[function(require,module,exports) {
module.exports = require("8235291a3ea928b8")(require("122c3bfbdc907fa0").resolve("CUJ9S")).then(()=>module.bundle.root("c4tci"));

},{"8235291a3ea928b8":"hpx0h","122c3bfbdc907fa0":"fyJL2"}],"dTU9H":[function(require,module,exports) {
module.exports = require("d2b516cb3c837cae")(require("7cf641f19fc738f0").resolve("7SGkM")).then(()=>module.bundle.root("f020E"));

},{"d2b516cb3c837cae":"hpx0h","7cf641f19fc738f0":"fyJL2"}],"bYeQK":[function(require,module,exports) {
module.exports = require("cc1d588288589599")(require("d5dc60b75e0a73a").resolve("3Eoqt")).then(()=>module.bundle.root("jAxlM"));

},{"cc1d588288589599":"hpx0h","d5dc60b75e0a73a":"fyJL2"}],"6svRp":[function(require,module,exports) {
module.exports = require("96c8b9ec29362d2d")(require("f9fdf2b643524324").resolve("dzqic")).then(()=>module.bundle.root("KsExq"));

},{"96c8b9ec29362d2d":"hpx0h","f9fdf2b643524324":"fyJL2"}]},["3sHWr","8RSWf"], "8RSWf", "parcelRequire819c")

//# sourceMappingURL=index.js.map
